import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import GridControl from '../components/Controls/gridControl.js';
import DispatchMainToolbar from '../components/Dispatch/DispatchMainToolbar.js';
import '../assets/Styles/DispatchCSS/DispatchCSS.css'; // Import Bootstrap CSS
import APICom from "../utils/helpers/APICom";
import CancelTrip from '../components/Dispatch/CancelTrip.js';
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Modal, Row, Form, Spinner, Button } from 'react-bootstrap';
import { mainstore } from "../store.js";
import MapControl from '../components/Controls/mapControl.js';
import MapControlDispatch from '../components/Controls/MapControlDispatch/MapControlDispatch.js'
import TripActions from '../components/Dispatch/TripActionsDialog.js';
import ActivateTrip from '../components/Dispatch/ActivateTrip.js';
import DriverActionsDialog from '../components/Dispatch/DriverActions/DriverActionsDialog.js';
import GroupingActions from '../components/Dispatch/GroupingAction.js';
import BuildCluster from '../components/Dispatch/BuildCluster.js';
import VehicleTracking from '../components/Dispatch/VehicleTracking.js';
import UpdateCallback from '../components/Dispatch/UpdateCallback.js';
import TripHistoryDialog from '../components/Dispatch/TripHistory/TripHistoryDialog.js';
import ConfirmationModal from '../components/Controls/ConfirmationModal.js';
import ARBResponseListener from '../components/Controls/ARBResponseListener.js';
import BrokerActionsDialog from '../components/Dispatch/BrokerActions/BrokerActionsDialog.js';
import AgileDispatch from '../components/Dispatch/AgileDispatch.js';
import * as XLSX from 'xlsx';
import saveIcon from "../assets/Images/CommonImages/save.png";
import clearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import refreshIcon from "../assets/Images/CommonImages/refresh.png";
import deSelectIcon from "../assets/Images/CommonImages/deselect.png";
import selectAllIcon from "../assets/Images/CommonImages/selectAll.png";
import collapseIcon from "../assets/Images/CommonImages/collapseGroup.png";
import expandIcon from "../assets/Images/CommonImages/expandGroup.png";
import infoIcon from "../assets/Images/CommonImages/info.png";
import AdjustTimes from "../assets/Images/CommonImages/adjustTimes.png";
import CommitTimes from "../assets/Images/CommonImages/commitTimes.png";
import TripDetailsDialog from '../components/Dispatch/TripDetailsDialog.js';
import MTDiagnostic from '../components/Dispatch/MTDiagnosticDialog.js'
import BuildManifest from '../components/Dispatch/BuildManifest.js';
import ShowRoutes from '../components/Dispatch/ShowRoutes.js';
import RBSProcess from '../components/Dispatch/RBSProcess.js';
import StandingRoutes from '../components/Dispatch/StandingRoutes.js';
import CommonFunctions from '../utils/helpers/CommonFunctions.js';
import ValidateIcon from "../assets/Images/CommonImages/validateIcon.png";
import AddBreakModal from '../components/Dispatch/AddBreak.js';
import AgentNotesDialog from '../components/Dispatch/AgentNotes/AgentNotesDialog.js';
import moment from 'moment';
import ModuleSecurity from '../utils/helpers/ModuleSecurity.js';
import { useNavigate } from "react-router-dom";
import PersistStorage from '../utils/helpers/PersistStorage.js';
import RunRouteSuggestion from "../components/Dispatch/RoutingActions/RunRouteSuggestion.js";
import isEqual from "lodash/isEqual";
import DateTimeUtils from '../utils/DateTimeUtility.js';
import { toast } from 'react-toastify';
import DispatchRouteSummary from '../components/DispatchRouteSummary.js';
import PrintManifestCriteria from '../Reports/CriteriaComponents/PrintManifestCriteria.js';
import UberTripEstimates from '../components/Uber/UberTripEstimates.js';
import LeftPane from '../components/LeftPane/LeftPane.js';
import ExternalDispatch from '../components/ExternalDispatch/ExternalDispatch.js';
import MultiTripCancellation from '../components/Dispatch/MultiTripCancellation.js';
import BrokerCancelDialog from '../components/Dispatch/BrokerCancelDialog.js';

export const FillBrokerCancelReasonsByObject = (BrokerCancelReasonData, iAffiliateID, iFSID) => {
    var tempHTML = "";
    var ObjectJSON = BrokerCancelReasonData;
    try {
        if (ObjectJSON != null && ObjectJSON !== "") {
            if (typeof ObjectJSON === "string") {
                ObjectJSON = JSON.parse(ObjectJSON);
            }
            let reasonDataStr = null;
            if (Array.isArray(ObjectJSON) && ObjectJSON.length > 0) {
                reasonDataStr = ObjectJSON[0][iAffiliateID];
            } else if (ObjectJSON && typeof ObjectJSON === "object") {
                reasonDataStr = ObjectJSON[iAffiliateID];
            }
            
            if (reasonDataStr) {
                let reasonsArray = JSON.parse(reasonDataStr);
                let filteredReasons = reasonsArray.filter(r => String(r.iFSID) === String(iFSID));
                filteredReasons.forEach(r => {
                    tempHTML += `<option value="${r.vReasonID}">${r.vReasonDesc}</option>`;
                });
            }
        }
    } catch (ex) { console.log(ex); }
    return tempHTML;
};

export const processBrokerCancellation = async (reasonCode, vBookingID, iATSPID, TripStatus, GlobalASCSData) => {
    try {
        let ascsSettings = GlobalASCSData ? GlobalASCSData : null;
        let thirdPartyApiUrlObj = ascsSettings?.find(item => item.SubTitle === "ThirdPartyTripsAPI_LocalURL" && item.Title === "ASCS");
        let baseUrl = thirdPartyApiUrlObj ? thirdPartyApiUrlObj.value : "";
        //baseUrl = "http://localhost:44331/api";
        if (!baseUrl) {
            return { success: false, message: "Third Party API URL is missing in Settings." };
        }

        baseUrl = baseUrl.replace(/\/$/, "");
        
        const apiUrl = `${baseUrl}/LogistiCare/SendLogisticareUpdateTripStatus`;
        const payload = {
            "iExtranalBrokerAffID": typeof iATSPID !== 'undefined' ? iATSPID.toString() : "-1",
            "vJobNo": typeof vBookingID !== 'undefined' ? vBookingID.toString() : "",
            "Lat": "0",
            "Long": "0",
            "VehID": "-1",
            "DrvID": "-1",
            "DrvPh": "000-000-0000",
            "CurrEstDistance": "0",
            "cost": "0",
            "vInloadTripStatus": TripStatus,
            "VIN": "",
            "reasonCode": typeof reasonCode !== 'undefined' ? reasonCode.toString() : "-1"
        };
        
        let response = await APICom.fetchData("full", apiUrl, "post", { "Content-Type": "application/json" }, payload, null);
        
        if (response && response.error == "" && response?.data !== "") {
            let isAllowedToCancel = false;
            let reason = "";
            let responseStr = typeof response === "string" ? response : JSON.stringify(response);
            
            try {
                let cancelResp = JSON.parse(response.data);
                
                if (cancelResp.Status === "APPROVED") {
                    isAllowedToCancel = true;
                } else if (cancelResp.Status === "DENIED") {
                    isAllowedToCancel = false;
                } else {
                    isAllowedToCancel = false;
                }
                reason = cancelResp.Reason || "";
            } catch (e) {
                if (responseStr.includes("APPROVED")) {
                    isAllowedToCancel = true;
                } else if (responseStr.includes("DENIED")) {
                    isAllowedToCancel = false;
                } else {
                    isAllowedToCancel = false;
                }
            }
            
            if (!isAllowedToCancel) {
                return { success: false, message: "Action Failed" + (reason ? ", " + reason : ".") };
            }
            
            let isLogisticareTrip = false;
            try {
                const pyPayload = {
                    "vBookingID": typeof vBookingID !== 'undefined' ? vBookingID.toString() : "",
                    "AffiliateID": typeof iATSPID !== 'undefined' ? parseInt(iATSPID) : -1
                };
                response = await APICom.fetchData("", "TripActions/DoesTripBelongToLogisticare", "post", { "Content-Type": "application/json" }, pyPayload, null); 
                let pyData = typeof response === "string" ? JSON.parse(response) : response;
                if (pyData && pyData?.data?.result === true) { 
                    isLogisticareTrip = true;
                }
            } catch (pyErr) {
                console.log("Error checking Logisticare Trip status:", pyErr);
            }

            if (isLogisticareTrip) {
                try {
                    const step2Url = `${baseUrl}/LogistiCare/RejectRide`;
                    const step2Payload = {
                        "iExtranalBrokerAffID": typeof iATSPID !== 'undefined' ? iATSPID.toString() : "-1",
                        "vBookingID": typeof vBookingID !== 'undefined' ? vBookingID.toString() : "",
                        "vStatus": TripStatus
                    };
                    
                    let resp = await APICom.fetchData("full", step2Url, "post", { "Content-Type": "application/json" }, step2Payload, null);
                    if(resp.error === ""){
                        return { success: true, message: "Action Success, Trip has been cancelled." };
                    }
                    else{
                        return { success: false, message: "Trip failed to cancel with exception " + resp.error };
                    }
                } catch (ex2) {
                    return { success: false, message: "Trip failed to cancel with exception " + ex2 };
                }
            } else {
                return { success: false, message: "Action Failed" };
            }
        } else {
             return { success: false, message: "No valid response from update trip status." };
        }
    } catch (err) {
        console.log("Error during broker cancellation:", err);
        return { success: false, message: "Action failed with exception " + err };
    }
};

const DispatchComponent = ({ sendAffToParent, gridRowData }) => {

    const [modalClassName, setModalClassName] = useState("");

    let CONTEXT_MENU_LABELS = {
        ExtnrlDispatch: "External Dispatch",
        CANCEL: "Cancel",
        ACTIVATE: "Activate",
        ASSIGN: "Assign",
        TRIP_ACTIONS: "Trip Actions",
        SEGMENTFARE: "Segment Fare", //(No Event Implementation)
        TRIP_HISTORY: "Trip History",
        TRIP_CLUSTER: "Cluster",
        TRIP_GROUP: "Group",
        TRIP_BROKER: "Broker",
        AGILE_DISPATCH: "Agile Dispatch",
        TRIP_MANIFEST: "Build Manifest",
        ADD_ROUTE: "Add to Route",
        ADD_CLUSTER: "Add to Cluster",
        TRIP_DETAILS: "Trip Information",
        UNROUTE: "UnRoute",
        UNASSIGN: "UnAssign",
        Rider_Notes: "Agent Notes",
        ROUTE_SUGGESTIONS: "Route Suggestions",
        MARK_WILLCALL: "Mark As WillCall",
        TRIP_EDIT: "Trip Edit",
        MARK_ROBOCALL: "Mark As Robocall",
        PRINT_MANIFEST: "Print Manifest",
    }
    let CONTEXT_MENU_LABELS_FOR_STOP_VIEW = {
        UNROUTE: "UnRoute",
        // ADJUSTROUTESTARTTIME: "Adj. Route StartTime",
        UPDATESCHEDULETIME: "Update Sch Time"
    }

    
    const [selectedRowFromRouteDropDown, setSelectedRowFromRouteDropDown] = useState("");

    const isCalledFromRouteDropDown = useRef(false);


    const deselectDispatchQRows = () => {
        try {
            if (DispatchGridControlRef) {
                let dispatchGridTable = DispatchGridControlRef.current.getCurrentGridData();
                if (dispatchGridTable){
                    let selectedRows = dispatchGridTable.getSelectedRows();
                    dispatchGridTable.deselectRow();
                }
            }
        } catch (error) {
            
        }
    }


    useEffect(() => {
        try {
            if(DispatchGridControlRef){
                let dispatchGridTable = DispatchGridControlRef.current.getCurrentGridData();
                if(dispatchGridTable){
                    let data = dispatchGridTable.getData();
                    let rowToBeSelected = data.find(p => p.Route == selectedRowFromRouteDropDown);
                    if(rowToBeSelected){
                        const rowComponent = dispatchGridTable.getRow(rowToBeSelected.ConfirmationNo);
                        if(rowComponent){
                            isCalledFromRouteDropDown.current = true;
                            //dispatchGridTable.deselectRow();
                            //rowComponent.select();
                            try {
                                const group = rowComponent.getGroup();
                                if (group && !group.isVisible()) {
                                    group.show(); // expands the group
                                }

                                rowComponent.scrollTo("middle", false);
                            } catch (error) {

                            }
                            setTimeout(() => {
                                rowComponent.select();
                                rowComponent._row.element.dispatchEvent(new MouseEvent("dblclick", { bubbles: true }));
                                setTimeout(() => {
                                    //rowComponent.select();
                                }, 100);
                            }, 200);

                        }
                    } 
                    else
                    {
                        setSelectedRoute("");
                        deselectDispatchQRows();
                        setClusterGridResponse([]);
                        let allRoutes = PersistStorage.retrieve("AllTodaysRoutes", true);
                        if (allRoutes && Array.isArray(allRoutes)) {
                            let routeData = allRoutes.find(r => r.vVirtualRoute === selectedRowFromRouteDropDown);
                            if (routeData) {
                                PersistStorage.save("AllTodaysRoutes", [], 9999, true);
                                CallGetRouteStopView(routeData);
                            }
                        }
                    }
                }

                async function CallGetRouteStopView(routeData) {
                    try {
                        
                        let resp = await GetRouteStopView(routeData.vManifestNumber, routeData.iAffiliateID, '', { fetchMode: 1, performed: true });
                        let result = resp.data;
                        if (!result || !result.data || result.data.length === 0) {
                            setClusterGridResponse([]);
                            return;
                        }
                        setSelectedRoute(routeData.vVirtualRoute);
                        setMapViewFromDoubleClick(true);
                        setMapView(true);
                        if (document.getElementById("tabulator_mapViewBtn") && document.getElementById("tabulator_mapViewBtn").textContent === "Map") {
                            try {
                                let filteredData = AffiliateData.filter(item => String(item.AffiliateID) === routeData.iAffiliateID.toString());
                                let iTransType = filteredData[0].iTransType;
                                if (iTransType !== 0) {
                                    setShowCompletedTrips(false);
                                    checkboxSelectionFlag.current = false;
                                }
                            } catch (error) {
    
                            }
                        }
                        handleRowResize(ClusterGridheight.current);
                        setShowGridClusterLoader(true);
                        setClusterGridResponse([]);
                        setclusterTableStateBeforeCompute(null);
                        setClusterGridResponse(result.data);
                        setClusterGridColumnSetting(result.setting);
                        routedTripShow.current = { "route": routeData.vVirtualRoute, "data": "" };
                        setShowGridClusterLoader(false);
                        setMapViewFromDoubleClick(true);
                        setMapView(true);
                    } catch (error) {
                        
                    }

                }

            }

        } catch (error) {

        }
    }, [selectedRowFromRouteDropDown])

    const [dispatchGridSelectedRow, setDispatchGridSelectedRow] = useState("");
    const [showPrintManifestCriteria, setShowPrintManifestCriteria] = useState(false);
    const [hideCostOnSDByFundingSource, setHideCostOnSDByFundingSource] = useState("-1");
    const [showExternalTripDispatch, setShowExternalTripDispatch] = useState(false);
    const [thirdPartyAffiliateToSelect, setThirdPartyAffiliateToSelect] = useState(-1);

    const tripType = useRef("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { StopViewBreakTrip } = useSelector((store) => store.ARB);
    const { SessionPersistData } = useSelector((store) => store.apicommunication);
    const { loginData } = useSelector((store) => store.login);
    const { GlobalASCSData, DispatchVehicleData, DispatchDriverData, ZoneVerticesData,
        DispatchGridColorsData, BrokerServingAffiliatesData, AttributeData, AffiliateData, ThirdPartyExternalAffiliatesData, BrokerCancelReasonData } = useSelector((store) => store.combinedata
        );
    const { ARBResponseForStopViewComputeEstimates, ARBResponseForStopViewValidate } = useSelector((store) => store.ARB);
    const [emailAlert, setShowEmailAlert] = useState("");
    const [sendEmailDict, setSendEmailDict] = useState({ showCustomerEmailRequest: false, customerTripData: {} });
    

    const SOQMenuSecurityMap = {
        "Trip Edit": "tag_d2_TripEdit",
        "Cancel": "tag_d2_TripCancel",
        "Show Multi-Sch": "tag_d2_m_TripAndBidHistory",
        "Send Email": "tag_d2_m_TripAndBidHistory",
        "Agent Notes": "tag_d2_AgentNotes",
        "Trip Information": "tag_d2_TripEdit",
        "Trip History": "tag_d2_m_TripAndBidHistory"
    };

    const standingOrderMenuItems = [
        {
            label: "Trip Edit",
            action: function (e, row) {
                try {
                    setShowCallTaker('Edit');
                }
                catch (err) { console.log(err); }
            },
        },
        { separator: true },
        {
            label: "Cancel",
            action: function (e, row) {
                try {
                    let rowData = row.getData();
                    let confirmation = rowData["Confirmation #"];
                    let name = rowData.PickupPerson;
                    setGivenDynamicModalSize('lg');
                    setModalHeaderText("Confirm Cancel");
                    setModalBodyHTML(<p>{"Request with confirmation # "}<b>{"'" + confirmation + "'"}</b>{" and pickup person "}
                        <b>{"'" + name + "'"}</b>{" is a "}<span className='text-danger fw-bold'>{"multi-schedule"}</span>{". Click 'Yes' to cancel the whole schedule."}</p>
                    );
                    setModalBtnHTML(
                        <>
                            <Button variant="dark" className="mx-1 border-0" onClick={() => { setShowDynamicModal(false); setShowCancel(true); setGivenDynamicModalSize(0); }}>
                                {"Yes"}
                            </Button>
                            <Button variant="secondary" className="mx-1 border-0" onClick={() => { setShowDynamicModal(false); setGivenDynamicModalSize(0); }}>
                                {"No"}
                            </Button>
                        </>
                    );
                    setShowDynamicModal(true);
                }
                catch (err) { console.log(err); }
            },
        },
        { separator: true },
        {
            label: "Show Multi-Sch",
            action: async function (e, row) {
                try {
                    let selectedRow = StandingOrderTableObj.current.getSelectedRows();
                    if (selectedRow && selectedRow.length === 1) {
                        let data = selectedRow[0].getData();
                        await ShowMultiSchData(data["Confirmation #"]);
                    }
                }
                catch (err) { console.log(err); }
            },
        },
        {
            label: "Send Email",
            action: function (e, row) {
                try {
                    let selectedRow = StandingOrderTableObj.current.getSelectedRows();
                    if(selectedRow) {
                        if (selectedRow.length > 1) {
                            setModalHeaderText("Email Receipt Alert");
                            setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                            setModalBtnHTML(
                                <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                    {"OK"}
                                </Button>
                            );
                            setShowDynamicModal(true);
                        }
                        else {
                            let data = selectedRow[0].getData();
                            setSendEmailDict({ showCustomerEmailRequest: true, customerTripData: data });
                        }
                    }
                }
                catch (err) { console.log(err); }
            },
        },
        {
            label: "Agent Notes",
            action: function (e, row) {
                try {
                    let selectedRow = StandingOrderTableObj.current.getSelectedRows();
                    if(selectedRow) {
                        if (selectedRow.length > 1) {
                            setModalHeaderText("Agent Notes Alert");
                            setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                            setModalBtnHTML(
                                <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                    {"OK"}
                                </Button>
                            );
                            setShowDynamicModal(true);
                        }
                        else {
                            setAgentNotesDialog(true);
                        }
                    }
                }
                catch (err) { console.log(err); }
            },
        },
        {
            label: "Trip Information",
            action: function (e, row) {
                let selectedRows = StandingOrderTableObj.current.getSelectedRows();
                if (selectedRows.length > 1) {
                    setModalHeaderText("Trip Information Alert");
                    setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else if (selectedRows.length === 1) {
                    PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
                    setTripDetailsDialog(true);
                }
            }
        },
        {
            label: "Trip History",
            action: function (e, row) {
                try {
                    let selectedRows = StandingOrderTableObj.current.getSelectedRows();
                    if(selectedRows) {
                        if (selectedRows.length > 1) {
                            setModalHeaderText("Trip Details Alert");
                            setModalBodyHTML(<p>{"You have selected "}<b>{selectedRows.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                            setModalBtnHTML(
                                <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                    {"OK"}
                                </Button>
                            );
                            setShowDynamicModal(true);
                        }
                        else {
                            setTripHistoryDialog(true);
                        }
                    }
                }
                catch (err) { console.log(err); }
            },
        },
    ];

    // const [standingOrderContextMenu, setSOContextMenu] = useState([
    //     {
    //         label: "Trip Edit",
    //         action: function (e, row) {
    //             try {
    //                 setShowCallTaker('Edit');
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    //     { separator: true },
    //     {
    //         label: "Cancel",
    //         action: function (e, row) {
    //             try {
    //                 let rowData = row.getData();
    //                 let confirmation = rowData["Confirmation #"];
    //                 let name = rowData.PickupPerson;
    //                 setGivenDynamicModalSize('lg');
    //                 setModalHeaderText("Confirm Cancel");
    //                 setModalBodyHTML(<p>{"Request with confirmation # "}<b>{"'" + confirmation + "'"}</b>{" and pickup person "}
    //                     <b>{"'" + name + "'"}</b>{" is a "}<span className='text-danger fw-bold'>{"multi-schedule"}</span>{". Click 'Yes' to cancel the whole schedule."}</p>
    //                 );
    //                 setModalBtnHTML(
    //                     <>
    //                         <Button variant="dark" className="mx-1 border-0" onClick={() => { setShowDynamicModal(false); setShowCancel(true); setGivenDynamicModalSize(0); }}>
    //                             {"Yes"}
    //                         </Button>
    //                         <Button variant="secondary" className="mx-1 border-0" onClick={() => { setShowDynamicModal(false); setGivenDynamicModalSize(0); }}>
    //                             {"No"}
    //                         </Button>
    //                     </>
    //                 );
    //                 setShowDynamicModal(true);
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    //     { separator: true },
    //     {
    //         label: "Show Multi-Sch",
    //         action: async function (e, row) {
    //             try {
    //                 let selectedRow = StandingOrderTableObj.current.getSelectedRows();
    //                 if (selectedRow && selectedRow.length === 1) {
    //                     let data = selectedRow[0].getData();
    //                     await ShowMultiSchData(data["Confirmation #"]);
    //                 }
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    //     {
    //         label: "Send Email",
    //         action: function (e, row) {
    //             try {
    //                 let selectedRow = StandingOrderTableObj.current.getSelectedRows();
    //                 if(selectedRow) {
    //                     if (selectedRow.length > 1) {
    //                         setModalHeaderText("Email Receipt Alert");
    //                         setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
    //                         setModalBtnHTML(
    //                             <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
    //                                 {"OK"}
    //                             </Button>
    //                         );
    //                         setShowDynamicModal(true);
    //                     }
    //                     else {
    //                         let data = selectedRow[0].getData();
    //                         setSendEmailDict({ showCustomerEmailRequest: true, customerTripData: data });
    //                     }
    //                 }
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    //     {
    //         label: "Agent Notes",
    //         action: function (e, row) {
    //             try {
    //                 let selectedRow = StandingOrderTableObj.current.getSelectedRows();
    //                 if(selectedRow) {
    //                     if (selectedRow.length > 1) {
    //                         setModalHeaderText("Agent Notes Alert");
    //                         setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
    //                         setModalBtnHTML(
    //                             <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
    //                                 {"OK"}
    //                             </Button>
    //                         );
    //                         setShowDynamicModal(true);
    //                     }
    //                     else {
    //                         setAgentNotesDialog(true);
    //                     }
    //                 }
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    //     {
    //         label: "Trip Information",
    //         action: function (e, row) {
    //             let selectedRows = StandingOrderTableObj.current.getSelectedRows();
    //             if (selectedRows.length > 1) {
    //                 setModalHeaderText("Trip Information Alert");
    //                 setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
    //                 setModalBtnHTML(
    //                     <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
    //                         {"OK"}
    //                     </Button>
    //                 );
    //                 setShowDynamicModal(true);
    //             }
    //             else if (selectedRows.length === 1) {
    //                 PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
    //                 setTripDetailsDialog(true);
    //             }
    //         }
    //     },
    //     {
    //         label: "Trip History",
    //         action: function (e, row) {
    //             try {
    //                 let selectedRows = StandingOrderTableObj.current.getSelectedRows();
    //                 if(selectedRows) {
    //                     if (selectedRows.length > 1) {
    //                         setModalHeaderText("Trip Details Alert");
    //                         setModalBodyHTML(<p>{"You have selected "}<b>{selectedRows.length}</b>{" trips, please select a single trip to perform this action."}</p>);
    //                         setModalBtnHTML(
    //                             <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
    //                                 {"OK"}
    //                             </Button>
    //                         );
    //                         setShowDynamicModal(true);
    //                     }
    //                     else {
    //                         setTripHistoryDialog(true);
    //                     }
    //                 }
    //             }
    //             catch (err) { console.log(err); }
    //         },
    //     },
    // ]);
    const [standingOrderContextMenu, setSOContextMenu] = useState(
        standingOrderMenuItems.filter(item => {
            const tag = SOQMenuSecurityMap[item.label];
            return !tag || ModuleSecurity.CheckModuleSecurityByTag(tag);
        })
    );


    const CompletedQMenuSecurityMap = {
        "Trip History": "tag_d2_m_TripAndBidHistory",
        "Driver Controls": "tag_d2_m_DriverControls",
        "Agent Notes": "tag_d2_AgentNotes",
        "Print Manifest": "tag_d2_PrintManifest"
    };
    const completedQueueMenuItems = [
        {
            label:"Trip History",
            action:function(e, row){
                try{
                    let selectedRows = completedTableObj.current.getSelectedRows();
                    if(selectedRows.length > 1)
                    {
                        setModalHeaderText("Trip History Alert");
                        setModalBodyHTML(<p>{"You have selected "}<b>{selectedRows.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                            {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }
                    else
                    {
                        setTripHistoryDialog(true);
                    }
                }
                catch(err){console.log(err);}
            },
        },
        {separator:true},    
        {
            label:"Driver Controls",
            action:function(e, row){
                try{
                    let selectedRows = completedTableObj.current.getSelectedRows();
                    setDriverActionsDialog(true);
                }
                catch(err){console.log(err);}
            },
        },
        {
            label:"Agent Notes",
            action:function(e, row){
                try{
                    let selectedRow = completedTableObj.current.getSelectedRows();
                    if(selectedRow.length > 1)
                    {
                        setModalHeaderText("Agent Notes Alert");
                        setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
                            {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }
                    else
                    {
                        setAgentNotesDialog(true);
                    }
                }
                catch(err){console.log(err);}
            },
        },
        {
            label: "Print Manifest",
            action: async function (e, row) {
                let selectedRow = completedTableObj.current.getSelectedRows();
                if (selectedRow.length <= 0) {
                    setModalHeaderText("Alert");
                    setModalBodyHTML(<p>{"Please selected a row to perform action"}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setHideCostOnSDByFundingSource(GlobalASCSData.find(dict => dict.SubTitle === "HideCostOnSDByFundingSource") ? GlobalASCSData.find(dict => dict.SubTitle === "HideCostOnSDByFundingSource").value : "-1");
                    setDispatchGridSelectedRow(selectedRow[0].getData());
                    setShowPrintManifestCriteria(true);
                }
            }
        },
    ];

    const [completedQueueContextMenu, setCQContextMenu] = useState(
        completedQueueMenuItems.filter(item => {
            const tag = CompletedQMenuSecurityMap[item.label];
            return !tag || ModuleSecurity.CheckModuleSecurityByTag(tag);
        })
    );

    // const [completedQueueContextMenu, setCQContextMenu] = useState([

    //     {
    //         label:"Trip History",
    //         action:function(e, row){
    //             try{
    //                 let selectedRows = completedTableObj.current.getSelectedRows();
    //                 if(selectedRows.length > 1)
    //                 {
    //                     setModalHeaderText("Trip History Alert");
    //                     setModalBodyHTML(<p>{"You have selected "}<b>{selectedRows.length}</b>{" trips, please select a single trip to perform this action."}</p>);
    //                     setModalBtnHTML(
    //                         <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
    //                         {"OK"}
    //                         </Button>
    //                     );
    //                     setShowDynamicModal(true);
    //                 }
    //                 else
    //                 {
    //                     setTripHistoryDialog(true);
    //                 }
    //             }
    //             catch(err){console.log(err);}
    //         },
    //     },
    //     {separator:true},    
    //     {
    //         label:"Driver Controls",
    //         action:function(e, row){
    //             try{
    //                 let selectedRows = completedTableObj.current.getSelectedRows();
    //                 setDriverActionsDialog(true);
    //             }
    //             catch(err){console.log(err);}
    //         },
    //     },
    //     {
    //         label:"Agent Notes",
    //         action:function(e, row){
    //             try{
    //                 let selectedRow = completedTableObj.current.getSelectedRows();
    //                 if(selectedRow.length > 1)
    //                 {
    //                     setModalHeaderText("Agent Notes Alert");
    //                     setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
    //                     setModalBtnHTML(
    //                         <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
    //                         {"OK"}
    //                         </Button>
    //                     );
    //                     setShowDynamicModal(true);
    //                 }
    //                 else
    //                 {
    //                     setAgentNotesDialog(true);
    //                 }
    //             }
    //             catch(err){console.log(err);}
    //         },
    //     },  
        
    // ]);
    // {
    //     label:"Copy Ride",
    //     action:function(e, row){
    //         try{
    //             setShowCallTaker('Copy');
    //         }
    //         catch(err){console.log(err);}
    //     },
    // },
    // {separator:true},  
    // {
    //     label:"Add ExtraInfo",
    //     action:function(e, row){
    //         try{
    //             let selectedRows = completedTableObj.current.getSelectedRows();
    //             setModalHeaderText("Upcoming Feature");
    //             setModalBodyHTML(<p><b>{"Add/Update Extra Info"}</b>{" is a work in progress and will be available in an upcoming release."}</p>);
    //             setModalBtnHTML(
    //                 <Button variant="dark" className="mx-1 border-0" onClick={()=>setShowDynamicModal(false)}>
    //                 {"OK"}
    //                 </Button>
    //             );
    //             setShowDynamicModal(true);
    //         }
    //         catch(err){console.log(err);}
    //     },
    // },
    
    const [givenDynamicModalSize, setGivenDynamicModalSize] = useState(0);
    const [numOfTripsInRoute, setNumTripsInRoute] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [handlePageProgressBar, sethandlePageProgressBar] = useState(null);
    const [gridMainType, setGridMainType] = useState('Dispatch');
    const [showAlert, setAlert] = useState(false);
    const [routeObj, setAlertObj] = useState({ alertTitle: '', alertMsg: '', displayFooter: true });
    const [showModal, setShowModal] = useState(false);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [DispatchScreenModalProps, setDispatchScreenModalProps] = useState({ "show": true, "Title": "", "Body": "", "btnCanceText": "", "btnOkText": "", "ShowCancelButton": false });
    const [DispatchGridResponse, setDispatchGridResponse] = useState({});
    const [ClusterGridResponse, setClusterGridResponse] = useState({});
    const [ClusterGridColumnSetting, setClusterGridColumnSetting] = useState({});
    const [StandingOrderGridColSetting, setSOGridColSetting] = useState([]);
    const [CompletedQueueColSetting, setCompletedQueueColSetting] = useState([]);
    const [showCancel, setShowCancel] = useState(false);
    const [showCallTaker, setShowCallTaker] = useState('None');
    const [mapView, setMapView] = useState(false);
    const [width, setWidth] = useState(100);
    const [showTripActionsDialog, setShowTripActionsDialog] = useState(false);
    const [showActivateDialog, setShowActivateDialog] = useState(false);
    // const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDriverActionsDialog, setDriverActionsDialog] = useState(false);
    const [showGroupingDialog, setShowGroupingActionDialog] = useState(false);
    const [showClusteringDialog, setShowClusterDialog] = useState(false);
    const [selectRowData, setSelectedRowData] = useState([]);
    const [selectRowDataForStopView, setSelectedRowDataForStopView] = useState([]);
    const [bCalledFromStopView, setbCalledFromStopView] = useState(false);
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [selectedManifest, setselectedManifest] = useState("");
    const [ShowGridClusterLoader, setShowGridClusterLoader] = useState(false);
    const [MapDetailData, setMapDetailData] = useState([]);
    const [SelectedStopsData, setSelectedStopsData] = useState([]);
    const [showColumnChooser, setShowColumnChooser] = useState(false);
    const [vehData, setVehData] = useState([]);
    const [assignedVehicleToTrip, setAssignedVehicleToTrip] = useState([]);
    const [apiRowData, setApiRowData] = useState([]);//DispatchGridColorsData[0]
    const [apiColData, setApiColData] = useState(DispatchGridColorsData[1]);
    const [apiAttributesColors, setApiAttributesColors] = useState(DispatchGridColorsData[2]);
    const [DynamicsStyles, setDynamicsStyles] = useState("");
    const [showVehicleTracking, setShowVehicleTracking] = useState(false);
    const [showUpdateCallback, setShowUpdateCallback] = useState(false);
    const [showTripHistoryDialog, setTripHistoryDialog] = useState(false);
    const [showBrokerActionsDialog, setBrokerActionsDialog] = useState(false);
    const [showAgileDispatch, setShowAgileDispatch] = useState(false);
    const [addTripToRoute, setAddTripToRoute] = useState(false);
    const [addTripToRouteCluster, setAddTripToRouteCluster] = useState(false);
    const [groupingHeaderFilter, setGroupingHeaderFilter] = useState("No Column Grouping");
    const [groupingHeaderFilterCompletedQ, setGroupingHeaderFilterCompletedQ] = useState("No Column Grouping");
    const [arbProgress, setarbProgress] = useState(100);
    const [route, setRoute] = useState("");
    const [tableSelRows, setTableRowsSel] = useState([]);
    const [showTripDetailsDialog, setTripDetailsDialog] = useState(false);
    const [showMTDiagnosticDialog, setMTDiagnosticDialog] = useState(false);
    const [SelectedRoute, setSelectedRoute] = useState("");
    const [showManifestBuildDialog, setManifestBuildDialog] = useState(false);
    const [showRBSProcessDialog, setRBSProcessDialog] = useState(false);
    const [showStandingRouteDialog, setStandingRouteDialog] = useState(false);
    const [showRoutesDialog, setShowRoutesDialog] = useState(false);
    const [arrangedClusterTrips, setArrangedClusterTrips] = useState([]);
    const [showClusterGridLoader, setClusterGridLoader] = useState(false);
    const [rowReArrangeCheck, setRowReArrangeCheck] = useState(false);
    const [showVehicleDispatch, setShowVehicleDispatch] = useState(true);
    const [showCompletedTrips, setShowCompletedTrips] = useState(true);
    const [showOccupiedVehicles, setShowOccupiedVehicles] = useState(false);
    const [nullifyActivated, setNullifyActivated] = useState(false);
    const [showAddBreakModal, setAddBreakModal] = useState(false);
    const [showEditRouteTimeModal, setEditRouteTimeModal] = useState(false);
    const [routeStartTime, setRouteStartTime] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [triggerUnAssign, setTriggerUnAssign] = useState(false);
    const [triggerUnRoute, setTriggerUnRoute] = useState(false);
    const [triggerRouteSuggestion, settriggerRouteSuggestion] = useState(false);
    const [violationColors, setViolationColors] = useState([{
        "capacity": "#FFA500", "timeWindow": "#C6B0F2", "RideTime": "#87CEEB",
        "maxMilesHours": "#BF8B19", "driverBreak": "#91F895",
        "uniqueStops": "#FA7AFC", "nonDrop": "#FF0000", "puLoopBack": "#F5CAA4", "WillCallTrip": "#B2B200", "TripStartTime": "#004d80",
        "MaxTrips": "#00ff3e", "invalidDOGPS": "#000dff", "maxRouteHrs": "#303030", "invalidPUGPS": "#05501e", "RideSharing": "#5d00ff"
    }
    ]);
    const [isResizing, setIsResizing] = useState(false);
    const [modalBodyHTML, setModalBodyHTML] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBtnHTML, setModalBtnHTML] = useState([]);
    const [clusterTripSelection, setClusterTripSelection] = useState({ Number: "", Type: "" });
    const [confirmationModalObj, setConfirmationModalObj] = useState({
        show: false, title: 'Manual Route Adjustment',
        body: 'Changes Saved Sucessfully', btnCancelText: 'No', btnOkText: 'Yes'
    });
    const [showAgentNotesDialog, setAgentNotesDialog] = useState(false);
    const [clusterTableStateBeforeCompute, setclusterTableStateBeforeCompute] = useState(null);
    const [force_assign, setforce_assign] = useState(false);
    const [showRouteActionCreate, setRouteActionCreate] = useState(false);
    const [isCreateNew, setIsCreateNew] = useState(true);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [showRouteAlert, setRouteAlert] = useState(false);
    const [disableAllButtons, setdisableAllButtons] = useState(false);
    const [showRouteSuggestionActionCreate, setRouteSuggestionActionCreate] = useState(false);
    const [rowMoveFlag, setRowMoveFlag] = useState(false);
    const [GridRefreshPaused, setGridRefreshPaused] = useState(false);
    const [MapViewFromDoubleClick, setMapViewFromDoubleClick] = useState(true);
 
    const [modalActionType, setModalActionType] = useState(null);
    const [StopViewSelectedRowIndex, setStopViewSelectedRowIndex] = useState(0);
    const [SelectedRowStopType, setSelectedRowStopType] = useState(0)
    const [validationError, setValidationError] = useState(false);
    const [errorMessageUST, setErrorMessageUST] = useState('');
    const [TimeTakenByLastGridCall, setTimeTakenByLastGridCall] = useState(0);
    const [NetworkTimeTakenByLastGridCall, setNetworkTimeTakenByLastGridCall] = useState(0);
    const [ToolboxValues, SetToolboxValues] = useState({
        Date: "", AffiliatesList: "", FSList: "", AttrList: "", StatusList: "", TotalHours: 24
    });
    const [height, setHeight] = useState(50);
    const [standingOrderGridData, setSOGridData] = useState([]);
    const [completedQueueData, setCompletedQueueData] = useState([]);
    const [completeDateRange, setCompleteDateRange] = useState({from: "", to: ""});
    const [showDispatcRouteSummary, setShowDispatcRouteSummary] = useState(false);

    const [sampleRoutes, setSampleRoutes] = useState([
        { routeName: "190-R1804_WC", routeStartTime: "08/12/2025 5:00AM", routeEndTime: "08/12/2025 10:30AM", noOfTrips: "20", driver: "test", vehicle: "8001", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1805_WC", routeStartTime: "08/12/2025 5:30AM", routeEndTime: "08/12/2025 11:30AM", noOfTrips: "25", driver: "test", vehicle: "8002", mobilityAttributes: "AMB: 20, W.C: 2"  },
        { routeName: "190-R1806_WC", routeStartTime: "08/12/2025 7:00AM", routeEndTime: "08/12/2025 9:00AM", noOfTrips: "5", driver: "test", vehicle: "8003", mobilityAttributes: "AMB: 20, W.C: 2"  },
        { routeName: "190-R1807_WC", routeStartTime: "08/12/2025 8:00AM", routeEndTime: "08/12/2025 2:30PM", noOfTrips: "10", driver: "test", vehicle: "8004", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1808_WC", routeStartTime: "08/12/2025 8:30AM", routeEndTime: "08/12/2025 3:00PM", noOfTrips: "30", driver: "test", vehicle: "8005", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1809_WC", routeStartTime: "08/12/2025 1:00PM", routeEndTime: "08/12/2025 5:00PM", noOfTrips: "8", driver: "test", vehicle: "8006", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1800_WC", routeStartTime: "08/12/2025 1:30PM", routeEndTime: "08/12/2025 5:00PM", noOfTrips: "15", driver: "test3", vehicle: "8007", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1820_WC", routeStartTime: "08/12/2025 2:30PM", routeEndTime: "08/12/2025 5:00PM", noOfTrips: "10", driver: "test", vehicle: "8008", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1825_WC", routeStartTime: "08/12/2025 3:00PM", routeEndTime: "08/12/2025 5:00PM", noOfTrips: "30", driver: "test", vehicle: "8009", mobilityAttributes: "AMB: 20, W.C: 2" },
        { routeName: "190-R1826_WC", routeStartTime: "08/12/2025 3:30PM", routeEndTime: "08/12/2025 5:00PM", noOfTrips: "5", driver: "test", vehicle: "8000", mobilityAttributes: "AMB: 20, W.C: 2" }
      ]);

    const toolboxRef = useRef({ Date: "", AffiliatesList: "", FSList: "", AttrList: "", StatusList: "", TotalHours: 24 });
    const isFirefox = useRef((typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1));
    const DispatchGridControlRef = useRef();
    const tableDispatchGridControlRef = useRef();
    const SOGridControlRef = useRef(null);
    const CompletedQueueControlRef = useRef(null);
    const ClusterGridheight = useRef(60);
    const xCancelSourceForGrid = useRef(null);
    const iDispatchRequestCountUnderProgress = useRef(0);
    const routedTripShow = useRef({ "route": "", "data": "" });
    const unroutedTripShow = useRef({ "unroutedTripConf": "", "data": "" });
    const RefSelectedDate = useRef();
    const ClusterTableObject = useRef(null);
    const DispatchTableObject = useRef(null);
    const mainTableObj = useRef(null);
    const StandingOrderTableObj = useRef(null);
    const completedTableObj = useRef(null);
    const mapViewCheck = useRef(null);
    const sidebarCheck = useRef(false);
    const manifestDataReceivedCheckRef = useRef(false);
    const selectedTripInfo = useRef(null);
    const selectedTripInfoToRefreshGrid = useRef(null);
    const DropDownRouteValue = useRef(null);
    const checkboxSelectionFlag = useRef(false);
    const groupingFilterCheck = useRef("No Column Grouping");
    const groupingFilterCheckCompletedQ = useRef("No Column Grouping");
    const _vManifestNumber = useRef(0);
    const _iAffilaiteID = useRef(0);
    const SelectedRowRefID = useRef('');
    const HistoryReason = useRef('');
    const ClusterGridSelectedRows = useRef([]);
    const ClusterGridSrollVertical = useRef(0);
    const ClusterGridDataResetComplete = useRef(false);
    const someThingChangedInGrid = useRef(true);
    const timerRef = useRef(null);
    const selectedRouteTimeout = useRef(null);
    const cellClickTimeout = useRef(null);
    const validateRouteTimeout = useRef(null);
    const stopViewBreakTrip_Internal_Timeout = useRef(null);
    const IsRoutedTrip = useRef(false);
    const [routedTrip, setIsRoutedTrip] = useState(false);
    const _iNoOfTripsInRoutes = useRef(0);
    const completeDateRangeRef = useRef({from: "", to: "", oldRange: ""});
    const IsShowOccupiedVehicles = useRef(false);
    const [showMultiTripCancellationDialog, setShowMultiTripCancellationDialog] = useState(false);
    const [showBrokerCancelDialog, setShowBrokerCancelDialog] = useState(false);
    const [brokerCancelReasonsHtml, setBrokerCancelReasonsHtml] = useState("");
    const [brokerCancelTripInfo, setBrokerCancelTripInfo] = useState(null);

    const handleBrokerCancelConfirmation = async (reasonCode, tripInfo) => {
        let vBookingID = tripInfo["PaymentExtention2"];
        let iATSPID = tripInfo["iSRATSPID"];
        let TripStatus = "CANCELLED";

        let result = await processBrokerCancellation(reasonCode, vBookingID, iATSPID, TripStatus, GlobalASCSData);

        setModalHeaderText(result.success && result.message !== "Action Failed" ? "Action Success" : "Broker Cancellation");
        setModalBodyHTML(<p>{result.message}</p>);
        setModalBtnHTML(<Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>OK</Button>);
        setShowDynamicModal(true);
        setShowBrokerCancelDialog(false);
    };



    const [manifestData, setManifestData] = useState([]);

    const selectedTripFromDispatchQueue = useRef();

    const [MainMapOpened, setIsMainMapOpened] = useState(false);
    useEffect(() => {

    }, [MainMapOpened])

    useEffect(() => {

        
        console.log(vehData);


    }, [vehData])

    const [isVehiclesVisible, setIsVehiclesVisible] = useState(false);

    const handleShowVehiclesChange = (newValue) => {
      setIsVehiclesVisible(newValue);
    };

    const handleShowOccupiedVehiclesChange = (newValue) => {
        IsShowOccupiedVehicles.current = newValue;
    };

    const handleShowCompletedTripChanges = (isEnabled) => {
        checkboxSelectionFlag.current = isEnabled;
        setShowCompletedTrips(isEnabled);
    }
    const handleShowVehicleDispatch = (isEnabled) => {
        setShowVehicleDispatch(isEnabled);
    }

    // Stop View Grid 
    let ContextMenuStopView = [
        // {
        //     label:CONTEXT_MENU_LABELS_FOR_STOP_VIEW.ADJUSTROUTESTARTTIME,
        //     action:function(e, row){
        //         setEditRouteTimeModal(true);
        //         setModalActionType('adjustRouteStartTime'); // Set action type
        //         let StopViewMainData = ClusterTableObject.current.getData()[0];
        //         setRouteStartTime (StopViewMainData.SchTime);
        //     }
        // },
        {
            label: CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UPDATESCHEDULETIME,
            action: function (e, row) {
                let allSelectedRows = ClusterTableObject.current.getSelectedRows();
                if (Array.isArray(allSelectedRows) && allSelectedRows.length > 1) {
                    setAlertObj({ ...routeObj, alertTitle: 'Update Schedule Time', alertMsg: 'Please select a single stop to update the schedule time.', displayFooter: true });
                    setAlert(true);
                    return; // Exit the function to prevent further execution
                }
                else {
                    let StopViewSelectedRow = row.getData(); // Get the selected row's data
                    let type = '';
                    const depotArr = ['StartDept', "EndDept", "SDepot", "EDepot"];
                    const alertMap = {
                        IDLE: {title: 'Update Schedule Time', msg: 'Updating schedule time is not allowed for idle stops.'},
                        DEPOT: {title: 'Update Schedule Time', msg: 'Updating schedule time is not allowed for depot stops.'},
                        BREAK: {title: 'Update Schedule Time', msg: 'Updating schedule time is not allowed for break stops.'},
                        PERFORMED: {title: 'Update Schedule Time', msg: 'Updating schedule time is not allowed for performed stops.'}
                    };
                    
                    if(StopViewSelectedRow.Type === "IdleTime"){
                        type = 'IDLE';
                    }
                    else if(depotArr.includes(StopViewSelectedRow.Type) || depotArr.includes(StopViewSelectedRow.PUPerson)){
                        type = 'DEPOT';
                    }
                    else if(StopViewSelectedRow.PUPerson === "BreakTrip"){
                        type = 'BREAK';
                    }
                    else if(StopViewSelectedRow.bPerformed) {
                        type = 'PERFORMED';
                    }
                    else{
                        type = 'N/A';
                    }

                    if(type !== 'N/A') {
                        setAlertObj({ ...routeObj, alertTitle: alertMap[type].title, alertMsg: alertMap[type].msg, displayFooter: true });
                        setAlert(true);
                        return; // Exit the function to prevent further execution
                    }
                    else {
                        setEditRouteTimeModal(true);
                        setModalActionType('updateScheduleTime'); // Set action type  
                        setStopViewSelectedRowIndex(StopViewSelectedRow.Index);
                        SelectedRowRefID.current = StopViewSelectedRow.TripNo;
                        setSelectedRowStopType(StopViewSelectedRow.Type);
                        setRouteStartTime(StopViewSelectedRow.SchTime);
                    }
                }
            }
        },
        {
            label: CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UNROUTE,
            action: async function (e, row) {
                let rowData = row.getData();
                let clusterComparisonTypeID = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '22', '23', '24'];
                let vManifestNumber = rowData.ManifestNumber;
                let CDFTypeID = rowData.ClusterTypeID;
                let PUPerson = rowData.PUPerson;
                let iAffiliateID = rowData.iAffiliateID;
                _vManifestNumber.current = vManifestNumber;
                _iAffilaiteID.current = iAffiliateID;

                if (PUPerson === 'BreakTrip') {
                    PerformReRouting(row);
                }
                else if (PUPerson !== 'SDepot' && PUPerson !== 'EDepot') {
                    // if (clusterComparisonTypeID.includes(CDFTypeID)) {
                    //     UnRouteActions();
                    // }
                    // else {
                    //     UnRouteActions();
                    // }
                    UnRouteActions();
                }
                else {
                    setConfirmationModalObj((prevState) => ({
                        ...prevState, show: true, title:
                            'UnRouting', body: 'Please Select the Service Trip!!!', btnCancelText: 'No', btnOkText: 'Ok'
                    }));
                }
            }
        },
    ];

    ContextMenuStopView = ContextMenuStopView.filter(item => {
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UNROUTE) {
            return false;
        }
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UPDATESCHEDULETIME) {
            return false;
        }
        return true;
    });

    //Main Dispatch Grid
    var ContextMenuArray = [
        {
            label: CONTEXT_MENU_LABELS.ExtnrlDispatch,
            action: async function (e, row) {
                try {
                    let showExternalDisaptch = await ExternalAffiliateValidation();
                    if(showExternalDisaptch === true){
                        setShowExternalTripDispatch(true);
                    }
                    else{
                        setShowExternalTripDispatch(false);
                        setModalHeaderText("Error: External Disaptch");
                        setModalBodyHTML(<p>{"Trip is assigned to a differnet affiliate."}</p>);
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }
                } catch (error) {
                    
                }
               
            }
        },
        {
            label: CONTEXT_MENU_LABELS.CANCEL,
            action: function (e, row) {
                try {
                    let selectedRows = mainTableObj.current.getSelectedRows().map(r => r.getData());
                    let hasBrokerTrip = false;
                    
                    if (selectedRows && selectedRows.length > 1) {
                        for (let i = 0; i < selectedRows.length; i++) {
                            let BrokerCancelReasons = FillBrokerCancelReasonsByObject(BrokerCancelReasonData, selectedRows[i]["iSRATSPID"], selectedRows[i]["iFundingSourceID"]);
                            let bkID = selectedRows[i]["PaymentExtention2"];
                            if (typeof bkID !== 'undefined' && bkID !== "" && BrokerCancelReasons !== "") {
                                hasBrokerTrip = true;
                                break;
                            }
                        }
                    }
                    
                    if (hasBrokerTrip) {
                        setModalHeaderText("Cancel Alert");
                        setModalBodyHTML(<p>{"Please select a single broker trip to continue."}</p>);
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                        return;
                    }

                    if (selectedRows.length > 1) {
                        setShowMultiTripCancellationDialog(true);
                        return;
                    }

                    let rowData = selectedRows.length === 1 ? selectedRows[0] : row.getData();
                    let vBookingID = rowData["PaymentExtention2"];
                    let iATSPID = rowData["iSRATSPID"];
                    let iFSID = rowData["iFundingSourceID"];
                    let BrokerCancelReasons = FillBrokerCancelReasonsByObject(BrokerCancelReasonData, iATSPID, iFSID);
                    
                    if (typeof (vBookingID) != 'undefined' && vBookingID != "" && BrokerCancelReasons != "") {
                        setBrokerCancelReasonsHtml(BrokerCancelReasons);
                        setBrokerCancelTripInfo(rowData);
                        setShowBrokerCancelDialog(true);
                    } else {
                        setShowMultiTripCancellationDialog(true);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            }
        },

        {
            label: CONTEXT_MENU_LABELS.ACTIVATE,
            action: function (e, row) {

                if(mainTableObj.current.getSelectedRows().length>1){
                setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: true}));

                }
                else{
                setShowActivateDialog(true);
                }
                // row.select();
            }
        },
        {
            separator: true,
        },
        {
            label: CONTEXT_MENU_LABELS.MARK_WILLCALL,
            action: function (e, row) {
                let rowData = row.getData();
                let selectedRow = mainTableObj.current.getSelectedRows();
                const willCallAlertMap = {
                    MULTIPLE: {title: "Trip Status Alert", msg: (<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to mark will call."}</p>)},
                    ROUTE: {title: "Trip Status Alert", msg: ("The trip is part of a route and cannot be marked as 'Will Call'. Please remove it from the route first, then mark it as 'Will Call'.")},
                    CONFIRM: {title: "Trip Status Alert", msg: ("Are you sure you want to mark trip#" + rowData.iRefID + " as 'Will Call'?")}
                };
                let type = '';
                if(selectedRow.length > 1) {
                    type = 'MULTIPLE';
                }
                else if(rowData.Route && rowData.Route !== "") {
                    type = 'ROUTE';
                }
                else {
                    type = 'CONFIRM';
                }
                let modalBtn = (
                    type !== 'CONFIRM' ? 
                    (
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    )
                    :
                    (
                        <>
                            <Button variant="dark" className="mx-1 border-0" onClick={(e) => { setShowDynamicModal(false); handleMarkAsWillCall(rowData, modalBtn); }}>
                                {"Yes"}
                            </Button>
                            <Button variant="secondary" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"No"}
                            </Button>
                        </>
                    )
                );
                setModalHeaderText((willCallAlertMap[type].title));
                setModalBodyHTML((willCallAlertMap[type].msg));
                setModalBtnHTML(modalBtn);
                setShowDynamicModal(true);
                
            }
        },
        {
            label: CONTEXT_MENU_LABELS.ASSIGN,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch");
                setShowTripActionsDialog(true);
                setGridRefreshPaused(true);
                // row.select();
            }
        },
        {
            label: CONTEXT_MENU_LABELS.UNASSIGN,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch");
                //Need to open assign and unassign automatically
                // console.log(row);
                setShowTripActionsDialog(true);
                setTriggerUnAssign(true);
                setGridRefreshPaused(true);
            }
        },
        {
            label: CONTEXT_MENU_LABELS.UNROUTE,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch")
                let rowData = row.getData();
                //Need to open manifest/cluster and unroute automatically
                let clusterComparisonTypeID = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '22', '23', '24'];
                let routeType = rowData.Route;
                let CDFTypeID = rowData.CDFTypeID;

                // console.log(routeType);
                if (clusterComparisonTypeID.includes(CDFTypeID)) {
                    setGridRefreshPaused(true);
                    setShowClusterDialog(true); 
                    setTriggerUnRoute(true);
                }
                else {
                    setGridRefreshPaused(true);
                    setManifestBuildDialog(true);
                    setTriggerUnRoute(true);
                }
            }
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_ACTIONS,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch");
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1 && false) {
                    setModalHeaderText("Trip Actions Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setShowTripActionsDialog(true);
                    setGridRefreshPaused(true);
                }
                // row.select();
            }
        },
        {
            separator: true,
        },
        {
            label: CONTEXT_MENU_LABELS.SEGMENTFARE,
            action: function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1) {
                    setModalHeaderText("Trip Details Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    //Any action for this option
                }
                // row.select();
            }
        },
        
        {
            label: CONTEXT_MENU_LABELS.MARK_ROBOCALL,
            action: async function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length <= 0) {
                    setModalHeaderText("Alert");
                    setModalBodyHTML(<p>{"Please selected atleast 1 Trip to perform Robo-Call"}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    await MarkAsRoboCall();
                }
            }
        },
        {
            separator: true,
        },

        {
            label: CONTEXT_MENU_LABELS.TRIP_HISTORY,
            action: function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1) {
                    setModalHeaderText("Trip History Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setTripHistoryDialog(true);
                }
                // row.select();
            }
        },
        {
            separator: true,
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_CLUSTER,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch");
                setGridRefreshPaused(true);
                setShowClusterDialog(true);
                // row.select();
            }
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_GROUP,
            action: function (e, row) {
                setShowGroupingActionDialog(true);
                // row.select();
            }
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_BROKER,
            action: function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                let rowData = row.getData();
                const filteredAffiliates = Array.isArray(BrokerServingAffiliatesData) ?
                    BrokerServingAffiliatesData.filter((aff) => String(aff.iBrokerAffiliateID) === String(rowData.iSRATSPID)) : [];

                const familyAffiliates = filterAffiliates(AffiliateData, row);

                if (filteredAffiliates?.length > 0) {
                    setBrokerActionsDialog(true);
                    setGridRefreshPaused(true);
                }
                else {
                    if (familyAffiliates?.length > 1) {
                        setBrokerActionsDialog(true);
                        setGridRefreshPaused(true);

                    }
                    else {
                        setAlertObj({ ...routeObj, alertTitle: 'Broker Action', alertMsg: 'Selected affiliate is not registered as a broker. Please contact your administrator.', displayFooter: true });
                        setAlert(true);
                        return;

                    }

                }
            }
        },
        {
            label: CONTEXT_MENU_LABELS.AGILE_DISPATCH,
            action: function (e, row) {
                // let rowInfo = row.getData();
                // if(rowInfo.ServiceStatus?.toUpperCase() === "DISPATCHED" || rowInfo.ServiceStatus?.toUpperCase() === "ASSIGNED" || rowInfo.ServiceStatus.toUpperCase() === "IRTPU" || rowInfo.ServiceStatus.toUpperCase() === "DROPPED" || rowInfo.ServiceStatus.toUpperCase() === "PICKEDUP" || rowInfo.ServiceStatus.toUpperCase() === "ATLOCATION")
                // {
                //     let manageRouteFooterBtns = ["OK"];
                //     let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                //         return(
                //             <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={()=>setShowDynamicModal(false)}>
                //                 {item}
                //             </Button>
                //         );
                //     });
                //     setModalHeaderText("Agile Dispatch Action Alert");
                //     setModalBodyHTML("Trip is not qualifying for the Agile Dispatch, it is already Dispatched.");
                //     setModalBtnHTML(manageRouteFooterHTML);
                //     setShowDynamicModal(true);
                // }
                // else
                // {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1) {
                    setModalHeaderText("Agile Dispatch Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setShowAgileDispatch(true);
                }
                // }
                // row.select();
            }
        },

        {
            label: CONTEXT_MENU_LABELS.TRIP_MANIFEST,
            action: function (e, row) {
                sethandlePageProgressBar("dispatch");
                setGridRefreshPaused(true);
                setManifestBuildDialog(true);
            }
        },
        {
            label: CONTEXT_MENU_LABELS.ADD_ROUTE,
            action: function (e, row) {

                try {
                    sethandlePageProgressBar("dispatch")
                    if (mapViewCheck.current) {
                        const clusterRowData = ClusterTableObject.current.getData()[0];
                        if (ClusterTableObject.current !== null && clusterRowData.Route !== "") {
                            function areAllRoutesEmpty(arr) {
                                return arr.every(dict => dict.Route === '');
                            }
                            let selectedRow = mainTableObj.current.getSelectedRows();
                            let tempRows = [];
                            for (let k in selectedRow) {
                                tempRows.push(selectedRow[k].getData());
                            }

                            const allUnroutedTripsFlag = areAllRoutesEmpty(tempRows);
                            
                            let clusterData = clusterRowData.ManifestNumber;
                            let ClusterTypeID = clusterRowData.ClusterTypeID;
                            let clusterComparisonTypeID = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '22', '23', '24'];
                            if (allUnroutedTripsFlag) {
                                // console.log(clusterData);
                                if (clusterComparisonTypeID.includes(ClusterTypeID)) {
                                    setRoute(clusterData);
                                    setAddTripToRouteCluster(true);
                                    setGridRefreshPaused(true);
                                    setShowClusterDialog(true);
                                }
                                else {
                                    setRoute(clusterData);
                                    setAddTripToRoute(true);
                                    setGridRefreshPaused(true);
                                    setManifestBuildDialog(true);
                                }

                            }
                            else {
                                let manageRouteFooterBtns = ["OK"];
                                let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                                    return (
                                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                                            {item}
                                        </Button>
                                    );
                                });
                                setModalHeaderText("Add to Route Alert");
                                setModalBodyHTML("Please click on an un-routed trip.");
                                setModalBtnHTML(manageRouteFooterHTML);
                                setShowDynamicModal(true);
                            }

                        }
                        else {
                            setRoute(SelectedRoute);
                            setAddTripToRoute(true);
                            setGridRefreshPaused(true);
                            setManifestBuildDialog(true);

                        }
                    }
                    else {

                        setRoute(SelectedRoute);
                        setAddTripToRoute(true);
                        setGridRefreshPaused(true);
                        setManifestBuildDialog(true);

                    }
                }
                catch (err) { console.log(err); }
            }
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_EDIT,
            action: function (e, row) {
                try {
                    setShowCallTaker('Edit');
                }
                catch (err) { console.log(err); }
            },
        },
        {
            label: CONTEXT_MENU_LABELS.TRIP_DETAILS,
            action: function (e, row) {
                let selectedRows = mainTableObj.current.getSelectedRows();
                if (selectedRows.length > 1) {
                    setModalHeaderText("Trip Information Alert");
                    setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else if (selectedRows.length === 1) {
                    PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
                    setTripDetailsDialog(true);
                }
            }
        },
        {
            label: CONTEXT_MENU_LABELS.Rider_Notes,
            action: function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1) {
                    setModalHeaderText("Agent Notes Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setAgentNotesDialog(true);
                }
                // row.select();
            }
        },
        {
            label: CONTEXT_MENU_LABELS.ROUTE_SUGGESTIONS,
            action: function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length > 1) {
                    setModalHeaderText("Route Suggestion Alert");
                    setModalBodyHTML(<p>{"You have selected "}<b>{selectedRow.length}</b>{" trips, please select a single trip to perform this action."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    sethandlePageProgressBar("dispatch");
                    const rowData = row.getData();
                    let slectedrowsdata = DispatchTableObject.current;
                    let routename = rowData.Route;

                    if (slectedrowsdata?.length > 1) {
                        setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Route Suggestion', body: 'Please select single unrouted trip.', btnCancelText: 'No', btnOkText: 'Ok' }));

                    }
                    else if (slectedrowsdata?.length === 1 && slectedrowsdata[0]?.SchDetailID > -1) {
                        setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Route Suggestion', body: 'The selected trip is a multi-schedule trip. Please choose a different trip.', btnCancelText: 'No', btnOkText: 'Ok' }));

                    }
                    else if (slectedrowsdata?.length === 1 && slectedrowsdata[0]?.PickupTime === "Will Call") {
                        setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Route Suggestion', body: 'The selected trip is a will call trip. Please choose a different trip.', btnCancelText: 'No', btnOkText: 'Ok' }));

                    }
                    else {
                        const allowedStatuses = ["pickedup", "cancelled", "atlocation","irtpu"];
                        if (!allowedStatuses.includes(rowData?.TripRequestStatus?.toLowerCase())) {
                            PersistStorage.save("selectedDate", RefSelectedDate.current, 999, false);
                            PersistStorage.save("AffiliateID", rowData.PrimaryAffiliateID, 999, false);
                            PersistStorage.save("ARBSelectedOption", 'RouteSuggestion', 999, false);
                            setGridRefreshPaused(true);
                            setRouteSuggestionActionCreate(true);
                        }
                        else{
                                                    const statusText =
                        slectedrowsdata?.[0]?.TripRequestStatus?.toUpperCase() ??
                        rowData?.TripRequestStatus?.toUpperCase() ??
                        "UNKNOWN";

                        setConfirmationModalObj(prev => ({
                        ...prev,
                        show: true,
                        title: "Route Suggestion",
                        body: `Selected trip is ${statusText}`,
                        btnCancelText: "No",
                        btnOkText: "Ok",
                        }));
                            //setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Route Suggestion', body: 'Selected trip is '+ slectedrowsdata[0]?.TripRequestStatus?.toUpperCase(), btnCancelText: 'No', btnOkText: 'Ok' }));
                        }
                    }
                }
            }
        },
        {
            label: CONTEXT_MENU_LABELS.PRINT_MANIFEST,
            action: async function (e, row) {
                let selectedRow = mainTableObj.current.getSelectedRows();
                if (selectedRow.length <= 0) {
                    setModalHeaderText("Alert");
                    setModalBodyHTML(<p>{"Please selected a row to perform action"}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
                else {
                    setHideCostOnSDByFundingSource(GlobalASCSData.find(dict => dict.SubTitle === "HideCostOnSDByFundingSource") ? GlobalASCSData.find(dict => dict.SubTitle === "HideCostOnSDByFundingSource").value : "-1");
                    setDispatchGridSelectedRow(selectedRow[0].getData());
                    setShowPrintManifestCriteria(true);
                }
            }
        },
        //{
        //    label: CONTEXT_MENU_LABELS.ROUTE_DETIALS,
        //    action: function (e, row) {
        //        setShowDispatcRouteSummary(true);
            
        //    }
        //}
    ];

        
    var MasterDispatchContextMenu = ContextMenuArray;
    ContextMenuArray = ContextMenuArray.filter(item => {
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripCancel") && item.label === CONTEXT_MENU_LABELS.CANCEL) {
            return false;
        }
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgileDispatch") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH) {
            return false;
        }
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ExternalDispatch") && item.label === CONTEXT_MENU_LABELS.ExtnrlDispatch) {
            return false;
        }
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripActivate") && item.label === CONTEXT_MENU_LABELS.ACTIVATE) {
            return false;
        }

        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripAssignDispatch") && item.label === CONTEXT_MENU_LABELS.ASSIGN) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_TripActions") && item.label === CONTEXT_MENU_LABELS.TRIP_ACTIONS) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_SegmentFare") && item.label === CONTEXT_MENU_LABELS.SEGMENTFARE) {// pending
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_TripAndBidHistory") && item.label === CONTEXT_MENU_LABELS.TRIP_HISTORY) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_ClusteringActions") && item.label === CONTEXT_MENU_LABELS.TRIP_CLUSTER) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_GroupingActions") && item.label === CONTEXT_MENU_LABELS.TRIP_GROUP) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_BrokerActions") && item.label === CONTEXT_MENU_LABELS.TRIP_BROKER) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgileDispatch") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS.TRIP_MANIFEST) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS.ADD_ROUTE) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_ClusteringActions") && item.label === CONTEXT_MENU_LABELS.ADD_CLUSTER) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS.TRIP_DETAILS) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS.UNROUTE) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripAssignDispatch") && item.label === CONTEXT_MENU_LABELS.UNASSIGN) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgentNotes") && item.label === CONTEXT_MENU_LABELS.Rider_Notes) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteSuggestions") && item.label === CONTEXT_MENU_LABELS.ROUTE_SUGGESTIONS) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripMarkAsWillCall") && item.label === CONTEXT_MENU_LABELS.MARK_WILLCALL) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS.TRIP_EDIT) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_MarkAsRoboCall") && item.label === CONTEXT_MENU_LABELS.MARK_ROBOCALL) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_PrintManifest") && item.label === CONTEXT_MENU_LABELS.PRINT_MANIFEST) {
            return false;
        }

        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UNROUTE) {
            return false;
        }
        
        if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UPDATESCHEDULETIME) {
            return false;
        }
        
        
        return true;
    });
    //ContextMenuArray = ContextMenuArray?.filter(item => {
        // if (!ModuleSecurity?.CheckModuleSecurityByTag("tag_CancelRequest") && item.label === CONTEXT_MENU_LABELS.CANCEL) {
        //     return false;
        // }
        // if (!ModuleSecurity?.CheckModuleSecurityByTag("tag_DispatchActions") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH) {
        //     return false;
        // }
        // if (!ModuleSecurity?.CheckModuleSecurityByTag("tag_DispatchActions") && item.label === CONTEXT_MENU_LABELS.TRIP_CLUSTER) {
        //     return false;
        // }
        // if (!ModuleSecurity?.CheckModuleSecurityByTag("tag_DispatchActions") && item.label === CONTEXT_MENU_LABELS.ADD_CLUSTER) {
        //     return false;
        // }


    //return true;
    //});
    
    
    const ExternalAffiliateValidation = async () => {
        try {
            /// Only works for single selection
            
            const ReqAffiliateID = mainTableObj.current.getSelectedRows()[0].getData().RequestAffiliateID;
            const PrmyAffiliateID = mainTableObj.current.getSelectedRows()[0].getData().PrimaryAffiliateID;
            const RefId = mainTableObj.current.getSelectedRows()[0].getData().iRefID;
            const CallBackInfo = mainTableObj.current.getSelectedRows()[0].getData().CallbackInfo;
            
            const externalAffiliates = Array.isArray(ThirdPartyExternalAffiliatesData) ?
            ThirdPartyExternalAffiliatesData.filter((aff) => String(aff.AffiliateID) === String(mainTableObj.current.getSelectedRows()[0].getData().RequestAffiliateID)) : [];

            //setThirdPartyAffiliateToSelect
            if(ReqAffiliateID != undefined && PrmyAffiliateID != undefined && ReqAffiliateID != "" && PrmyAffiliateID != "" && externalAffiliates != []){
                if(ReqAffiliateID != PrmyAffiliateID){
                    // That means request is already assigned to a different affiliate.
                    // pass that RequestAffiliateID to External Dispatch
                   
                    setThirdPartyAffiliateToSelect(parseInt(ReqAffiliateID));
                }
                else if(ReqAffiliateID === PrmyAffiliateID)
                {
                    setThirdPartyAffiliateToSelect(-1);
                }
                return true;
            }
            else if(externalAffiliates?.length == 0 && ThirdPartyExternalAffiliatesData?.length > 0){
                return false;
            }
            return false;

        } catch (error) {
            setThirdPartyAffiliateToSelect(-1);
            return false;            
        }
    }



    const [DispatchGridControlOptions, SetDispatchGridControlOptions] = useState(() => getDispatchGridControlOptions());
    const [ClusterGridControlOptions, SetClusterGridControlOptions] = useState(() => getClusterGridControlOptions());
    const [StandingOrderGridControlOptions, SetStandingOrderGridControlOptions] = useState({
        height: 'auto',
        heightoffset: 132,
        calculateHeight: true,
        pagination: true,
        paginationMode: "local",
        paginationSize: 1000,
        paginationSizeSelector: [100, 300, 500, 1000, 5000],
        selectable: true,
        reactiveData: true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder: "No Trips Available",
        clipboard: true,
        mapHeight: "auto",
        selectableRangeMode: "click",
        GridName: "standingOrder",
        paginationCounter: "rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") ? GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value * 2000 : 6000,
        index: "Confirmation #",
        movableColumns: true,
        movableRows: false,
        vDefaultGridName: "StandingOrderGrid",
        bSysUser: 1,
        intervalEnable: false,
        persistence: true,
        bWebApplySettingToAll: false,
        mapClass: "col-6 d-inline-flex",
        ID_Column: "Index",
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns: [""],
        mapView: mapView,
        contextMenuSetting: standingOrderContextMenu,
        selectedRoute: SelectedRoute,
        saveCCSettingsOption: true,
        containerClass: "col",
        Containerstyle: {},
        frozenState: false,
        sortCondition: true,
        tableDoubleClickFunc: function (table, row) {
            try{
                table.deselectRow();
                row.select();
                let rowData = row.getData();
                setTableRowsSel(rowData.id);
    
                DropDownRouteValue.current = null;
    
                setMapViewFromDoubleClick(true)
                setMapView(true);
                if (document.getElementById("standingOrder_mapViewBtn") && document.getElementById("standingOrder_mapViewBtn").textContent === 'Map')
                    document.getElementById("standingOrder_mapViewBtn").click();
    
                // someThingChangedInGrid.current = true;
                // selectedTripInfo.current = rowData;
                // selectedTripInfoToRefreshGrid.current = rowData; 
                unroutedTripShow.current = { "unroutedTripConf": rowData["Confirmation #"], "data": rowData };
            } catch(err){console.log(err);}
        },
        footerElement: '<button class="tabulator_btns raised-button border border-dark " title="Export To Excel" id="'
            + "standingOrder" + '_ExportToExcel"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
            + "standingOrder" + '_ClearFilter" title="Clear Filters" id="' + "standingOrder" + '_ClearFilter"></button><button class="tabulator_btns lastTabulator-btn raised-button border border-dark " title="Reload Data" id="'
            + "standingOrder" + '_RefreshData"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
            + "standingOrder" + '_DeSelectAll" title="Deselect Selected" id="' + "standingOrder" + '_DeSelectAll"></button> '
            + '<span class="middleTabulator-btns me-1 fw-bold '
            + "standingOrder" + '_recordSelected" id="' + "standingOrder" + '_selectedRecords" style="font-size:small"></span>',
        footerElementHandles: function (table) {
            StandingOrderTableObj.current = table;
            var img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = saveIcon;
            document.getElementById("standingOrder_ExportToExcel").appendChild(img);
            img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = clearFilterIcon;
            document.getElementById("standingOrder_ClearFilter").appendChild(img);
            // img = document.createElement("img");
            // img.style.cssText = "width:16px; height:16px";
            // img.src = selectAllIcon;
            // document.getElementById("standingOrder_SelectAll").appendChild(img);
            img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = deSelectIcon;
            document.getElementById("standingOrder_DeSelectAll").appendChild(img);
            img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.src = refreshIcon;
            document.getElementById("standingOrder_RefreshData").appendChild(img);

            if (document.getElementById('standingOrder_selectedRecords').innerHTML === "") {
                document.getElementById('standingOrder_selectedRecords').innerHTML = "[No Trips Selected]";
            }
            //select row on "select all" button click
            // document.getElementById('standingOrder_SelectAll').addEventListener("click", function () {
            //     table.selectRow();
            // });
            //deselect row on "deselect all" button click
            document.getElementById('standingOrder_DeSelectAll').addEventListener("click", function () {
                table.deselectRow();
            });
            document.getElementById('standingOrder_RefreshData').addEventListener("click", async function () {
                await PrepareStandingOrderRequest();
            });
            document.getElementById("standingOrder_ExportToExcel").addEventListener("click", function () {
                
                if (table != undefined) {
                    const data = table.getData('active');
                    const columnsToIgnore = ['id'];
                    const visibleColumns = table.getColumns()
                    .filter(col => col.isVisible())
                    .map(col => col.getField())
                    .filter(field => field && !columnsToIgnore.includes(field));
            
                    const filteredData = data.map(row => {
                        const filteredRow = {};
                        visibleColumns.forEach(field => {
                            filteredRow[field] = row[field];
                        });
                        return filteredRow;
                    });
            
                    const sheet = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                    XLSX.writeFile(wb, "StandingOrder_Table_Data.xlsx");
                }

            });
            document.getElementById('standingOrder_ClearFilter').addEventListener("click", function () {
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: function (data) {
            if (data.length === 0) {
                document.getElementById('standingOrder_selectedRecords').innerHTML = "[No Trips Selected]";
            }
            else if(data.length > 0)
            {
                document.getElementById('standingOrder_selectedRecords').innerHTML = "["+data.length+" Trip"+(data.length === 1 ? '':'s')+" Selected]";
                if(document.getElementById("standingOrder_mapViewBtn") && document.getElementById("standingOrder_mapViewBtn").textContent === 'Hide Map')
                {
                    unroutedTripShow.current = {"unroutedTripConf": data[0]["Confirmation #"], "data":data[0]};
                }
            }
        },
    });
    const [CompletedGridControlOptions, SetCompletedGridControlOptions] = useState({
        height: 'auto',
        heightoffset: 132,
        calculateHeight: true,
        pagination: true,
        paginationMode: "local",
        paginationSize: 1000,
        paginationSizeSelector: [100, 300, 500, 1000, 5000],
        selectable: true,
        reactiveData:true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Trips Available",
        clipboard: true,
        mapHeight: "auto",
        selectableRangeMode: "click",
        GridName:"completedQueue",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01")? GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value * 2000 : 6000,
        index: "Confirmation #",
        movableColumns:true,
        movableRows: false,
        vDefaultGridName: "CompletedGrid",
        bSysUser: 1,
        intervalEnable: false,
        persistence:true,
        bWebApplySettingToAll: false,
        mapClass: "col-6 d-inline-flex",
        ID_Column: "Index",
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:[""],
        GeneralArrayForHTML: ["Attribute"],
        mapView: mapView,
        contextMenuSetting: completedQueueContextMenu,
        selectedRoute:SelectedRoute,
        saveCCSettingsOption: true,
        containerClass: "col",
        Containerstyle: {},
        frozenState: false,
        sortCondition: true,
        groupByColumns: [],
        GridGroupedColumns: ["No Column Grouping", "Group", "vAttributes", "vAssignedAttributes", "Funding Source", "ManifestNo", "PZONE", "DZONE", "VEH#", "AssignedDriver#", "DispatchedBy"],
        tableDoubleClickFunc: async function (table, row) {
            try{
                table.deselectRow();
                row.select();
                let rowData = row.getData();
                setTableRowsSel(rowData.id);

                DropDownRouteValue.current = null;
                let selectedrowRoute = rowData.ManifestNo;
                setMapViewFromDoubleClick(true)
                setMapView(true);
                if(document.getElementById("completedQueue_mapViewBtn") && document.getElementById("completedQueue_mapViewBtn").textContent === 'Map')
                    document.getElementById("completedQueue_mapViewBtn").click();  
                
                if (selectedrowRoute && selectedrowRoute !== "") {
                    // selectedTripInfo.current = rowData;
                    // selectedTripInfoToRefreshGrid.current = rowData;
                    if(rowData.ManifestNo && rowData.ManifestNo !== "")
                        await handleClusterManifestData(rowData, true, 'complete');
                }
                else {
                    handleRowResize(100);
                    setVehData([]);
                    setClusterGridResponse({});
                    setClusterGridColumnSetting({});
                    routedTripShow.current = { "route": "", "data": "" };
                    unroutedTripShow.current = {"unroutedTripConf": rowData["Confirmation #"], "data":rowData};
                }
                // someThingChangedInGrid.current = true;
                // selectedTripInfo.current = rowData;
                // selectedTripInfoToRefreshGrid.current = rowData; 
            }catch(err){console.log(err);}
        },
        footerElement : '<button class="tabulator_btns raised-button border border-dark " title="Export To Excel" id="'
            +"completedQueue"+'_ExportToExcel"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
            +"completedQueue"+'_ClearFilter" title="Clear Filters" id="'+"completedQueue"+'_ClearFilter"></button><button class="tabulator_btns lastTabulator-btn raised-button border border-dark " title="Reload Data" id="'
            +"completedQueue"+'_RefreshData"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
            +"completedQueue"+'_DeSelectAll" title="Deselect Selected" id="'+"completedQueue"+'_DeSelectAll"></button> '
            + ' <div class="tabulator_group_' + "tabulator" + '"><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
            +   "tabulator" + '_ExpandCollapse" title="Collapse Grouped Trips" id="' + "completedQueue" + '_ExpandCollapse"></button>'
            +   '<select class="tabulator_btns gridgroupedcols DropdownArrow raised-button border border-dark " id="gridgroupedcolstabulator" style="cursor:pointer; width:auto; margin-left:-2px;">'
            +   '</select><button class="tabulator_btns middleTabulator-btns raised-button border border-dark" style="display:none;" '
            +   "tabulatorSaveSettings" + '" title="Collapse Grouped Trips" id="tabulatorSaveSettings">Save Grid Settings</button></div>'
            +'<span class="middleTabulator-btns me-1 fw-bold '
            +"completedQueue"+'_recordSelected" id="'+"completedQueue"+'_selectedRecords" style="font-size:small"></span>',
        footerElementHandles: function (table) {
            completedTableObj.current = table;
            let img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = saveIcon;
                document.getElementById("completedQueue_ExportToExcel").appendChild(img);
            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = clearFilterIcon;
                document.getElementById("completedQueue_ClearFilter").appendChild(img);
            // img = document.createElement("img");
            //     img.style.cssText = "width:16px; height:16px"; 
            //     img.src = selectAllIcon;
            //     document.getElementById("completedQueue_SelectAll").appendChild(img);
            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = deSelectIcon;
                document.getElementById("completedQueue_DeSelectAll").appendChild(img);
            img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = refreshIcon;
                document.getElementById("completedQueue_RefreshData").appendChild(img);
            

            img = document.createElement("img");
            img.style.cssText = "width:16px; height:16px";
            img.id = "expandCollapseImgCQ";
            img.src = collapseIcon;
            document.getElementById("completedQueue_ExpandCollapse").appendChild(img);

            
            if(document.getElementById('completedQueue_selectedRecords').innerHTML === "")
            {
                document.getElementById('completedQueue_selectedRecords').innerHTML = "[No Trips Selected]";
            }
            //select row on "select all" button click
            // document.getElementById('completedQueue_SelectAll').addEventListener("click", function(){
            //     table.selectRow();
            // });
            //deselect row on "deselect all" button click
            document.getElementById('completedQueue_DeSelectAll').addEventListener("click", function(){
                table.deselectRow();
            });
            document.getElementById('completedQueue_RefreshData').addEventListener("click", async function(){
                await PrepareCompletedGridRequest(true);
            });
            document.getElementById("completedQueue_ExportToExcel").addEventListener("click", function(){
               
                if (table != undefined) {
                    const data = table.getData('active');
                    const columnsToIgnore = ['id'];
                    const visibleColumns = table.getColumns()
                    .filter(col => col.isVisible())
                    .map(col => col.getField())
                    .filter(field => field && !columnsToIgnore.includes(field));
            
                    const filteredData = data.map(row => {
                        const filteredRow = {};
                        visibleColumns.forEach(field => {
                            filteredRow[field] = row[field];
                        });
                        return filteredRow;
                    });
            
                
                    const sheet = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                    XLSX.writeFile(wb, "CompletedQueue_Table_Data.xlsx");
    
                }

                
            });
            document.getElementById('completedQueue_ClearFilter').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
            document.getElementById('completedQueue_ExpandCollapse').addEventListener("click", function () {
                try {
                    // console.log("tabulator_ExpandCollapse......................................................");
                    let element = document.getElementById("completedQueue_ExpandCollapse");
                    let oldImage = document.getElementById("expandCollapseImgCQ");
                    if (groupingFilterCheckCompletedQ.current.toLowerCase() !== "no column grouping") {
                        if (element.title.toLowerCase().includes("collapse")) {
                            element.removeChild(oldImage);
                            let img = document.createElement("img");
                            img.style.cssText = "width:16px; height:16px";
                            img.id = "expandCollapseImgCQ";
                            img.src = expandIcon;
                            element.appendChild(img);
                            element.title = "Expand Grouped Trips";
                            table.setGroupStartOpen(false);
                            table.setGroupBy(false);

                            // if (groupingFilterCheckCompletedQ.current === "Driver") {
                            //     table.setGroupBy(function (row) {
                            //       return `${row['AssignedDriver#']}`;
                            //     });
                            // }
                            // else if(groupingFilterCheckCompletedQ.current === "Vehicle"){
                            //     table.setGroupBy(function (row) {
                            //         return `${row['VEH#']}`;
                            //       });
                            // }
                            // else if(groupingFilterCheckCompletedQ.current === "Assigned Attributes"){
                            //     table.setGroupBy(function (row) {
                            //         return `${row['vAssignedAttributes']}`;
                            //       });
                            // }
                            // else if(groupingFilterCheckCompletedQ.current === "Attributes"){
                            //     table.setGroupBy(function (row) {
                            //         return `${row['vAttributes']}`;
                            //       });
                            // }
                            // else if(groupingFilterCheckCompletedQ.current === "Dispatched By"){
                            //     table.setGroupBy(function (row) {
                            //         return `${row['DispatchedBy']}`;
                            //       });
                            // }
                            // else {
                            //     table.setGroupBy(groupingFilterCheckCompletedQ.current); // for single-column groupings
                            // }
                            table.setGroupBy(groupingFilterCheckCompletedQ.current); // for single-column groupings
                        }
                        else {
                            element.removeChild(oldImage);
                            let img = document.createElement("img");
                            img.style.cssText = "width:16px; height:16px";
                            img.id = "expandCollapseImgCQ";
                            img.src = collapseIcon;
                            element.appendChild(img);
                            element.title = "Collapse Grouped Trips";
                            table.setGroupStartOpen(true);
                            table.setGroupBy(false);
                            table.setGroupBy(groupingFilterCheckCompletedQ.current);
                        }
                    }
                }
                catch (err) { console.log(err); }
            });
        },
        rowSelectionChangeHandle: async function(data){
            if(data.length === 0)
            {
                document.getElementById('completedQueue_selectedRecords').innerHTML = "[No Trips Selected]";
            }
            else if(data.length > 0)
            {
                
                document.getElementById('completedQueue_selectedRecords').innerHTML = "["+data.length+" Trip"+(data.length === 1 ? '':'s')+" Selected]";
                if(document.getElementById("completedQueue_mapViewBtn") && document.getElementById("completedQueue_mapViewBtn").textContent === 'Hide Map')
                {
                    if(data[0].ManifestNo && data[0].ManifestNo !== '')
                    {
                        selectedTripInfo.current = data[0];
                        selectedTripInfoToRefreshGrid.current = data[0];
                        if(data[0].ManifestNo && data[0].ManifestNo !== '')
                            await handleClusterManifestData(data[0], true, 'complete');
                        
                    }
                    else{
                        handleRowResize(100);
                        setVehData([]);
                        setClusterGridResponse({});
                        setClusterGridColumnSetting({});
                        routedTripShow.current = { "route": "", "data": "" };
                        unroutedTripShow.current = {"unroutedTripConf": data[0]["Confirmation #"], "data":data[0]};
                    }
                }
            }
        },
    });

    useEffect(() => {
        try {
            // if (!ModuleSecurity.CheckModuleSecurityByTag("DSPC")) {
            //     alert("You do not have access rights to access this section. Please contact the administrator.");
            //     navigate('/Login');
            // }
            

            if (document.readyState === 'complete') {
                ContextMenuArray = ContextMenuArray.filter(item => {
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripCancel") && item.label === CONTEXT_MENU_LABELS.CANCEL) {
                        return false;
                    }
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgileDispatch") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH) {
                        return false;
                    }
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_ExternalDispatch") && item.label === CONTEXT_MENU_LABELS.ExtnrlDispatch) {
                        return false;
                    }
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripActivate") && item.label === CONTEXT_MENU_LABELS.ACTIVATE) {
                        return false;
                    }

                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripAssignDispatch") && item.label === CONTEXT_MENU_LABELS.ASSIGN) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_TripActions") && item.label === CONTEXT_MENU_LABELS.TRIP_ACTIONS) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_SegmentFare") && item.label === CONTEXT_MENU_LABELS.SEGMENTFARE) {// pending
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_TripAndBidHistory") && item.label === CONTEXT_MENU_LABELS.TRIP_HISTORY) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_ClusteringActions") && item.label === CONTEXT_MENU_LABELS.TRIP_CLUSTER) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_GroupingActions") && item.label === CONTEXT_MENU_LABELS.TRIP_GROUP) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_BrokerActions") && item.label === CONTEXT_MENU_LABELS.TRIP_BROKER) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgileDispatch") && item.label === CONTEXT_MENU_LABELS.AGILE_DISPATCH) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_BuildManifest") && item.label === CONTEXT_MENU_LABELS.TRIP_MANIFEST) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS.ADD_ROUTE) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_ClusteringActions") && item.label === CONTEXT_MENU_LABELS.ADD_CLUSTER) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS.TRIP_DETAILS) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS.UNROUTE) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripAssignDispatch") && item.label === CONTEXT_MENU_LABELS.UNASSIGN) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_AgentNotes") && item.label === CONTEXT_MENU_LABELS.Rider_Notes) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteSuggestions") && item.label === CONTEXT_MENU_LABELS.ROUTE_SUGGESTIONS) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripMarkAsWillCall") && item.label === CONTEXT_MENU_LABELS.MARK_WILLCALL) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit") && item.label === CONTEXT_MENU_LABELS.TRIP_EDIT) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_MarkAsRoboCall") && item.label === CONTEXT_MENU_LABELS.MARK_ROBOCALL) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_PrintManifest") && item.label === CONTEXT_MENU_LABELS.PRINT_MANIFEST) {
                        return false;
                    }

                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_RouteUnRoute") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UNROUTE) {
                        return false;
                    }
                    
                    if (!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_UpdateScheduleTime") && item.label === CONTEXT_MENU_LABELS_FOR_STOP_VIEW.UPDATESCHEDULETIME) {
                        return false;
                    }
                    
                    
                    return true;
                });
                // PersistStorage.save("rowDataCallAgent", [], 999, true);
                PersistStorage.save("rowDataEditTrip", "", 999, true);
                PersistStorage.save("clientInfo", [], 99, true);
                localStorage.removeItem("callAgentTabStatus");

            }
            return () => {
                try {
                    if (xCancelSourceForGrid.current) {
                        xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
                    }
                    if (timerRef.current) {
                        clearTimeout(timerRef.current);
                    }
                    if (selectedRouteTimeout.current) {
                        clearTimeout(selectedRouteTimeout.current);
                    }
                    if (cellClickTimeout.current) {
                        clearTimeout(cellClickTimeout.current);
                    }
                    if (validateRouteTimeout.current) {
                        clearTimeout(validateRouteTimeout.current);
                    }
                    if (stopViewBreakTrip_Internal_Timeout.current) {
                        clearTimeout(stopViewBreakTrip_Internal_Timeout.current);
                    }
                } catch (e) { }
            };
        } catch (err) {
            console.log(err);
            return () => {
                try {
                    if (xCancelSourceForGrid.current) {
                        xCancelSourceForGrid.current.cancel("Cancelling grid request fetch call before initiating new request");
                    }
                    if (timerRef.current) {
                        clearTimeout(timerRef.current);
                    }
                    if (selectedRouteTimeout.current) {
                        clearTimeout(selectedRouteTimeout.current);
                    }
                    if (cellClickTimeout.current) {
                        clearTimeout(cellClickTimeout.current);
                    }
                    if (validateRouteTimeout.current) {
                        clearTimeout(validateRouteTimeout.current);
                    }
                    if (stopViewBreakTrip_Internal_Timeout.current) {
                        clearTimeout(stopViewBreakTrip_Internal_Timeout.current);
                    }
                } catch (e) { }
            };
        }
    }, []);

    useEffect(() => {
        try{
            if((completeDateRange.from && completeDateRange.from !== '') && (completeDateRange.to && completeDateRange.to !== ""))
            {
                completeDateRangeRef.current.from = completeDateRange.from;
                completeDateRangeRef.current.to = completeDateRange.to;
                if(gridMainType === 'Complete'){
                    PrepareCompletedGridRequest(true);
                }
            }
            else
            {
                completeDateRangeRef.current = {from: "", to: "", oldRange: completeDateRangeRef.current.oldRange};
                if(gridMainType === 'Complete') {
                    PrepareCompletedGridRequest(true);
                }
            }
        }catch(err){console.log(err);}
    }, [completeDateRange, gridMainType]);

    useEffect(() => {
        try{
            updateNumTripsInRoute();
            window.addEventListener('keydown', handler, false);
            return () => window.removeEventListener('keydown', handler, false);
        }
        catch (err) { console.log(err); return () => window.removeEventListener('keydown', handler, false); }
    }, [selectRowData, mainTableObj]);

    useEffect(() => {
        try {
            if (rowMoveFlag) {
                someThingChangedInGrid.current = true;
                updateCheckboxState();
                setRowMoveFlag(false);
            }
        }
        catch (err) { console.log(err); }
    }, [rowMoveFlag]);

    useEffect(() => {
        try {
            setGroupingHeaderFilter(groupingHeaderFilter);
            groupingFilterCheck.current = groupingHeaderFilter;
        }
        catch (err) { console.log(err); }
    }, [groupingHeaderFilter]);

    useEffect(() => {
        try {
            setGroupingHeaderFilterCompletedQ(groupingHeaderFilterCompletedQ);
            groupingFilterCheckCompletedQ.current = groupingHeaderFilterCompletedQ;
        }
        catch (err) { console.log(err); }
    }, [groupingHeaderFilterCompletedQ])

    useEffect(() => {
        try {
            let pliststyles = "";
            for (const AttributesColor of apiAttributesColors) {
                // console.log(AttributesColor);
                pliststyles = pliststyles + "      [Attr" + AttributesColor["ID"] + "]{margin-bottom: 1%;margin-left: 2px !important;background-color: " + AttributesColor["BackgroundColor"] + " !important;color: " + AttributesColor["vForeColor"] + " !important;display: inline-block !important; border:1px solid gray;}";
            }
            setDynamicsStyles(pliststyles);
        }
        catch (err) { console.log(err); }
    }, [apiAttributesColors]);

    useEffect(() => {
        try {
            if(toolboxRef.current.AffiliatesList !== ToolboxValues.AffiliatesList)
            {
                unroutedTripShow.current = { "unroutedTripConf": "", "data": "" };
                routedTripShow.current = { "route": "", "data": "" };
                setSelectedRowData([]);
            }
            toolboxRef.current = ToolboxValues;
            if (DispatchGridControlRef.current && !ToolboxValues.AffiliatesList.includes(","))
                PrepareGridRequest("grid");
            else if (SOGridControlRef.current)
                PrepareStandingOrderRequest();
            else if(CompletedQueueControlRef.current)
                PrepareCompletedGridRequest(true);
        } catch(err){console.log(err);}
    }, [ToolboxValues]);

    useEffect(() => {
        try {
            if (mainTableObj.current && manifestDataReceivedCheckRef.current) {
                manifestDataReceivedCheckRef.current = false;
                if (selectedManifest !== "") {
                    let data = mainTableObj.current.getData();
                    let row = data.find((item) => item.vManifestNumber === selectedManifest);
                    selectedTripInfo.current = row;
                    // handleClusterManifestData(row, checkboxSelectionFlag.current);
                }
            }
        } catch (err) { console.log(err); }
    }, [manifestDataReceivedCheckRef.current]);

    useEffect(() => {
        try {
            sidebarCheck.current = sidebarOpen;
        }
        catch (err) { console.log(err); }
    }, [sidebarOpen]);

    useEffect(() => {
        try {
            checkboxSelectionFlag.current = showCompletedTrips;
        }
        catch (err) { console.log(err); }
    }, [showCompletedTrips]);

    useEffect(() => {
        IsShowOccupiedVehicles.current = showOccupiedVehicles;
    }, [showOccupiedVehicles])

    useEffect(() => {
        try {
            if (height !== 100) { ClusterGridheight.current = height; }
        }
        catch (err) { console.log(err); }
    }, [height]);

    useEffect(() => {
        try {
            mapViewCheck.current = mapView;
            const selectedGroupingElm = document.querySelector('#gridgroupedcolstabulator');
            const WidthAmount = (mapView ? 50 : 100);
            const groupingStyleWidth = (mapView ? '25px' : 'auto');
            setWidth(WidthAmount);
            if (selectedGroupingElm) {
                selectedGroupingElm.style.width = groupingStyleWidth;
            }
        }
        catch (err) { console.log(err); }
    }, [mapView]);

    useEffect(() => {
        try{
            if(DispatchGridControlRef.current){
                DispatchGridControlRef.current.SetWidth(width +"%");
            }
            else if(SOGridControlRef.current){
                SOGridControlRef.current.SetWidth(width + "%");
            }
            else if(CompletedQueueControlRef.current){
                CompletedQueueControlRef.current.SetWidth(width + "%");
            }
        } catch(err){console.log(err);}
    }, [width]);

    useEffect(() => {
        try {
            if (DispatchGridControlRef.current) {
                DispatchGridControlRef.current.SetGridRefreshPaused(GridRefreshPaused);
            }
            else if(SOGridControlRef.current) {
                SOGridControlRef.current.SetGridRefreshPaused(GridRefreshPaused);
            }
            else if(CompletedQueueControlRef.current) {
                CompletedQueueControlRef.current.SetGridRefreshPaused(GridRefreshPaused);
            }
        } catch(err){console.log(err);}
    }, [GridRefreshPaused]);

    useEffect(() => {
        try {
            
            if (gridMainType === 'Dispatch') {
                unroutedTripShow.current = { "unroutedTripConf": "", "data": "" };
                routedTripShow.current = { "route": "", "data": "" };
                setSelectedRowData([]);
                handleRowResize(100);
                setVehData([]);
                setClusterGridResponse({});
                setClusterGridColumnSetting({});
                PrepareGridRequest('grid');
            }
            else if (gridMainType === 'Standing') {
                unroutedTripShow.current = { "unroutedTripConf": "", "data": "" };
                routedTripShow.current = { "route": "", "data": "" };
                setSelectedRowData([]);
                handleRowResize(100);
                setVehData([]);
                setClusterGridResponse({});
                setClusterGridColumnSetting({});
                PrepareStandingOrderRequest();
            }
            else
            {
                unroutedTripShow.current = { "unroutedTripConf": "", "data": "" };
                routedTripShow.current = { "route": "", "data": "" };
                setSelectedRowData([]);
                handleRowResize(100);
                setVehData([]);
                setClusterGridResponse({});
                setClusterGridColumnSetting({});
                PrepareCompletedGridRequest();
            }
        }
        catch (err) { console.log(err); }
    }, [gridMainType]);

    const verticalDragHandler = useCallback((e) => {
        let h =
            ((e.clientY -
                e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                    .top) /
                e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                    .height) *
            100;
        h = Math.min(h, 90);
        if (h > 0 && h !== height) {
            setHeight(h);
        }
    }, [height]);

    const horizontalDragHandler = useCallback(
        (e) => {
            let w =
                ((e.clientX -
                    e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                        .left) /
                    e.currentTarget.parentElement.parentElement.getBoundingClientRect()
                        .width) *
                100;
            w = Math.min(w, 80);

            if (w > 0 && w !== width) {
                setWidth(w);
            }
        },
        [width]
    );


    const MarkAsRoboCall = async () => {
        try {
            if(mainTableObj?.current){
                const confirmationNoList = GetSelectedRowsConfirmationNo();
                let count = 0;
                if (confirmationNoList.trim() !== "") {
                    count = confirmationNoList.includes(",") 
                    ? confirmationNoList.split(",").length 
                    : 1;
                }
                const _selectedRows = mainTableObj.current.getSelectedRows();
                let selectedAff = parseInt(_selectedRows[0].getData().PrimaryAffiliateID);

                try {
                    const payload = {
                        refIds: confirmationNoList,
                        affiliateID: selectedAff
                    };
                    const response = await APICom.fetchData(
                        "GenericManifestDotNetCoreURL",
                        "api/Notification/MarkGridAdded",
                        "post",
                        { "Content-Type": "application/json" },
                        payload
                    );
                    if (response && response.data) {
                            console.log("API response:", response.data);
                            if(response.data == "Added successfully."){
                                toast.success("Robocall: Requests marked successfully for " + count + " trip(s)", {
                                    autoClose: 6000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });
                            }
                            else{
                                toast.error("An Error occured while marking request(s) as RoboCall", {
                                    autoClose: 6000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });
                            }
                        }
                    } catch (err) {
                        toast.error("An Error occured while marking request(s) as RoboCall", {
                            autoClose: 6000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true
                          });
                    }
            }

        } catch (error) {

            toast.error("An Error occured while marking request(s) as RoboCall", {
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
              });
        }
    }

    function GetSelectedRowsConfirmationNo(){
        let confirmationNumber = "";
        try {
            if(mainTableObj?.current){
                const _selectedRows = mainTableObj.current.getSelectedRows();
                const confirmationNos = _selectedRows.map(row => row.getData().ConfirmationNo);
                const confirmationNoList = confirmationNos.join(",");
                confirmationNumber = confirmationNoList;
                
            }    
        } catch (error) {
            return "";
        }
        return confirmationNumber;

    }

    function filterUniqueTrips(tripArray) {
        const seen = new Set();
        return tripArray.filter(trip => {
            if (!seen.has(trip.TripNo)) {
                seen.add(trip.TripNo);
                return true;
            }
            return false;
        });
    }

    const UnRouteActions = async () => {
        try {
            sethandlePageProgressBar("dispatch")
            let uniqueTrips = ClusterTableObject.current.getSelectedData();
            const selectedGridData = filterUniqueTrips(uniqueTrips);
            const affID = selectedGridData[0].iAffiliateID;
            let callBackURL = "";
            const SelectedRecordsForARB = [];
            if (GlobalASCSData && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }
            let bschedule = "";
            for (let k = 0; k < selectedGridData.length; k++) {
                if (selectedGridData[k].Route !== "" && selectedGridData[k].PickupPerson !== 'BreakTrip' && selectedGridData[k].PickupPerson !== 'SDepot' && selectedGridData[k].PickupPerson !== 'EDepot') {
                    bschedule = (typeof selectedGridData[k].bIsScheduled === "boolean" ? (selectedGridData[k].bIsScheduled === true ? true : false) : (selectedGridData[k].bIsScheduled.toUpperCase() === "TRUE" ? true : false));
                    SelectedRecordsForARB.push({
                        PickupDateTime: selectedGridData[0].ReqTimeHidden,
                        AffiliateID: selectedGridData[k].iAffiliateID,
                        ServiceID: (!bschedule ? selectedGridData[k].iServiceID : -1),
                        ScheduleID: (bschedule ? selectedGridData[k].iScheduleID : -1),
                        Confirmation: selectedGridData[k].TripNo,
                        vManifestNumber: selectedGridData[k].ManifestNumber,
                        TripRequestStatus: selectedGridData[k].StopStatus,
                        iAssignedVehicleId: selectedGridData[k].iVehicleID === "" ? "-1" : selectedGridData[k].iVehicleID,
                        iAssignedDriverId: "-1"//selectedGridData[k].AssignedDriverId === "" ? "-1" : selectedGridData[k].AssignedDriverId,
                    });
                }
            }

            if (SelectedRecordsForARB.length === 0) {
                setAlertObj({ ...routeObj, alertTitle: 'UnRoute', alertMsg: 'No grouped record is selected. Please select valid grouped record(s) to perform this action!', displayFooter: true });
                setAlert(true);
                return false;
            }

            UnRouteTrips(affID, callBackURL, SelectedRecordsForARB);
        }
        catch (err) { console.log(err); }
    };

    const UnRouteTrips = async (affID, cbURL, arrObj) => {
        try {
            let Param = {
                "affiliate_id": affID,
                "requested_page_name": "UnClusteringAction",
                "user_id": loginData.iUserID,
                "app_id": 26,
                "object_list": JSON.stringify(arrObj),
                "call_back_url": cbURL
            }
            setAlertObj({ ...routeObj, alertTitle: 'Initializing UnRouting Process', alertMsg: 'Please Wait...', displayFooter: false });
            setAlert(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/UnRoute", "post", { "Content-Type": "application/json" }, Param, null);
            let result = response.data;
            if (result.run_id > 0) {
                setAlertObj({ ...routeObj, alertTitle: 'UnRouting Started', alertMsg: 'UnRouting is being performed...', displayFooter: false });
                setAlert(true);
            }
            else if (result.error_message !== null && result.error_message !== "") {
                setAlertObj({ ...routeObj, alertTitle: 'Un-Route', alertMsg: result.error_message, displayFooter: true });
                setAlert(true);
                setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
                handleRouteAlertClose();
            }
            else {
                setAlertObj({ ...routeObj, alertTitle: 'Un-Route', alertMsg: 'Something went wrong !!!', displayFooter: true });
                setAlert(true);
                setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
                handleRouteAlertClose();
            }
        }
        catch (err) { console.log(err); }
    };

    const PerformReRouting = async (row) => {
        try {
            setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...', displayFooter: false });
            setAlert(true);
            const rowData = row.getData();
            let PickupDateTime = rowData.ReqTimeHidden;
            let iServiceID = rowData.iServiceID;
            let PUPerson = rowData.PUPerson;
            let vManifestNumber = rowData.ManifestNumber;
            let iAffiliateID = rowData.iAffiliateID;
            if (PUPerson === 'BreakTrip') {
                let params = {
                    "vServiceIDs": String(iServiceID),
                    "vScheduleIDs": String(-1),
                    "dtSelectedDate": PickupDateTime,
                    "iUserID": loginData.iUserID
                }

                setShowGridClusterLoader(true);
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ReRoute", "post", { "Content-Type": "application/json" }, params, null);
                setAlert(false);
                if (response.data[0].Result == 1) {
                    setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Re-Routing', body: 'BreakTrip is Deleted Successfully', btnCancelText: 'No', btnOkText: 'Ok' }));
                    StopViewGridLoad(vManifestNumber, iAffiliateID);
                }
                else if (response.data[0].Result == -1) {
                    setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Re-Routing', body: 'BreakTrip Cannot Deleted', btnCancelText: 'No', btnOkText: 'Ok' }));
                }
            }
        } catch (err) { console.log(err); }
    };

    const filterAffiliates = (AffiliateData, row) => {
        try {
            const rowData = row.getData();
            const { iSRATSPID } = rowData;

            // Validate input data
            if (!iSRATSPID) {
                console.error("Invalid row data: iSRATSPID is missing.");
                return [];
            }

            // Find the `iPartnerAffiliateID` for the given `iSRATSPID`
            const matchingAffiliate = AffiliateData.find(
                (affiliate) => affiliate.AffiliateID === parseInt(iSRATSPID)
            );

            if (!matchingAffiliate) {
                console.warn(`No affiliate found with AffiliateID: ${iSRATSPID}`);
                return [];
            }

            const { iPartnerAffiliateID } = matchingAffiliate;

            // Filter affiliates with the same `iPartnerAffiliateID`
            return AffiliateData.filter(
                (affiliate) => affiliate.iPartnerAffiliateID === parseInt(iPartnerAffiliateID)
            );
        }
        catch (err) {
            console.log(err);
            return 0;
        }
    };

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    };

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    };

    const handleConfirmationModalClose = () => {
        setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    };
    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const setArrangedClusterTripsFunc = (data) => {
        setArrangedClusterTrips(data);
    };

    const handleTripActionsDialogueShowHide = (show) => {
        setGridRefreshPaused(show);
        setShowTripActionsDialog(show);
    };

    const handleShowTripsActionsForManifestNumber = (show, data) => {
        try {
            if(DispatchGridControlOptions != undefined){
                let dataFromDispatchQ = DispatchGridControlRef.current?.getCurrentGridData();
                let dataFromQueue = dataFromDispatchQ.getData();
                if(dataFromQueue != undefined && dataFromQueue.length > 0)
                {

                    let topConfirmationNumber = dataFromQueue.filter(p => p.Route != "" && p.Route == data.vVirtualRoute)[0].ConfirmationNo;
                    if(topConfirmationNumber != undefined && topConfirmationNumber != ""){
                        let rowToPass = dataFromQueue.filter(p => p.Route != "" && p.Route == data.vVirtualRoute)[0];
                        let arrQ = [];
                        arrQ.push(rowToPass);
                        setSelectedRowData(arrQ);
                        setShowTripActionsDialog(true);
                    }
                }
                setManifestData(data);
            }
        } catch (error) {
            
        }
    }

    const SendEmailToCustomer = async (data) => {
        try {
            let Param = {
                confirmationno: data["Confirmation #"],
                email: customerEmail
            };
            const globalInLoadAPIURL = (GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : "");
            let fullEmailURL = globalInLoadAPIURL + "/TripReservation/SendTripEmailToCustomer"
            let response = await APICom.fetchData("full", fullEmailURL, "post", { "Content-Type": "application/json" }, Param, null);
            let result = response.data;
            if (result === 'Success') {
                setModalHeaderText("Email Receipt Alert");
                setModalBodyHTML(<p>{"Email sent successfully. "}</p>);
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
                setCustomerEmail("");
            }
            else {
                setModalHeaderText("Email Receipt Alert");
                setModalBodyHTML(<p>{"Email not sent. Please try again later. "}</p>);
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
                setCustomerEmail("");
            }
        }
        catch (err) { console.log(err); }
    };

    function ToolBoxStateChange(newToolboxValues) {
        try {
            // console.log(newToolboxValues.AffiliatesList);
            // sendAffToParent(newToolboxValues.AffiliatesList);
            // SetToolboxValues({...ToolboxValues, ...newToolboxValues});

            if (!isEqual(ToolboxValues, newToolboxValues)) {
                sendAffToParent(newToolboxValues.AffiliatesList);
                SetToolboxValues({ ...ToolboxValues, ...newToolboxValues });
                //SetToolboxValues(prevValues => ({ ...prevValues, ...newToolboxValues }));
            }

            try {
                if(ToolboxValues.Date != newToolboxValues.Date){
                    setSelectedRoute("");
                }
                
            } catch (error) {
                
            }
        } catch (Err) { }
    }

    const GridRowSelect = (rowData) => {
        setSelectedRowData(rowData);
        gridRowData(rowData);
    };

    const handleMarkAsWillCall = async (rowData, modalBtn) => {
        try {

            if(rowData && rowData.PickupTime === 'Will Call')
            {
                setModalHeaderText("Trip Status Alert");
                setModalBodyHTML("Trip #" + rowData.iRefID + " already marked as 'Will Call'.");
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
                return;
            }

            let confirmation = (rowData.iRefID && rowData.iRefID !== "" ? parseInt(rowData.iRefID) : 0);
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowGridClusterLoader(true);
            let response = await APICom.fetchData("ReservationCoreURL", "api/ParatransitCT/MarkTripAsWillCall", "post", { 'Content-Type': 'application/json' }, confirmation, xCancelSourceForGrid.current);
            // console.log(response);
            setShowGridClusterLoader(false);
            if (response && response.error === "") {
                if (response.data && response.data !== "No data found") {
                    if (response.data === 1) {
                        setModalHeaderText("Trip Status Changed");
                        setModalBodyHTML("Trip #" + rowData.iRefID + " was changed to 'Will Call' status successfully.");
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }
                    else if (response.data === 0) {
                        setModalHeaderText("Trip Status Alert");
                        setModalBodyHTML("Trip #" + rowData.iRefID + " was not marked as 'Will Call'.");
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }

                }
                else {
                    setModalHeaderText("Trip Status Alert");
                    setModalBodyHTML("No data was found for the trip #" + rowData.iRefID + ", please try again or contact an administrator.");
                    setModalBtnHTML(modalBtn);
                    setShowDynamicModal(true);
                }
            }
            else {
                setModalHeaderText("Trip Status Error");
                setModalBodyHTML(<b>{response.error}</b>);
                setModalBtnHTML(modalBtn);
                setShowDynamicModal(true);
            }
        }
        catch (err) { console.log(err); }
    };

    const AdjustRouteTimes = async () => {
        try {
            if (!showAlert) {
                setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...', displayFooter: false });
                setAlert(true);
                sethandlePageProgressBar("dispatch")
            }
            const data = ClusterTableObject.current.getData();
            let callBackURL = "";
            let _tripDetails = [];
            let _stopOrder = 1;
            let loopStartIndex = 0;
            let iMode = 0;
            if (StopViewSelectedRowIndex !== 0) {
                iMode = 16;
                // loopStartIndex= data.findIndex(row => row.Index === StopViewSelectedRowIndex);
            }
            for (let i = loopStartIndex; i < data.length; i++) {
                if((data[i].Type === "PU" && data[i]["PUPerson"]?.toLowerCase() == 'breaktrip')){
                    for (var j = 0; j < i; j++) {
                        if((data[j].Type === "EndDept" || data[j]["Type"] === "StartDept" || data[j]['Type'] == "IdleTime")){
                            continue;
                        }
                    else{
                        if(data.slice(0, i).filter(x => x.Type === "DO" && x["TripNo"]===data[j]["TripNo"]).length>0){
                            continue;
                        }
                    else{
                        setAlert(false);
                        setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Manual Stop View Adjustment', body: 'No Passenger can stay on-boarded while driver taking break', btnCancelText: 'No', btnOkText: 'Ok' }));

                        // alert('no passenger can stay on-boarded while driver taking break');
                        
                        return;
                    }
                    
                }
                }
                }
                if (data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept" || data[i].Type === "StartDept") {
                    let det = {};
                    det.RouteID = data[i].Route;
                    det.iRefID = data[i]["TripNo"];
                    if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                        det.iRefID = "-1"
                    }
                    det.NodeType = data[i].Type;
                    det.SystemScheduleTime = data[i].SchTime;
                    det.EstTravelTime = data[i].EstTimeFromPrev;
                    det.EstTravelDistance = data[i].EstDistFromPrev;
                    det.WaitTimeAtLocation = 0;
                    //det.isNewNode = false;
                    det.PUPerson = data[i].PUPerson;
                    det.TripRequestStatus = data[i].StopStatus;
                    det.ERSASettingName = "";
                    det.ERSASettingID = _stopOrder;  //algoSettingId;
                    det.Zone = "";
                    det.Latitude = data[i].dLatitude;
                    det.Longitude = data[i].dLongitude;
                    det.isFeasibleRoute = false;
                    det.PickupDateTime = data[i].ReqTimeHidden;
                    det.ManifestNumber = data[i].ManifestNumber;
                    if (det.NodeType === "EndDept" && _tripDetails.length > 0) {
                        det.SystemScheduleTime = data[i - 1].SchTime;
                        det.PickupDateTime = data[i - 1].ReqTimeHidden;
                        det.RouteID = data[i - 1].Route;
                    }
                    _tripDetails.push(det);
                    _stopOrder++;
                }
            }
            if (_tripDetails.length === 1) {
                //ShowDialogueMsg("InValid Action", "Action not allowed.");
                return false;
            }

            
            if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }


            let params = {
                "TripDetails": JSON.stringify(_tripDetails),
                "callBackURL": callBackURL,
                "iMode": iMode, // 1 for Compute Estimates Route on Cluster Table Grid/Stop View Screen
                "AlgoSetting": String(data[0].iID_RouteGeneralSettings),   //String(data[0].iSettingID),
                "RouteNo": data[0].Route,
                "iAffiliateID": String(data[0].iAffiliateID), //data[0].iATSPID,
                "iUserID": loginData.iUserID,
                "iSelectedRefID": SelectedRowRefID.current,
                "iStopType": (SelectedRowStopType === "PU" ? 0 : 1)
            }

            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowGridClusterLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BulkInputToARB", "post", {}, params, xCancelSourceForGrid.current);
            if (response["data"] !== null && response["data"].length > 0) {
                if(response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                    setShowGridClusterLoader(false);
                    setAlertObj({
                        ...routeObj,
                        alertTitle: 'Affiliate Restricted',
                        alertMsg: response["data"][0].Error,
                        displayFooter: true
                    });
                    setAlert(true);
                }
            }
            else {
                //to do
            }
            setShowGridClusterLoader(false);
        } catch (err) { console.log(err); }
    };

    const StopViewGridLoad = async (vManifestNumber, iAffiliateID) => {
        try {
            handleRowResize(ClusterGridheight.current);
            
            let response = await GetRouteStopView(vManifestNumber, iAffiliateID);
            let result = response.data;
            if (result && result.data && result.data.length > 0) {
                setShowGridClusterLoader(true);
                // setClusterGridResponse([]);
                setclusterTableStateBeforeCompute(null);
                setClusterGridResponse(result.data);
                setClusterGridColumnSetting(result.setting)
                routedTripShow.current = { "route": result.data[0]?.Route, "data": "" };
            }
            setShowGridClusterLoader(false);
        } catch (err) { }
    };

    const AutoRefresh = async () => {
        
        const checkbox = document.getElementById("clusterTableGrid_checkbox");
        if (checkbox && checkbox.checked) {
            someThingChangedInGrid.current = false;
        } else {
            someThingChangedInGrid.current = true;
        }

        if (checkbox) {
            const slider = checkbox.nextElementSibling;
            if (slider) {
                slider.title = checkbox.checked
                    ? "Disable Auto Refresh"
                    : "Enable Auto Refresh";
            }

            if(checkbox.checked){
                toast.success("Stop view auto-refresh enabled");
            }
            else{
                toast.error("Stop view auto-refresh disabled");
            }
        } else {
            console.warn("Checkbox not found: #clusterTableGrid_checkbox");
        }
    };

    const ValidateRoute = async () => {
        try {
            sethandlePageProgressBar("dispatch");
            setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...', displayFooter: false });
            setAlert(true);

            const data = ClusterTableObject.current.getData();
            let _tripDetails = [];
            let _stopOrder = 1;
            for (let i = 0; i < data.length; i++) {
                if (data[i].Type === "PU" || data[i].Type === "DO" || data[i].Type === "EndDept") {
                    let det = {};
                    det.RouteID = data[i].Route;
                    det.iRefID = data[i]["TripNo"];
                    if (det.iRefID === "" || det.iRefID === null || det.iRefID === undefined) {
                        det.iRefID = "-1"
                    }
                    det.NodeType = data[i].Type;
                    det.SystemScheduleTime = data[i].SchTime;
                    det.EstTravelTime = data[i].EstTimeFromPrev;
                    det.EstTravelDistance = data[i].EstDistFromPrev;
                    det.WaitTimeAtLocation = 0;
                    //det.isNewNode = false;
                    det.PUPerson = data[i].PUPerson;
                    det.TripRequestStatus = data[i].StopStatus;
                    det.ERSASettingName = "";
                    det.ERSASettingID = _stopOrder;  //algoSettingId;
                    det.Zone = "";
                    det.Latitude = data[i].dLatitude;
                    det.Longitude = data[i].dLongitude;
                    det.isFeasibleRoute = false;
                    det.PickupDateTime = data[i].ReqTimeHidden;
                    det.ManifestNumber = data[i].ManifestNumber;
                    if (det.NodeType === "EndDept" && _tripDetails.length > 0) {
                        det.SystemScheduleTime = data[i - 1].SchTime;
                        det.PickupDateTime = data[i - 1].ReqTimeHidden;
                        det.RouteID = data[i - 1].Route;
                    }
                    _tripDetails.push(det);
                    _stopOrder++;
                }
            }
            if (_tripDetails.length === 1) {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                    return (
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Validation Alert");
                setModalBodyHTML("Action not allowed.");
                setModalBtnHTML(manageRouteFooterHTML);
                setShowDynamicModal(true);
                // alert("InValid Action", "Action not allowed.");

                return false;
            }

            let callBackURL = "";
            if (GlobalASCSData && GlobalASCSData !== undefined) {
                const jsonArray = GlobalASCSData;
                const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
                callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
            }

            let params = {
                "TripDetails": JSON.stringify(_tripDetails),
                "callBackURL": callBackURL,
                "iMode": 1, // 1 for Validate Route on Cluster Table Grid/Stop View Screen
                "AlgoSetting": String(data[0].iID_RouteGeneralSettings),   //String(data[0].iSettingID),
                "RouteNo": data[0].Route,
                "iAffiliateID": String(data[0].iAffiliateID), //data[0].iATSPID,
                "iUserID": loginData.iUserID
            }

            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowGridClusterLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/BulkInputToARB", "post", {}, params, xCancelSourceForGrid.current);
            if (response["data"] && response["data"].length > 0) {
                //to do
                if(response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                    setShowGridClusterLoader(false);
                    setAlertObj({
                        ...routeObj,
                        alertTitle: 'Affiliate Restricted',
                        alertMsg: response["data"][0].Error,
                        displayFooter: true
                    });
                    setAlert(true);
                }
            }
            else {
                //to do
            }
            setShowGridClusterLoader(false);
        } catch (err) { console.log(err); }
    };

    const CommitActions = async () => {
        try {
            handleRowResize(ClusterGridheight.current);
            setAlertObj({ ...routeObj, alertTitle: 'Initializing Process', alertMsg: 'Please Wait...', displayFooter: false });
            setAlert(true);
            let StopViewMainData = ClusterTableObject.current.getData()[0];
            const _result = ClusterTableObject.current.getData();
            let arrayTripClusterGrid=null;
            let Result = [];
            if(_result.some((v) => v.StopStatus === "Performed")){
            arrayTripClusterGrid = _result.filter(
                (v) =>
                    (v.Type === 'PU' ||
                    v.Type === 'DO' ||
                    v.Type === 'EndDept') && v.StopStatus != "Performed");
            }
            else{
            arrayTripClusterGrid = _result.filter(
                (v) =>
                    (v.Type === 'PU' ||
                    v.Type === 'DO' ||
                    v.Type === 'StartDept' ||
                    v.Type === 'EndDept') && v.StopStatus != "Performed");
            }

            if (arrayTripClusterGrid.length > 0) {
                //Changes To Restict The Commit Action For The External Trips
                let _ExternalList = arrayTripClusterGrid.filter(el => el.iCreatedByAppId === 19);

                if (_ExternalList != null && typeof _ExternalList != "undefined" && _ExternalList.length > 0) {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                        return (
                            <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Commit Action Alert");
                    setModalBodyHTML("Action not Allowed for the Broker Trips.");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowDynamicModal(true);
                    // console.log("Action not Allowed for the Broker Trips.");
                    return false;
                }
                let _affilateId = _result[0].iAffiliateID;


                let rsfc_input = null;
                let RSFCRoutes = new Array();
                let _iStopNumberCount = 1;
                let routeTypeMode = 1;
                // arrayTripClusterGrid.sort((a, b) => a["Stop#"] - b["Stop#"]);
                //Changes To Restict The Commit Action For The External Trips
                for (let i = 0; i < arrayTripClusterGrid.length; i++) {
                    let _ConfirmationNo = arrayTripClusterGrid[i]["TripNo"];
                    let _stoptype = arrayTripClusterGrid[i]["Type"];
                    if (_stoptype === "StartDept" || _stoptype === "EndDept") {
                        routeTypeMode = 2
                    }
                    if (_ConfirmationNo !== "" && typeof _ConfirmationNo !== "" &&
                        (_stoptype === "PU" || _stoptype === "DO" || _stoptype === "StartDept" || _stoptype === "EndDept")) {
                        let isfound = true;
                        let _objT = {
                            "vManifestNumber": arrayTripClusterGrid[i]["ManifestNumber"],
                            "iTripID": parseInt(arrayTripClusterGrid[i]["TripNo"]),
                            "iStopNumber": _iStopNumberCount,
                            "vStopType": arrayTripClusterGrid[i]["Type"],
                            "vReferenceNo": "",
                            "dtSchTime": arrayTripClusterGrid[i]["SchTime"],
                            "bWillCall": arrayTripClusterGrid[i]["bWillCall"],
                            "bPerformed": arrayTripClusterGrid[i]["bPerformed"],
                            "bIsScheduled": arrayTripClusterGrid[i]["bIsScheduled"] ?? "",
                            "dtReqTime": arrayTripClusterGrid[i]["ReqTime"],
                            "SchDateTime": arrayTripClusterGrid[i]["SchDateTime"]
                        };
                        Result.push(_objT);
                        _iStopNumberCount++;
                        try {
                            let temp_elem = RSFCRoutes.findIndex(elem => elem.ManifestNumber === arrayTripClusterGrid[i]["ManifestNumber"]);
                            if (temp_elem < 0 && arrayTripClusterGrid[i]["ManifestNumber"] !== "")
                                RSFCRoutes.push({ "ManifestNumber": arrayTripClusterGrid[i]["ManifestNumber"], "RouteType": routeTypeMode });
                        } catch (error) { }
                    }
                }
                if (Result && Result.length > 0) {
                    let _iUserID = 0;
                    if (loginData && typeof loginData !== "undefined") {
                        _iUserID = loginData.iUserID
                    }

                    let MACsAPI_URL = "";
                    let RunRSFC_URL = "";
                    if (GlobalASCSData && GlobalASCSData !== undefined) {

                        MACsAPI_URL = GlobalASCSData.find(item => item.SubTitle === "MACsAPI_URL").value;

                        let localURLItem = GlobalASCSData.find(item => item.SubTitle === "InLoadAPI_LocalURL");

                        if (localURLItem) {
                            RunRSFC_URL = localURLItem.value;
                        } else {
                            let apiUrlItem = GlobalASCSData.find(item => item.SubTitle === "InLoadAPI_URL");
                            RunRSFC_URL = apiUrlItem ? apiUrlItem.value : null;
                        }

                    }

                    let jsondata = {
                        "DataList": JSON.stringify(Result),
                        "iModifiedBy": _iUserID,
                        "vManifestDisposition": "RASA",
                        "MACsAPI_URL": MACsAPI_URL + '/MBPC/CommonAPICall?MethodName=SaveUpdateRouteStopsOrder',
                        "iModifiedByAppID": 26,
                        "vHistoryReason": HistoryReason.current,
                        "IrefIDForUpdateSchedule": SelectedRowRefID.current,
                        "RunRSFC_URL": RunRSFC_URL + '/MBPC/RunRSFC',
                        "RSFC_Routes": RSFCRoutes
                    }

                    try {
                        rsfc_input = { "Routes": RSFCRoutes, "UnRoutedTrips": null, UserID: _iUserID, AppID: 26 };



                        xCancelSourceForGrid.current = APICom.GenerateSource();

                        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/CommitAdjustedRoutes", "post", {}, jsondata);

                        if (response.data === 'success') {

                            // var rsfc_response = await APICom.fetchData("full", `${RunRSFC_URL}/MBPC/RunRSFC`, "post", {}, rsfc_input);


                            // if (rsfc_response.data.GenericRecord === ''){}
                            setAlert(false);
                            setConfirmationModalObj((prevState) => ({ ...prevState, show: true, title: 'Manual Route Adjustment', body: 'Changes Saved Sucessfully', btnCancelText: 'No', btnOkText: 'Ok' }));

                            // xCancelSourceForGrid.current = APICom.GenerateSource();
                            let response = await GetRouteStopView(_result[0].ManifestNumber, _result[0].iAffiliateID, _result[0].ConfirmationNo);
                            let result = response.data;
                            if (result && result.data && result.data.length > 0) {
                                setShowGridClusterLoader(true);
                                setClusterGridResponse([]);
                                setclusterTableStateBeforeCompute(null);
                                setClusterGridResponse(result.data);
                                setClusterGridColumnSetting(result.setting)

                                routedTripShow.current = { "route": result.data[0]?.Route, "data": "" };
                            }
                            setShowGridClusterLoader(false);
                        }
                        else if (response.data.message && response.data.message !== "") {
                            setAlert(false);
                            const errorMessage = response.data.message;
                            setAlertObj({ ...routeObj, alertTitle: 'Commit Action', alertMsg: errorMessage, displayFooter: true });
                            setAlert(true);
                        }

                        else {
                            setAlert(false);
                            const errorMessage = "An error occured while committing";
                            setAlertObj({ ...routeObj, alertTitle: 'Commit Action', alertMsg: errorMessage, displayFooter: true });
                            setAlert(true);

                        }
                    }

                    catch (error) { }

                }
                else {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                        return (
                            <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Commit Action Alert");
                    setModalBodyHTML("No change found in any record !");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowDynamicModal(true);
                    // console.log("No change found in any record !");
                    return false;
                }
            }
            else {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                    return (
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Commit Action Alert");
                setModalBodyHTML("There are no records to update.");
                setModalBtnHTML(manageRouteFooterHTML);
                setShowDynamicModal(true);
                // console.log("There are no records to update.");
                return false;
            }

        }
        catch (TripClusterCommit) { console.log(TripClusterCommit); }
    };

    async function GetRouteStopView (ManifestNo = '', iAffiliateID = 0, ConfirmationNo = '', fetch = {fetchMode: 0, performed: false}) {
        try{
            if(ManifestNo !== ''){
            
                let givenDate = (PersistStorage.retrieve('selectedDate', true) ? PersistStorage.retrieve('selectedDate', true) : "");
                if(givenDate === "")
                    givenDate = RefSelectedDate.current;
                else{
                    let correctedDate = givenDate.includes("-") ? givenDate.split('-') : '';
                    if(correctedDate === '')
                        return 0;
                    else{
                        const [year, month, day] = correctedDate.map(num=> num.padStart(2, '0'));
                        givenDate = `${year}-${month}-${day}`;
                    }
                }
                let params = {
                    "vManifestNumber": ManifestNo,
                    "dtSelectedDate": givenDate, //"12/06/2023",
                    "vehicleId": -1,
                    "bIncludePerformed": fetch.performed,
                    "vAffIDs": String(iAffiliateID),
                    "confirmationNo": String(ConfirmationNo),
                    "iFetchMode": fetch.fetchMode,
                    "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
                    "iUserID": loginData.recordID
                }

                let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params, null);

                return response;
            }
            else
            {
                return {data: '', error:''};
            }
        } catch(err){console.log(err); return {data: '', error:''}}
    }

    const handleColorCodesDisplay = async (affiliate) => {
        try {
            let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1";
            //(ToolboxValues.AffiliatesList === "" ? iATSPID :ToolboxValues.AffiliatesList.split(',')[0].trim(' '))
            let data = {
                "iATSPID": affiliate
            }
            let response = await APICom.fetchData("", "TripActions/GetServiceRequestColorCodes", "post", { "Content-Type": "application/json" }, data, null);
            let api_data = response.data.data ? response.data.data : []
            // Elvis operator in ECMAScript 2020
            if (api_data?.length) {
                if (api_data.length === 3) {
                    //setApiRowData(api_data[0]);
                    setApiColData(api_data[1]);
                    setApiAttributesColors(api_data[2]);
                }

            }

        }
        catch (err) { console.log(err); }
    };

    const handleClusterManifestData = async (data, checked = false, gridType = '') => {
        try {
            let manifest = (data && data.vManifestNumber ? data.vManifestNumber : (data && data.ManifestNo ? data.ManifestNo : ""));
            if (data && manifest !== "") {
                handleRowResize(ClusterGridheight.current);
                let data1 = (gridType === '' ? mainTableObj.current.getData() : (gridType === 'complete' ? completedTableObj.current.getData() : []));
                const filteredResults = (gridType === '' ? data1.filter(item => item.vManifestNumber === data.vManifestNumber) : data1.filter(item => item.ManifestNo === data.ManifestNo));
                filteredResults.sort((a, b) => {
                    const timeA = new Date(a.PickupDateTime);
                    const timeB = new Date(b.PickupDateTime);
                    return timeA - timeB;
                });

                // let dispatchVeh = "";
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let dispatchVEH = (data.VEHNo ? data.VEHNo : (data["VEH#"] ? data["VEH#"] : null));
                let iAssignedVehicleID = data.iAssignedVehicleId;
                let _iServiceStatusID = data.iServiceStatusID;
                // toolboxRef.current.Date
                let givenDate = (PersistStorage.retrieve('selectedDate', true) ? PersistStorage.retrieve('selectedDate', true) : "");
                if(givenDate === "")
                    givenDate = RefSelectedDate.current;
                else{
                    let correctedDate = givenDate.includes("-") ? givenDate.split('-') : '';
                    if(correctedDate === '')
                        return 0;
                    else{
                        const [year, month, day] = correctedDate.map(num=> num.padStart(2, '0'));
                        givenDate = `${year}-${month}-${day}`;
                    }
                }
                
                let affID = (data.PrimaryAffiliateID ? String(data.PrimaryAffiliateID) : String(data.iPrimaryAffiliate));
                let confirmation = (data.ConfirmationNo ? String(data.ConfirmationNo) : String(data["Confirmation #"]));
                // xCancelSourceForGrid.current = APICom.GenerateSource();

                setTimeout(() => {
                    setSelectedRoute(""); 
                }, 100);

                selectedRouteTimeout.current = setTimeout(() => {
                    setSelectedRoute(manifest/*row.getData().vManifestNumber*/);
                }, 200);

                let response = await GetRouteStopView(manifest, affID, confirmation, {fetchMode: 0, performed: checked});
                let result = response.data;
                if (result && result.data && result.data.length > 0) 
                {
                    let currentdate = DateTimeUtils.getCurrentDate();
                    if (RefSelectedDate.current === currentdate){// new Date().toISOString().split('T')[0]) {
                        
                        if (iAssignedVehicleID && iAssignedVehicleID != "0" && iAssignedVehicleID != "None-R" && 
                            iAssignedVehicleID !== "" && iAssignedVehicleID != null && iAssignedVehicleID != -1 && iAssignedVehicleID != "-1"
                         && (_iServiceStatusID === "1" || _iServiceStatusID === "2" || _iServiceStatusID === "3")) {
                            await GetAssignedVehicleToTrip(data);
                            // let APIdata = {
                            //     "iServiceID": data.ServiceID,
                            // };
                            // await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                                
                            //     setVehData([]);
                            //     //setVehData(response.data);
                            //     setAssignedVehicleToTrip([]);
                            //     setAssignedVehicleToTrip(response.data);
                            // });
                        }
                        // (filteredResults[0]?.ServiceStatus?.toUpperCase() === "ACTIVE" || filteredResults[0]?.ServiceStatus.toUpperCase() === "ASSIGNED" || filteredResults[0]?.ServiceStatus.toUpperCase() === "TRANSFERRED")

                        else if(tripType.current != "Routed-2"){
                            let refIDNewGrid = (filteredResults.length > 0 ? (filteredResults[0]["Confirmation #"] ? String(filteredResults[0]["Confirmation #"]) : "") : "");
                            let RefID = (filteredResults.length > 0 ? (filteredResults[0].iRefID ? String(filteredResults[0]?.iRefID) : (refIDNewGrid.length > 0 ? refIDNewGrid.slice(1) : "")) : "")
                            
                            await GetNearByVehicles(filteredResults[0], RefID);
                            // let APIdata = {
                            //     "pulat": filteredResults[0]?.PickupLatitude,
                            //     "pulong": filteredResults[0]?.PickupLongitude,
                            //     "nwheelchairs": String(filteredResults[0]?.nTotalWheelChairs),
                            //     "iatspid": String(filteredResults[0]?.iSRATSPID),
                            //     "bshowoccupiedvehicles": IsShowOccupiedVehicles.current.toString(),
                            //     "irefid": RefID,
                            // };

                            // await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                            //     setVehData([]);
                            //     setVehData(response.data);
                            // });
                        }
                    }
                    else {
                        setVehData([]);
                    }
                    setShowGridClusterLoader(true);
                    setClusterGridResponse([]);
                    setclusterTableStateBeforeCompute(null);
                    setClusterGridResponse(result.data);
                    setClusterGridColumnSetting(result.setting);
                    routedTripShow.current = { "route": result.data[0]?.Route, "data": "" };

                }
                else{
                    setClusterGridResponse([]);
                }
                setShowGridClusterLoader(false);
            }
        }
        catch (err) { console.log(err); }
    };

    async function GetAssignedVehiclesForTrip(data, iAssignedVehicleID, _iServiceStatusID, filteredResults){
        try {
            let currentdate = DateTimeUtils.getCurrentDate();
            if (RefSelectedDate.current === currentdate){// new Date().toISOString().split('T')[0]) {
                
                if (iAssignedVehicleID && iAssignedVehicleID !== "" && iAssignedVehicleID != null && iAssignedVehicleID != -1 && iAssignedVehicleID != "-1" && (_iServiceStatusID === "1" || _iServiceStatusID === "2" || _iServiceStatusID === "3")) {
                    
                    await GetAssignedVehicleToTrip(data);
                    // let APIdata = {
                    //     "iServiceID": data.ServiceID,
                    // };
                    // await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        
                    //     setVehData([]);
                    //     //setVehData(response.data);
                    //     setAssignedVehicleToTrip([]);
                    //     setAssignedVehicleToTrip(response.data);
                    // });
                }
                // (filteredResults[0]?.ServiceStatus?.toUpperCase() === "ACTIVE" || filteredResults[0]?.ServiceStatus.toUpperCase() === "ASSIGNED" || filteredResults[0]?.ServiceStatus.toUpperCase() === "TRANSFERRED")

                else if(tripType.current != "Routed-2"){
                    let refIDNewGrid = (filteredResults.length > 0 ? (filteredResults[0]["Confirmation #"] ? String(filteredResults[0]["Confirmation #"]) : "") : "");
                    let RefID = (filteredResults.length > 0 ? (filteredResults[0].iRefID ? String(filteredResults[0]?.iRefID) : (refIDNewGrid.length > 0 ? refIDNewGrid.slice(1) : "")) : "")
                    await GetNearByVehicles(filteredResults[0], RefID);
                    // let APIdata = {
                    //     "pulat": filteredResults[0]?.PickupLatitude,
                    //     "pulong": filteredResults[0]?.PickupLongitude,
                    //     "nwheelchairs": String(filteredResults[0]?.nTotalWheelChairs),
                    //     "iatspid": String(filteredResults[0]?.iSRATSPID),
                    //     "bshowoccupiedvehicles": IsShowOccupiedVehicles.current.toString(),
                    //     "irefid": RefID,
                    // };

                    // await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                    //     setVehData([]);
                    //     setVehData(response.data);
                    // });
                }
            }
            else {
                setVehData([]);
            }
        } catch (error) {
            
        }
    }

    const GridRowDoubleClick = async (data, autoDoubleClick = false, performed = false) => {
        try {

            
            setMapViewFromDoubleClick(!autoDoubleClick);
            
            if(data)
            {
                let isManifest = (data.vManifestNumber && data.vManifestNumber !== '' ? true : (data.ManifestNo && data.ManifestNo !== '' ? true : false));
                if(isManifest){
                    handleRowResize(ClusterGridheight.current);
                }
                else
                {
                    handleRowResize(100);
                }
            }
            // someThingChangedInGrid.current = false;
            let pickupFullAddress = "";
            let dropoffFullAddress = "";
            let riderName = "";
            let scheduledPUTime = "";
            let scheduledDOTime = "";
            //setVehData([]);
            let bIsSelectedTripWithIn30Mins = true;
            try {
                let SelectedRowDateTime = new Date();
                SelectedRowDateTime = CommonFunctions.ParseFormatADate(data.PickupDateTime.replace(/ {2}/g, ' '));
                if (Object.prototype.toString.call(SelectedRowDateTime) === "[object Date]") {
                    // it is a date
                    if (isNaN(SelectedRowDateTime)) { // d.getTime() or d.valueOf() will also work
                        // date object is not valid
                        SelectedRowDateTime = new Date();
                    } else {
                        // date object is valid
                    }
                } else {
                    // not a date object
                    SelectedRowDateTime = new Date();
                }
                bIsSelectedTripWithIn30Mins = CommonFunctions.isDateWithinFuture30Minutes(SelectedRowDateTime);
            }
            catch (tr) { bIsSelectedTripWithIn30Mins = true; }
            if (data.Route !== undefined) {
                riderName = "";
                scheduledPUTime = (data.PickupTime !== "" && data.PickupTime ? data.PickupTime : "N/A");
                scheduledDOTime = "";
                pickupFullAddress = data.PickupAddress;
                dropoffFullAddress = data.Destination;
                if (data.PickupPerson === "") {
                    riderName = "UNKWN";
                }
                else {
                    let nameSplit = data.PickupPerson.split(",");
                    riderName = nameSplit[(nameSplit.length - 1)] + " ";
                    for (let i = 0; i < nameSplit.length; i++) {
                        if (i < (nameSplit.length - 1)) {
                            riderName += nameSplit[i] + " ";
                        }
                    }
                }

                if (data.ApptTime !== "" && data.ApptTime !== null) {
                    if (data.ApptTime === "00:00") {
                        scheduledDOTime = "24:00";
                    }
                    else {
                        scheduledDOTime = data.ApptTime;
                    }
                }
                else {
                    scheduledDOTime = "N/A";
                }

                if (selectRowData.length <= 0) {selectRowData.push(data);}
                xCancelSourceForGrid.current = APICom.GenerateSource();

                let dispatchVeh = (data.VEHNo && data.VEHNo !== "" && data.VEHNo !== "None-R" ? data.VEHNo : "");
                let iAssignedVehicleID = data.iAssignedVehicleId;
                let _singleTripiServiceStatusID = data.iServiceStatusID;
                setClusterGridResponse([]);
                let response = await GetRouteStopView(data.vManifestNumber, data.PrimaryAffiliateID, data.ConfirmationNo, {fetchMode: 1, performed: performed});
                let result = response.data;
                
                let currentdate = DateTimeUtils.getCurrentDate();
                if (RefSelectedDate.current === currentdate)
                {
                    if (iAssignedVehicleID && iAssignedVehicleID !== "" && iAssignedVehicleID != null && 
                        iAssignedVehicleID != -1 && iAssignedVehicleID != "-1" && 
                            (
                            _singleTripiServiceStatusID === "1" || 
                            _singleTripiServiceStatusID === "2" ||
                            _singleTripiServiceStatusID === "3")) 
                    {
                        await GetAssignedVehicleToTrip(data);
                        // let APIdata = {
                        //     "iServiceID": data.ServiceID,
                        // }
                        // await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        //     setVehData([]);
                        //     //setVehData(response.data);
                        //     setAssignedVehicleToTrip([]);
                        //     setAssignedVehicleToTrip(response.data);
                        // });
                    }
                    else if(tripType.current != "Routed-2") {
                        let RefID = data.iRefID;
                        const dateStr = RefSelectedDate.current;
                        const timeStr = data.PickupTime;

                        const targetDt = new Date(`${dateStr}T${timeStr}`);
                        const now = new Date();

                        const diffHours = Math.abs(now.getTime() - targetDt.getTime()) / 36e5;

                        if (diffHours < 4 && (!iAssignedVehicleID || iAssignedVehicleID == "" || iAssignedVehicleID == null ||
                        iAssignedVehicleID == -1 || iAssignedVehicleID == "-1" )) {
                            await GetNearByVehicles(data, RefID);
                        }

                        // let APIdata = {
                        //     "pulat": data.PickupLatitude,
                        //     "pulong": data.PickupLongitude,
                        //     "nwheelchairs": String(data.nTotalWheelChairs),
                        //     "iatspid": String(data.iSRATSPID),
                        //     "bshowoccupiedvehicles": IsShowOccupiedVehicles.current.toString(),
                        //     "irefid": String(data.iRefID)
                        // }
                        // await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                        //     setVehData([]);
                        //     setVehData(response.data);
                        // });

                    }

                }
                else {
                    setVehData([]);
                }
                
                if (result !== null && result.data && result.data.length > 0) {
                    unroutedTripShow.current.unroutedTripConf = result.data[0]?.TripNo;
                    unroutedTripShow.current.data = "";
                    setclusterTableStateBeforeCompute(null);
                    setClusterGridResponse([]);
                    setClusterGridResponse(result.data);
                    setClusterGridColumnSetting(result.setting);
                }
            }
        }
        catch (err) { console.log(err); }
    };

    async function GetAssignedVehicleToTrip(data){
        try {
            let APIdata = {
                "iServiceID": data.ServiceID,
            }
            await APICom.fetchData("main", "TripActions/GetVehicleAssignedToTrip", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                //setVehData([]);
                //setAssignedVehicleToTrip([]);
                let updatedData;
                if (Array.isArray(response.data)) {
                    updatedData = response.data.map(item => ({
                        ...item,
                        isSingleVehicleCall: true,
                    }));
                    setVehData([]);
                    setVehData(updatedData);
                } 
                else if (response.data && typeof response.data === 'object') 
                {
                    let updatedDataArray;
                    updatedDataArray = [{
                        ...response.data,
                        isSingleVehicleCall: true,
                      }];
                      setVehData([]);
                      setVehData(updatedDataArray);
                }
               
                //setAssignedVehicleToTrip(response.data);
            });
        } catch (error) {
            
        }
    }

    async function GetNearByVehicles(data){
        try {
            let APIdata = {
                "pulat": data.PickupLatitude,
                "pulong": data.PickupLongitude,
                "nwheelchairs": String(data.nTotalWheelChairs),
                "iatspid": String(data.iSRATSPID),
                "bshowoccupiedvehicles": IsShowOccupiedVehicles.current.toString(),
                "irefid": String(data.iRefID)
            }
            await APICom.fetchData("main", "TripActions/getnearbyvehicles", "post", {}, APIdata, xCancelSourceForGrid.current).then((response) => {
                setVehData([]);
                //setAssignedVehicleToTrip([]);
                setVehData(response.data);
            });

        } catch (error) {
            
        }
    }
    

    const dispatchGridRowDoubleClick = async (table, row, deselectRow = true, callApis = true) => {
        try {

            if (deselectRow) {
                table.deselectRow();
                //row.select();
            }
            let rowData; //= row.getData();
            if (row && typeof row.getData === "function") {
                rowData = row.getData();
                // Use rowData
            }
            else{
                rowData = row;
            }
            ClusterGridSelectedRows.current = [];
            ClusterGridSrollVertical.current = 0;
            ClusterGridDataResetComplete.current = false;
            const { iSRATSPID } = rowData;
            let selectedrowRoute = rowData.Route;

            setTableRowsSel(rowData.id);
            if (typeof GridRowDoubleClick !== "undefined") {
                if (deselectRow) {
                    DropDownRouteValue.current = null;
                }
                
                if(selectedrowRoute === "" || selectedrowRoute === undefined){
                    IsRoutedTrip.current = false;
                    setIsRoutedTrip(false);
                    _iNoOfTripsInRoutes.current = 0
                }
                else{
                    IsRoutedTrip.current = true;
                    setIsRoutedTrip(true);
                }
                // setMapViewFromDoubleClick(true);
                // setMapView(true);
                // if (document.getElementById("tabulator_mapViewBtn") && document.getElementById("tabulator_mapViewBtn").textContent === "Map")
                // {
                //     try {
                //         let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === iSRATSPID.toString());
                //         let iTransType = filteredData[0].iTransType;
                //         if(iTransType !== 0){
                //             setShowCompletedTrips(false);
                //             checkboxSelectionFlag.current = false;
                //         }
                        
                //     } catch (error) {
                        
                //     }
                //     document.getElementById("tabulator_mapViewBtn").click();
                // }


                let isManifest = (rowData.vManifestNumber && rowData.vManifestNumber !== '' ? true : (rowData.ManifestNo && rowData.ManifestNo !== '' ? true : false));
                if(isManifest){
                    handleRowResize(ClusterGridheight.current);
                }
                else
                {
                    handleRowResize(100);
                }

                if (selectedrowRoute !== "") {
                    setSelectedStopsData([]);
                    selectedTripInfo.current = rowData;//row.getData();
                    selectedTripInfoToRefreshGrid.current = rowData;//row.getData();
                    //let rowData = row.getData();
                    if(rowData.vManifestNumber && rowData.vManifestNumber !== ''){
                        let iSRATSPID = rowData.iSRATSPID;
                        let iTransType = GetTransTypeOfAffiliate(iSRATSPID);
                        if(iTransType == undefined || iTransType == null){
                            iTransType = 0;
                        }
                        //tripType.current = "Routed-" + iTransType;
                        SetTripType("Routed-" + iTransType)
                        if(callApis){
                            await handleClusterManifestData(rowData/*row.getData()*/, checkboxSelectionFlag.current);
                        }
                    }
                    else{
                        tripType.current = "";
                    }
                }
                else if (selectedrowRoute === "") {
                    setSelectedStopsData([]);
                    selectedTripInfo.current = rowData;//row.getData();
                    selectedTripInfoToRefreshGrid.current = rowData;//row.getData();
                    let iSRATSPID = rowData.iSRATSPID;//row.getData().iSRATSPID;
                    let iTransType = GetTransTypeOfAffiliate(iSRATSPID);
                    if(iTransType == undefined || iTransType == null){
                        iTransType = 0;
                    }
                    //tripType.current = "Routed-" + iTransType;
                    SetTripType("Routed-" + iTransType)
                    if(callApis){
                        await GridRowDoubleClick(rowData/*row.getData()*/, false, checkboxSelectionFlag.current);
                    }
                }

                setTimeout(() => {
                    setSelectedRoute(""); 
                }, 500);

                selectedRouteTimeout.current = setTimeout(() => {
                    setSelectedRoute(rowData.vManifestNumber/*row.getData().vManifestNumber*/);
                }, 1000);
                setTimeout(() => {
                    row.select();
                }, 1000);
            }
        } catch (error) {
            IsRoutedTrip.current = true;
            setIsRoutedTrip(false);
         }
    };

    function SetTripType(type){
        try {
            tripType.current = type;
        } catch (error) {
            tripType.current = "";
        }
    }

    function normalizeToDateString (input) {
        try{
            if(input === null || typeof input === 'undefined' || input === ''){ return null; }
            const date = input instanceof Date ? input : new Date(input + ' 00:00:00');

            if (isNaN(date)){ return null; } // invalid date handling

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // zero-padded
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        } catch (err) {console.log(err);}
    }
    
    const GetTransTypeOfAffiliate = (iSRATSPID) =>{
        try {
            let selectedAffiliate = AffiliateData.find((affiliate) => affiliate.AffiliateID === parseInt(iSRATSPID))
            return selectedAffiliate.iTransType;
        } catch (error) {
            return null;
        }
    };

    const PrepareClusterGridRequest = async () => { };

    const PrepareCompletedGridRequest = async (bFilterChange = false) => {
        try{
            const fromDate = normalizeToDateString(completeDateRangeRef.current.from);
            const toDate = normalizeToDateString(completeDateRangeRef.current.to);
            if(fromDate && toDate && (completeDateRangeRef.current.oldRange !== fromDate || bFilterChange)) {
                completeDateRangeRef.current.oldRange = fromDate;
                setShowGridLoader(true);
                let settingsData = [];
                let tripsData = [];
                let fsIDsList = (String(toolboxRef.current.FSList) === "" ? "" : String(toolboxRef.current.FSList).replace(/-\d+/g, ""));
                let data = {
                    userAffiliateID: parseInt(loginData.iUserAffiliateID),
                    assignedAffiliateIDs: String(toolboxRef.current.AffiliatesList),
                    fundingSourceIDs: fsIDsList,
                    userID: loginData.recordID,
                    fromDate: fromDate,
                    toDate: toDate
                };
                
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("ReservationCoreURL","GridData/GetCompletedGridData", "post", {}, data, xCancelSourceForGrid.current);
                if(response && response.error === "")
                {
                    // console.log(response);
                    if(response.data)
                    {
                        if(response.data.TripsJSON && response.data.TripsJSON.length > 0 && response.data.Settings && response.data.Settings.length > 0)
                        {
                            let tripsJSON = response.data.TripsJSON;
                            settingsData = response.data.Settings;
                            if(toolboxRef.current.AttrList !== ""){
                                const filterArr = new Set(toolboxRef.current.AttrList.split(","));
                                tripsData = tripsJSON.filter((item)=>{
                                    if(!item.vAttributes && item.vAttributes === "")
                                        return false;
                                    let tripAttributesArr = (AttributeData ? AttributeData.filter((main)=>{return String(item.vAttributes.trim().toUpperCase()).includes(main.DisplayTitle.toUpperCase());}) : []);
                                    return tripAttributesArr.some(val => filterArr.has(String(val.ID)));
                                });
                            }
                            else
                            {
                                tripsData = tripsJSON;
                            }
                            
                            setCompletedQueueColSetting(settingsData);
                            if(tripsData.length > 0)
                            {
                                let activeRows = (completedTableObj.current ? completedTableObj.current.getRows('active') : []);
                                if(activeRows.length > 0 && completedTableObj.current)
                                {
                                    completedTableObj.current.setData(tripsData);
                                }
                                else
                                    setCompletedQueueData(tripsData);
                            }
                            else
                            {
                                let firstRowData = response.data.TripsJSON[0];
                                if(firstRowData["Confirmation #"])
                                    firstRowData["Confirmation #"] = -1;
                                setCompletedQueueData([firstRowData]);
                                // StandingOrderTableObj.current.setData([firstRowData]);
                            }
                        }
                        else
                        {
                            settingsData = (response.data.Settings && response.data.Settings.length > 0 ? response.data.Settings : []);
                            let firstRowData = {};
                            
                            if(settingsData.length > 0) {
                                for(let i = 0; i < settingsData.length; i++){
                                    if(settingsData[i].bVisible){
                                        if(settingsData[i].vName === 'Confirmation #'){
                                            firstRowData[(settingsData[i].vName)] = -1;
                                        }
                                        else
                                        {
                                            firstRowData[(settingsData[i].vName)] = '';
                                        }
                                    }
                                }
                            }
                            setCompletedQueueColSetting(settingsData);
                            setCompletedQueueData([firstRowData]);
                            // StandingOrderTableObj.current.setData([firstRowData]);
                        }
                        
                    }
                }
                setShowGridLoader(false);
            }
        }
        catch(err){console.log(err); setShowGridLoader(false);}
    };

    const PrepareStandingOrderRequest = async () => {
        try {
            setShowGridLoader(true);
            let settingsData = [];
            let tripsData = [];
            let fsIDsList = (String(toolboxRef.current.FSList) === "" ? "" : String(toolboxRef.current.FSList).replace(/-\d+/g, ""));
            let data = {
                userAffiliateID: parseInt(loginData.iUserAffiliateID),
                assignedAffiliateIDs: String(toolboxRef.current.AffiliatesList),
                fundingSourceIDs: fsIDsList,
                userID: loginData.recordID
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            let response = await APICom.fetchData("ReservationCoreURL", "GridData/GetStandingOrderGridData", "post", {}, data, xCancelSourceForGrid.current);
            if (response && response.error === "") {
                if (response.data) {
                    if (response.data.TripsJSON && response.data.TripsJSON.length > 0 && response.data.Settings && response.data.Settings.length > 0) {
                        let tripsJSON = response.data.TripsJSON;
                        settingsData = response.data.Settings;
                        if (toolboxRef.current.AttrList !== "") {
                            const filterArr = new Set(toolboxRef.current.AttrList.split(","));
                            tripsData = tripsJSON.filter((item) => {
                                if (!item.vAttributes && item.vAttributes === "")
                                    return false;
                                let tripAttributesArr = (AttributeData ? AttributeData.filter((main) => { return String(item.vAttributes.trim().toUpperCase()).includes(main.DisplayTitle.toUpperCase()); }) : []);
                                return tripAttributesArr.some(val => filterArr.has(String(val.ID)));
                            });
                        }
                        else {
                            tripsData = tripsJSON;
                        }

                        setSOGridColSetting(settingsData);
                        if(tripsData.length > 0)
                        {
                            let activeRows = (StandingOrderTableObj.current ? StandingOrderTableObj.current.getRows('active') : []);
                            if (activeRows.length > 0 && StandingOrderTableObj.current) {
                                StandingOrderTableObj.current.setData(tripsData);
                            }
                            else
                                setSOGridData(tripsData);
                        }
                        else {
                            let firstRowData = response.data.TripsJSON[0];
                            if (firstRowData["Confirmation #"])
                                firstRowData["Confirmation #"] = -1;
                            setSOGridData([firstRowData]);
                            // StandingOrderTableObj.current.setData([firstRowData]);
                        }
                    }
                    else {
                        settingsData = (response.data.Settings && response.data.Settings.length > 0 ? response.data.Settings : []);
                        let firstRowData = (standingOrderGridData.length > 0 ? standingOrderGridData[0] : {});
                        if (firstRowData["Confirmation #"])
                            firstRowData["Confirmation #"] = -1;
                        setSOGridData([firstRowData]);
                        // StandingOrderTableObj.current.setData([firstRowData]);
                    }

                }
            }
            setShowGridLoader(false);
        }
        catch (err) { console.log(err); setShowGridLoader(false); }
    };

    const PrepareGridRequest = useCallback(async (type = '') => {
        
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        let SavedDate = PersistStorage.retrieve("DispatchToolBarDate", false);
        //timerRef.current = setTimeout(() => {
            setTimeTakenByLastGridCall(0);
            APICom.LastGridCall = new Date();
            if (ToolboxValues.Date === "" || ToolboxValues.AffiliatesList === "") { return; }
             //if(ToolboxValues.Date != SavedDate){
             //    RefSelectedDate.current = SavedDate;
             //}
             //else{
             //    RefSelectedDate.current = ToolboxValues.Date;
             //}
            if (ToolboxValues.Date !== "") {
                // This ToolboxValues.Date is coming from DispatchMainToolbar
                RefSelectedDate.current = ToolboxValues.Date; //saving DOM selected date because we need this when showing cluster grid. If not saved here it shows empty date
            }
            if(DispatchGridControlRef.current && typeof DispatchGridControlRef.current.ToolboxUpdate === 'function'){
                
                DispatchGridControlRef.current.ToolboxUpdate(ToolboxValues, type);
            }
        //}, 1000);
    }, [ToolboxValues]);


    const ShowMultiSchData = async (refID) => {
        try {
            const response = await APICom.fetchData("AspDotNetCoreURL", `TripHistoryReports/GetMultiScheduleReport?refid=${refID}`, "get", {}, {});

            if (response && response.error.length === 0) {
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    //Data generated
                    await GenerateMultiSchReport(response.data);
                }
                else if (response.data && response.data.length === 0) {
                    setModalHeaderText("Multi-Schedule Report Alert");
                    setModalBodyHTML(<p>{"There is report data for this trip, please contact the administrator."}</p>);
                    setModalBtnHTML(
                        <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                            {"OK"}
                        </Button>
                    );
                    setShowDynamicModal(true);
                }
            }
            else {
                setModalHeaderText("Multi-Schedule Report Alert");
                setModalBodyHTML(<p>{(response.error.length > 0 ? response.error : "There was an issue with the API, please contact the administrator.")}</p>);
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
            }
        }
        catch (err) { console.log(err); }
    };

    const GenerateMultiSchReport = async (dataArr) => {
        try {
            // let JSONData = JSON.stringify(dataArr);
            let myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            let headersObj = headersToObject(myHeaders);
            let reportingURL = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API + "ShowMultiScheduleReport";
            let ReportResponse = await APICom.fetchData("full", reportingURL, "post", headersObj, dataArr, null, false, {}, 'blob');
            if (ReportResponse && ReportResponse.error.length === 0) {
                const blob = new Blob([ReportResponse.data], { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_MultiSchReportPDF');
                URL.revokeObjectURL(pdfUrl);
            }
            else {
                setModalHeaderText("Multi-Schedule Report Alert");
                setModalBodyHTML((ReportResponse.error.length > 0 ? ReportResponse.error : "There was an issue with the API, please contact the administrator."));
                setModalBtnHTML(
                    <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                        {"OK"}
                    </Button>
                );
                setShowDynamicModal(true);
            }
        }
        catch (err) { console.log(err); }
    };

    const handleSelectedRouteChange = (value, iTotalNoOfTrips) => {
        manifestDataReceivedCheckRef.current = true;
        routedTripShow.current = { "route": value, "data": "" };
        setselectedManifest(value);
        handleRowResize(ClusterGridheight.current);
        _iNoOfTripsInRoutes.current = iTotalNoOfTrips;
    };

    const handleDropDownRouteChange = (route) => {
        try {
            //someThingChangedInGrid.current = true;
            DropDownRouteValue.current = route;
            selectedTripInfoToRefreshGrid.current = null
        }
        catch (err) { console.log(err); }
    };

    const handler = (e) => {
        try {
            // e.preventDefault();
            if ((e.key === 'x' || e.key === 'X') && e.ctrlKey) { //Cancel & Activate: CTRL + X
                if (mainTableObj.current.getHeaderFilters().length === 0) {
                    e.preventDefault();
                    let tripStatusCollection = [];
                    for (var k = 0; k < selectRowData.length; k++) {
                        tripStatusCollection.push(selectRowData[k].TripRequestStatus.toUpperCase());
                    }

                    if (tripStatusCollection.includes("NOSHOW") || tripStatusCollection.includes("NOSHOWED") || 
                        tripStatusCollection.includes("CANCELLED") || tripStatusCollection.includes("CANCELLEDARQ") || tripStatusCollection.includes("CANCELLEDSRQ")) {
                        if (!showActivateDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                            if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripActivate")){
                                return;
                            }
                            setShowActivateDialog(true);
                        }
                    }
                    else {
                        if (!showCancel && document.getElementsByClassName("modal-dialog").length === 0) {
                            if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripCancel")){
                                return;
                            }
                            try {
                                if (selectRowData.length === 1) {
                                    let rowData = selectRowData[0];
                                    let vBookingID = rowData["PaymentExtention2"];
                                    let iATSPID = rowData["iSRATSPID"];
                                    let iFSID = rowData["iFundingSourceID"];
                                    let BrokerCancelReasons = FillBrokerCancelReasonsByObject(BrokerCancelReasonData, iATSPID, iFSID);
                                    
                                    if (typeof (vBookingID) != 'undefined' && vBookingID != "" && BrokerCancelReasons != "") {
                                        setBrokerCancelReasonsHtml(BrokerCancelReasons);
                                        setBrokerCancelTripInfo(rowData);
                                        setShowBrokerCancelDialog(true);
                                    } else {
                                        setShowMultiTripCancellationDialog(true);
                                    }
                                } else {
                                    let hasBrokerTrip = false;
                                    for (let i = 0; i < selectRowData.length; i++) {
                                        let BrokerCancelReasons = FillBrokerCancelReasonsByObject(BrokerCancelReasonData, selectRowData[i]["iSRATSPID"], selectRowData[i]["iFundingSourceID"]);
                                        let bkID = selectRowData[i]["PaymentExtention2"];
                                        if (typeof bkID !== 'undefined' && bkID !== "" && BrokerCancelReasons != "") {
                                            hasBrokerTrip = true;
                                            break;
                                        }
                                    }
                                    
                                    if (hasBrokerTrip) {
                                        setModalHeaderText("Cancel Alert");
                                        setModalBodyHTML(<p>{"Please select a single broker trip to continue."}</p>);
                                        setModalBtnHTML(
                                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                                {"OK"}
                                            </Button>
                                        );
                                        setShowDynamicModal(true);
                                    } else {
                                        setShowMultiTripCancellationDialog(true);
                                    }
                                }
                            } catch (ex) { console.log(ex); }
                        }
                    }
                }


            }
            // else if ((e.key === 'a' || e.key === 'A') && e.altKey){ //Activate: Alt + A

            // }

            // else if ((e.key === 'h' || e.key === 'H') && e.altKey){ //Trip History: Alt + H
            //     if (!showTripHistoryDialog && document.getElementsByClassName("modal-dialog").length === 0) {
            //         showTripHistoryDialog(true);
            //     }
            // }
            else if ((e.key === 'g' || e.key === 'G') && e.ctrlKey) { //Grouping: Ctrl + G
                e.preventDefault();
                if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_GroupingActions")){
                    return;
                }
                if (!showGroupingDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                    setShowGroupingActionDialog(true);
                }
            }
            else if ((e.key === 'q' || e.key === 'Q') && e.ctrlKey) { //Clustering: Ctrl + Q
                e.preventDefault();
                if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_ClusteringActions")){
                    return;
                }
                if (!showClusteringDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                    setGridRefreshPaused(true);
                    setShowClusterDialog(true);
                }
            }
            else if ((e.key === 'b' || e.key === 'B') && e.ctrlKey) { //Broker: Ctrl + B
                e.preventDefault();
                if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_BrokerActions")){
                    return;
                }
                if (!showBrokerActionsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                    setBrokerActionsDialog(true);
                }
            }
            else if ((e.key === 'd' || e.key === 'D') && e.ctrlKey) { //Trip Actions: Ctrl + D
                if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_m_TripActions")){
                    return;
                }
                e.preventDefault();
                if (!showTripActionsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                    setShowTripActionsDialog(true);
                }
            }
            else if ((e.key === 'i' || e.key === 'I') && e.ctrlKey) { //Trip Info: CTRL + I
                if(!ModuleSecurity.CheckModuleSecurityByTag("tag_d2_TripEdit")){
                    return;
                }
                e.preventDefault();
                if (!showTripDetailsDialog && document.getElementsByClassName("modal-dialog").length === 0) {
                    let selectedRows = mainTableObj.current.getSelectedRows();
                    if (selectedRows.length > 1) {
                        setModalHeaderText("Trip Details Alert");
                        setModalBodyHTML(<p>{"Please select a single trip to edit."}</p>);
                        setModalBtnHTML(
                            <Button variant="dark" className="mx-1 border-0" onClick={() => setShowDynamicModal(false)}>
                                {"OK"}
                            </Button>
                        );
                        setShowDynamicModal(true);
                    }
                    else if (selectedRows.length === 1) {
                        PersistStorage.save("IsTripDetailsDialogOpened", true, 10, false);
                        setTripDetailsDialog(true);
                    }
                }
            }
        } catch (err) { }
    };

    const UnMountAgileDispatch = () => {
        setShowAgileDispatch(false);
    };

    const handleClusterGridResponse = () => {
        console.log("reload");
    };

    function updateCheckboxState() {
        const checkbox = document.getElementById('clusterTableGrid_checkbox');
        if (checkbox && checkbox.checked) {
            // console.log("Unchecked made true");
            checkbox.checked = false; // true to check, false to uncheck
        }
    }

    function headersToObject(headers) {
        try {
            let result = {};
            for (let [key, value] of headers.entries()) {
                result[key] = value;
            }
            return result;
        }
        catch (err) { console.log(err); return []; }
    };

    function updateNumTripsInRoute() {
        try {
            if (mainTableObj?.current) {
                let data = mainTableObj?.current.getData();
                let vRoute = selectRowData[0]?.Route;
                const filteredNumbers = data.filter(row => row?.Route === vRoute);
                setNumTripsInRoute(filteredNumbers.length);
            }
        } catch (err) { console.log(err); }
    }

    
    const [doubleClickVersion, setDoubleClickVersion] = useState(0);
    

    const clickTimer = useRef(null);
    function getDispatchGridControlOptions() {
        try {
            return {
                height: 'auto',
                heightoffset: 132,
                calculateHeight: true,
                pagination: true,
                paginationMode: "local",
                paginationSize: 1000,
                paginationSizeSelector: [100, 300, 500, 1000, 5000],
                selectable: true,
                reactiveData: true, //enable data reactivity
                layout: "fitDataStretch",
                placeholder: "No Trips Available",
                clipboard: true,
                mapHeight: "auto",
                selectableRangeMode: "click",
                GridName: "tabulator",
                paginationCounter: "rows",
                intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined ? 60000 : GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value * 2000,
                EnableProgressBar: true,
                index: "ConfirmationNo",
                movableColumns: true,
                movableRows: false,
                vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
                bSysUser: 1,
                intervalEnable: true,
                persistence: true,
                bWebApplySettingToAll: false,
                mapClass: "col-6 d-inline-flex",
                ID_Column: "ConfSchDtl",
                GridReturnOnlyIDColumnInRowData: false,
                AlwaysHiddenColumns: ["AffPhoneNo", "AssignedDriverId", "CallbackInfo", "CallbackMethod", "CallOutStatus", "CallRecieve", /*"CancelComment",*/ "CheckInState", "DateCallback", "DateCreation", "DispatchedBy", "DispatchMethod", "DODev", "DriverCellPhone", "DriverHomePhone", "DriverNearDropLoc", "DriverPhone", "DropCity", "DropLatitude", "DropLongitude", "DropState", "DropZip", "EstCostSort", "ExtraInformation", "iAssignedVehicleId", "iClassOfServiceID", "iCreatedByAppID", "iFundingSourceID", "iMVOriginalATSPID", "iMVRouteATSPID", "iRefID", "iScheduleID", "iSpecialDriverId", "iSpecialVehicleId", "iVehicleTypeId", "LastModifiedBy", "MilesPickOrDrop", "PaymentExtention1", "PaymentExtention3", "PickupCity", "PickupLatitude", "PickupLongitude", "PickupSort", "PickupState", "PickupZip", "PromoAmount", "PromotionCode", "ProviderMileage", "PUDev", "ShowDAffiliateTripsToATSP", "StandingRoute", "TotalCancelled", "TotalNoShows", "TripAttributes", "vCompanyPBXAPIURL"/*,"vManifestNumber"*/, "vMarsID", "vPBXCompany", "VREQ", "CDFTypeID", "PUSortTime"],
                saveCCSettingsOption: true,
                mapView: mapView,
                contextMenuSetting: ContextMenuArray,
                MasterMenu: MasterDispatchContextMenu,
                MasterMenuLabels: CONTEXT_MENU_LABELS,
                //rowContextMenu: ContextMenuArray,
                selectedRoute: SelectedRoute,
                MasterMenu: MasterDispatchContextMenu,
                MasterMenuLabels: CONTEXT_MENU_LABELS,
                containerClass: "col",
                Containerstyle: {},
                frozenState: true,
                sortCondition: true,
                groupByColumns: [],//["No Column Grouping", "Group", "Attribute", "TripRequestStatus", "FundingSource", "Route"],
                GridGroupedColumns: ["No Column Grouping", "Group", "Attribute", "TripRequestStatus", "FundingSource", "Route", "PZONE", "DZONE", "PickupCity", "DropCity", "Vehicle", "Driver"],
                tableDoubleClickFunc: async function (table, row, IsSingleSelectionChange) {


                    setDoubleClickVersion(prev => prev + 1);

                    
                    console.log("Dispatch tableDoubleClickFunc");
                    selectedTripFromDispatchQueue.current = -1;
                    selectedTripFromDispatchQueue.current = row;
                    selectedTripFromDispatchQueue.current._row.data.PlotVehicle = true;

                    let PlotVehicle_ConfirmationNo = localStorage.getItem("DispatchQ_PlotVehicle");
                    if(PlotVehicle_ConfirmationNo){
                      let dataJson = JSON.parse(PlotVehicle_ConfirmationNo);
                      if(dataJson.data != selectedTripFromDispatchQueue.current._row.data.ConfirmationNo){
                        //localStorage.removeItem("DispatchQ_PlotVehicle");
                      }
                    }

                    PersistStorage.save("DispatchQ_PlotVehicle", selectedTripFromDispatchQueue.current._row.data.ConfirmationNo, 120, true);
                    // if(MainMapOpened){
                    //     return;
                    // }

                    //setTimeout(() => {
                        
                   
                    setMapViewFromDoubleClick(true);
                    setMapView(true);
                    if (document.getElementById("tabulator_mapViewBtn") && document.getElementById("tabulator_mapViewBtn").textContent === "Map")
                    {
                        try {
                            let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === selectedTripFromDispatchQueue.current._row.data.iSRATSPID.toString());
                            let iTransType = filteredData[0].iTransType;
                            if(iTransType !== 0){
                                setShowCompletedTrips(false);
                                checkboxSelectionFlag.current = false;
                            }
                            
                        } catch (error) {
                            
                        }
                        document.getElementById("tabulator_mapViewBtn").click();
                    }
                //}, 2000);
                    dispatchGridRowDoubleClick(table, row);// We set the map to visible inside this call
                },
                footerElement:
                '<select class="tabulator_btns raised-button border border-dark " title="Export To Excel" id="'
                + "tabulator" + '_ExportToExcel"><option value="">-- Export --</option></select>'
                + '<button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                + "tabulator" + '_ClearFilter" title="Clear Filters" id="' + "tabulator" + '_ClearFilter"></button><button class="tabulator_btns lastTabulator-btn raised-button border border-dark " title="Reload Data" id="'
                + "tabulator" + '_RefreshData"></button><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                + "tabulator" + '_DeSelectAll" title="Deselect Selected" id="' + "tabulator" + '_DeSelectAll"></button> '
                + ' <div class="tabulator_group_' + "tabulator" + '"><button class="tabulator_btns middleTabulator-btns raised-button border border-dark '
                +   "tabulator" + '_ExpandCollapse" title="Collapse Grouped Trips" id="' + "tabulator" + '_ExpandCollapse"></button>'
                +   '<select class="tabulator_btns gridgroupedcols DropdownArrow raised-button border border-dark " id="gridgroupedcolstabulator" style="cursor:pointer; width:auto; margin-left:-2px;">'
                +   '</select><button class="tabulator_btns middleTabulator-btns raised-button border border-dark" style="display:none;" '
                +   "tabulatorSaveSettings" + '" title="Collapse Grouped Trips" id="tabulatorSaveSettings">Save Grid Settings</button></div><span class="middleTabulator-btns fw-normal'
                + "tabulator" + '_recordSelected" id="' + "tabulator" + '_selectedRecords" style="font-size:small"></span><div class="progress lastTabulator-btn rounded-0 text-center user-select-none" style="width:55px"><div class="progress-bar'
                + 'progress-bar-striped tabulatorProgressBar" aria-valuemin="0" aria-valuemax="100"></div></div><div><span'
                + " class=tabulator" + '_classapiErrorMsg" id="' + "tabulator" + '_apiErrorMsg" style="font-size:small">adfadfadfadf</span></div>',
                footerElementHandles: function (table) {
                    mainTableObj.current = table;
                    //<button class="tabulator_btns" title="Select Column To Group By" id="'+"tabulator"+'_ColSelectGrouping"></button>
                    // var img = document.createElement("img");
                    // img.style.cssText = "width:16px; height:16px";
                    // img.src = saveIcon;
                    // document.getElementById("tabulator_ExportToExcel").appendChild(img);
                    const groups = mainTableObj.current.getGroups();
                    const isOpen = (groups.length > 0 ? groups[0].isVisible() : false);
                    let img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px";
                    img.src = clearFilterIcon;
                    document.getElementById("tabulator_ClearFilter").appendChild(img);
                    // img = document.createElement("img");
                    // img.style.cssText = "width:16px; height:16px";
                    // img.src = selectAllIcon;
                    // document.getElementById("tabulator_SelectAll").appendChild(img);
                    img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px";
                    img.src = deSelectIcon;
                    document.getElementById("tabulator_DeSelectAll").appendChild(img);
                    img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px";
                    img.src = refreshIcon;
                    document.getElementById("tabulator_RefreshData").appendChild(img);
                    
                    img = document.createElement("img");
                    img.style.cssText = "width:16px; height:16px";
                    img.id = "expandCollapseImg";
                    img.src = collapseIcon;
                    document.getElementById("tabulator_ExpandCollapse").appendChild(img);

                    if (document.getElementById('tabulator_selectedRecords').innerHTML === "") {
                        document.getElementById('tabulator_selectedRecords').innerHTML = "[No Trips Selected]";
                    }
                    //select row on "select all" button click
                    // document.getElementById('tabulator_SelectAll').addEventListener("click", function () {

                    //     table.selectRow();
                    // });
                    //deselect row on "deselect all" button click
                    document.getElementById('tabulator_DeSelectAll').addEventListener("click", function () {
                        table.deselectRow();
                    });
                    document.getElementById("tabulator_ExportToExcel").addEventListener("click", function (event) {
                        let dropdown = document.getElementById("tabulator_ExportToExcel");
                        dropdown.innerHTML = "";
                        let select = document.createElement("select");
                        select.style.width = "100%";
                        select.style.padding = "8px";
                        select.style.marginTop = "10px";
                        select.style.border = "1px solid #ccc";
                        select.style.borderRadius = "5px";
                        select.style.cursor = "pointer";
                        select.style.fontSize = "16px";
                        select.select = true;

                        let emptyOption = document.createElement("option");
                        emptyOption.text = "-- Export --";
                        emptyOption.value = "";
                        dropdown.appendChild(emptyOption);

                        let csvOption = document.createElement("option");
                        csvOption.text = "Default Export";
                        csvOption.value = "defaultExport";
                        dropdown.appendChild(csvOption);

                        let excelOption = document.createElement("option");
                        excelOption.text = "Special Export";
                        excelOption.value = "spcFrmtExprt";
                        dropdown.appendChild(excelOption);

                        dropdown.addEventListener("change", function () {
                            if (dropdown.value) {
                                 
                                if (dropdown.value == "defaultExport") {
                                    defaultTableExportAsExcel(table);
                                }
                                else if (dropdown.value == "spcFrmtExprt") {
                                    let data = table.getData('active');
                                    data = data.map(row => ({
                                        ...row,
                                        SchedulePickTime: (row?.PickupTime != "" && row?.SchedulePickTime == "") ? "Will Call" : row.SchedulePickTime,
                                        PickupDateTime: row?.PickupDateTime ? row.PickupDateTime.replace(/(AM|PM)/, " $1") : row.PickupDateTime, // Adding space before AM or PM
                                        "Early/Late Mins": 
                                                row?.SchedulePickTime && row?.PickupDateTime
                                                ? moment(
                                                    row.PickupDateTime.replace(/(AM|PM)/, " $1"),
                                                    "MM/DD/YYYY hh:mm A"
                                                ).diff(
                                                    moment(
                                                    moment(row.PickupDateTime, "MM/DD/YYYY hh:mmA").format("MM/DD/YYYY") +
                                                        " " +
                                                        row.SchedulePickTime,
                                                    "MM/DD/YYYY hh:mm A"
                                                    ),
                                                    "minutes"
                                                )
                                        : "",
                                    }));
                                    const requiredColumns = ['Affiliate', 'Route', 'AssignedDriver', 'VEHNo', 'SchedulePickTime',
                                        'PickupDateTime', 'PickupPerson', 'Phone', 'nTotalWheelChairs', 'PickupAddress', 'Destination',
                                        'ExtraInformation', 'EstimatedDistance', 'EstimatedTime', 'Early/Late Mins'];
                                    const filteredData = data.map(row => {
                                        let filteredRow = {};
                                        requiredColumns.forEach(column => {
                                            if (row.hasOwnProperty(column)) {
                                                filteredRow[column] = row[column];
                                            }
                                        });
                                        return filteredRow;
                                    });
                                    groupEntriesAndDownloadAsExcel(filteredData);
                                }
                                let img = document.createElement("img");
                                img.style.cssText = "width:16px; height:16px";
                                img.src = saveIcon;
                                dropdown.innerHTML = "";
                                dropdown.appendChild(img);
                            }
                        });

                        dropdown.style.left = event.target.offsetLeft + "px";
                        dropdown.style.top = (event.target.offsetTop + event.target.offsetHeight) + "px";
                        dropdown.style.display = "block";
                    });
                    document.getElementById('tabulator_ClearFilter').addEventListener("click", function () {
                        table.clearHeaderFilter();
                    });
                    document.getElementById('tabulator_ExpandCollapse').addEventListener("click", function () {
                        try {
                            // console.log("tabulator_ExpandCollapse......................................................");
                            let element = document.getElementById("tabulator_ExpandCollapse");
                            let oldImage = document.getElementById("expandCollapseImg");
                            if (groupingFilterCheck.current.toLowerCase() !== "no column grouping") {
                                if (element.title.toLowerCase().includes("collapse")) {
                                    element.removeChild(oldImage);
                                    let img = document.createElement("img");
                                    img.style.cssText = "width:16px; height:16px";
                                    img.id = "expandCollapseImg";
                                    img.src = expandIcon;
                                    element.appendChild(img);
                                    element.title = "Expand Grouped Trips";
                                    table.setGroupStartOpen(false);
                                    table.setGroupBy(false);

                                    if (groupingFilterCheck.current === "Driver") {
                                        table.setGroupBy(function (row) {
                                          return `${row.AssignedDriverNo} - ${row.AssignedDriver}`;
                                        });
                                    }
                                    else if(groupingFilterCheck.current === "Vehicle"){
                                        table.setGroupBy(function (row) {
                                            return `${row.VEHNo}`;
                                          });
                                    }
                                    else {
                                        table.setGroupBy(groupingFilterCheck.current); // for single-column groupings
                                    }
                                }
                                else {
                                    element.removeChild(oldImage);
                                    let img = document.createElement("img");
                                    img.style.cssText = "width:16px; height:16px";
                                    img.id = "expandCollapseImg";
                                    img.src = collapseIcon;
                                    element.appendChild(img);
                                    element.title = "Collapse Grouped Trips";
                                    table.setGroupStartOpen(true);
                                    table.setGroupBy(false);
                                    table.setGroupBy(groupingFilterCheck.current);
                                }
                            }
                        }
                        catch (err) { console.log(err); }
                    });
                },
                rowSelectionChangeHandle:function (data, IsCtrlPressed = false, performDoubleClick = false, table = undefined) 
                {
                    function areAllRoutesEmpty(arr) {
                        return arr.every(dict => dict.Route === '')
                    }
                    
                    selectedTripInfoToRefreshGrid.current = data[0];
                    selectedTripFromDispatchQueue.current = data;
                    UpdateSelectedTripCounter(data);
                    return;
                    // console.log("Dispatch rowSelectionChangeHandle");

                    // if(performDoubleClick){
                    //    // dispatchGridRowDoubleClick(table, data);
                    // }
                    // if(MainMapOpened){
                    //     //dispatchGridRowDoubleClick(table, data);
                    // }

                    // try {
                    //     if(data?.length == 1 && data[0]?.Route == ""){
                    //         IsRoutedTrip.current = false;
                    //     }    
                    // } catch (error) {
                        
                    // }
                    

                    // if( IsRoutedTrip.current){
                    //     console.log("Routed Trip Selection");
                    //     return;
                    // }

                    // UpdateSelectedTripCounter(data);
                    
                    // //alert("row selection");
                    // DispatchTableObject.current = data;
                    // if(data.length == 1){
                    //     setVehData([]);
                    //     let PlotVehicle_ConfirmationNo = localStorage.getItem("DispatchQ_PlotVehicle");
                    //     if(PlotVehicle_ConfirmationNo){
                    //       let dataJson = JSON.parse(PlotVehicle_ConfirmationNo);
                    //       if(dataJson?.data && dataJson?.data == data[0].ConfirmationNo){
                    //         localStorage.removeItem("DispatchQ_PlotVehicle");
                    //         data[0].PlotVehicle = true;
                    //         PersistStorage.save("DispatchQ_PlotVehicle", data[0].ConfirmationNo, 120, true);
                    //         //dispatchGridRowDoubleClick(table, data);
                    //       }
                    //     }
                    //     PersistStorage.save("DispatchQ_PlotVehicle", data[0].ConfirmationNo, 120, true);
                    // }

                    // if (Array.isArray(data)) {
                    //     if (data.length === 1) {
                    //       if(data[0].DoubleClicked){
                    //           //data[0].PlotVehicle = true;
                    //           //data[0].DoubleClicked = false;
                    //       }
                    //       else{
                    //        // data[0].PlotVehicle = false;
                    //       }
                    //     } 
                    //     else {
                    //       data.forEach((trip, index) => {
                    //        if(index != 0){
                    //            // trip.PlotVehicle = false;
                    //         }
                    //       });
                    //     }
                    //   }

                    // selectedTripInfoToRefreshGrid.current = data[0];
                    // selectedTripFromDispatchQueue.current = data;
                    // function areAllRoutesEmpty(arr) {
                    //     return arr.every(dict => dict.Route === '')
                    // }
                    // if (data.length === 0) {
                    //     // if (document.getElementById('tabulator_selectedRecords').innerHTML != "[No Trips Selected]") {
                    //     //     document.getElementById('tabulator_selectedRecords').innerHTML = "[No Trips Selected]";
                    //     // }
                    //     if (routedTripShow.current.route !== "") {
                    //         routedTripShow.current = { "route": routedTripShow.current.route, "data": "" };
                    //     }

                    //     routedTripShow.current = { "route": routedTripShow.current.route, "data": "" };
                    //     unroutedTripShow.current = { "unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data": data };
                    // }
                    // // else if (data.length === 1) {
                    // //     document.getElementById('tabulator_selectedRecords').innerHTML = "[" + data.length + " Trip Selected]";
                    // // }
                    // // else {
                    // //     document.getElementById('tabulator_selectedRecords').innerHTML = "[" + data.length + " Trips Selected]";
                    // // }

                    // if (unroutedTripShow.current.unroutedTripConf !== "") {
                    //     if (data.length > 0) {
                    //         let sameTripFinder = data.find((item) => item.ConfirmationNo === unroutedTripShow.current.unroutedTripConf);
                    //         if (sameTripFinder !== undefined) {
                    //             unroutedTripShow.current = { "unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data": data };
                    //         }
                    //         else {
                    //             const result = areAllRoutesEmpty(data);
                    //             if (result) {
                    //                 unroutedTripShow.current = { "unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data": data };
                    //             }
                    //             else {
                    //                 const filteredArray = data.filter(obj => obj.Route == "");
                    //                 unroutedTripShow.current = { "unroutedTripConf": "", "data": filteredArray };
                    //             }
                    //         }
                    //     }
                    //     else if (data.length === 0) {
                    //         unroutedTripShow.current = { "unroutedTripConf": unroutedTripShow.current.unroutedTripConf, "data": "" };
                    //     }
                    // }
                    // else if (unroutedTripShow.current.unroutedTripConf === "" && data.length > 0) {
                    //     const result = areAllRoutesEmpty(data);
                    //     if (result) {
                    //         unroutedTripShow.current = { "unroutedTripConf": "", "data": data };
                    //     }
                    //     else {
                    //         const filteredArray = data.filter(obj => obj.Route == "");
                    //         unroutedTripShow.current = { "unroutedTripConf": "", "data": filteredArray };
                    //     }
                    // }

                    // if (routedTripShow.current.route !== "" && data.length > 0) {
                    //     if (data.length === 1 && data[0].Route === "") {
                    //         routedTripShow.current = { "route": routedTripShow.current.route, "data": data };
                    //     }
                    //     else if (data.length > 1) {

                    //         const result = areAllRoutesEmpty(data);
                    //         if (result) {
                    //             routedTripShow.current = { "route": routedTripShow.current.route, "data": data };
                    //         }
                    //         else {
                    //             const filteredArray = data.filter(obj => obj.Route != "");
                    //             routedTripShow.current = { "route": "", "data": filteredArray };
                    //         }
                    //     }
                    // }
                    // else if (routedTripShow.current.route !== "" && data.length === 0) {
                    //     routedTripShow.current = { "route": routedTripShow.current.route, "data": "" };
                    // }

                    // if(data?.length == 1 && IsRoutedTrip.current == false && data.some(obj => obj.Route == "")){
                    //     //alert("GridRowDoubleClick");
                    //     //await GridRowDoubleClick(data[0], false, checkboxSelectionFlag.current);
                    // }
                    // if(document.getElementById("tabulator_mapViewBtn").textContent == "Hide Map"){
                    //     //await GridRowDoubleClick(data[0], false, checkboxSelectionFlag.current);
                    //     //dispatchGridRowDoubleClick(table, data[0], false, true);// We set the map to visible inside this call
                    // }
                    // if(data?.length == 1)
                    // {
                    // }
                    // if(data != undefined){
                    //     setTimeout(() => {
                            
                    //         dispatchGridRowDoubleClick(table, data[0], false);
                    //     }, 2000);
                    // }
                    //Get stops view if there is any route selected // in-progress
                    // if(DropDownRouteValue?.current != undefined && DropDownRouteValue?.current != ""){
                    //     dispatchGridRowDoubleClick(table, row[0], false);
                    // }

                },
                GridScrollVertical: function (top, table = "") {
                    setGridRefreshPaused(false);
                    let multiSelectContainer = document.getElementsByClassName('multi-select')
                    if (multiSelectContainer.length > 0) {
                        multiSelectContainer[0].style.display = 'none';

                        try {
                            if (typeof table.previousValue !== 'undefined') {
                                if (table.previousValue !== null) {
                                    if (table.previousCellData) {
                                        table.previousCellData.row.data[table.previousCellData.column.field] = table.previousValue;
                                        table.updateData([table.previousCellData.row.data]);
                                    }
                                }
                            }
                        } catch (e) {
                        }
                    }

                },
                cellClickHandle: function (e, cell_data, table, cellPositionDetails) {
                    if(cell_data._cell.column.field != "Attribute"){
                        return;
                    }
                    let data_len = table.getSelectedData().length;
                    try {
                        if (typeof table.previousValue !== 'undefined') {
                            if (table.previousValue !== null) {
                                if (table.previousCellData &&
                                    (table.previousCellData.row !== cell_data._cell.row || table.previousCellData.column !== cell_data._cell.column)) {
                                    table.previousCellData.row.data[table.previousCellData.column.field] = table.previousValue;
                                    table.updateData([table.previousCellData.row.data]);
                                    let rowElement = table.previousCellData.row.getElement();

                                    if (rowElement) {
                                        rowElement.style.zIndex = '';
                                    }
                                }
                            }
                        }

                    } catch (e) { }

                    if (cell_data._cell.column.field === "Attribute" && data_len === 1) {

                        let attrSelection = AttributeData.filter((item) =>
                            parseInt(item.iAttrATSPID) === parseInt(cell_data._cell.row.data.iSRATSPID)
                        );

                        let attrOptionsSel = attrSelection.map((item) => ({
                            id: item.ID,
                            name: item.Title,
                            shortName: item.ShortTitle,
                            attrType: item.iAttrType
                        })).sort((a, b) => a.name.localeCompare(b.name));

                        try {
                            let isMultiSelectInAttribute = cell_data._cell.row.data.Attribute.includes('input')
                            let previousAttributeValue = ''
                            if (!isMultiSelectInAttribute) {
                                previousAttributeValue = cell_data._cell.row.data.Attribute;
                            }
                        } catch (e) { }
                        // Save the current cell data and value for future restoration

                        table.previousCellData = {
                            row: cell_data._cell.row,
                            column: cell_data._cell.column
                        };
                        if (typeof cell_data._cell.row.data[cell_data._cell.column.field] === 'string') {
                            table.previousValue = cell_data._cell.row.data[cell_data._cell.column.field];
                        }

                        const selectedValues = [];

                        const parentContainer = document.createElement('div');

                        parentContainer.style.height = '19px';
                        parentContainer.style.width = 'inherit';
                        parentContainer.style.top = (cellPositionDetails.y - 106) + 'px';
                        parentContainer.style.left = cellPositionDetails.x + 'px';
                        // parentContainer.style.border = '1px solid #ccc';
                        parentContainer.style.padding = '10px';
                        parentContainer.style.cursor = 'pointer';
                        parentContainer.style.position = 'fixed';
                        parentContainer.style.display = 'flex';
                        parentContainer.style.alignItems = 'center';
                        parentContainer.style.justifyContent = 'space-between';

                        // parentContainer.style.backgroundColor = '#fff';

                        const displayText = document.createElement('span');
                        displayText.textContent = 'Select Attribute';
                        displayText.style.flexGrow = '1';
                        displayText.style.whiteSpace = 'nowrap';
                        displayText.style.overflow = 'hidden';
                        displayText.style.textOverflow = 'ellipsis';

                        const dropdownIcon = document.createElement('span');
                        dropdownIcon.textContent = '▼';
                        dropdownIcon.style.marginLeft = '10px';
                        parentContainer.appendChild(displayText);
                        parentContainer.appendChild(dropdownIcon);
                        const multiSelectContainer = document.createElement('div');
                        multiSelectContainer.classList.add('multi-select');
                        multiSelectContainer.style.position = 'fixed';
                        multiSelectContainer.style.top = 'auto';
                        multiSelectContainer.style.left = '0';
                        multiSelectContainer.style.width = 'inherit';
                        multiSelectContainer.style.border = '1px solid #ccc';
                        multiSelectContainer.style.backgroundColor = '#fff';
                        multiSelectContainer.style.maxHeight = '200px';
                        multiSelectContainer.style.overflowY = 'auto';
                        multiSelectContainer.style.display = 'none';
                        multiSelectContainer.style.zIndex = '111111 !important';
                        multiSelectContainer.style.height = '20%';

                        attrOptionsSel.forEach(attr => {

                            const optionDiv = document.createElement('div');
                            optionDiv.classList.add('custom-option');
                            optionDiv.style.padding = '5px';
                            optionDiv.style.display = 'flex';
                            optionDiv.style.alignItems = 'center';
                            optionDiv.style.position = 'unset';
                            optionDiv.style.zIndex = '99999';

                            const checkbox = document.createElement('input');
                            checkbox.type = 'checkbox';
                            checkbox.id = attr.id;
                            checkbox.value = attr.id;
                            checkbox.setAttribute('optionTitle', attr.name)
                            checkbox.setAttribute('optionShortTitle', attr.shortName)
                            checkbox.setAttribute('optionAttrType', attr.attrType)

                            try {
                                let attributeContent = typeof table.previousValue === 'string' ? table.previousValue : (typeof cell_data._cell.row.data.Attribute === 'string' ? cell_data._cell.row.data.Attribute : "");
                                let tempDiv = document.createElement('div');
                                tempDiv.innerHTML = attributeContent;
                                if (tempDiv.querySelector(`[attr${attr.id}]`)) {
                                    checkbox.checked = true;
                                    selectedValues.push({ id: attr.id, name: attr.name, shortName: attr.shortName, attrType: attr.attrType });
                                }
                            } catch (e) { }
                            checkbox.classList.add('custom-checkbox');

                            const label = document.createElement('label');
                            label.htmlFor = attr.id;
                            label.textContent = attr.name;
                            label.style.marginLeft = '5px';
                            label.classList.add('custom-option-input-label');
                            if (Number(attr.attrType) === 10) {
                                checkbox.disabled = true;
                                checkbox.style.cursor = "not-allowed";
                                checkbox.style.opacity = "0.5";
                                checkbox.style.backgroundColor = "#f0f0f0";
                                label.style.color = "#aaa";
                                label.style.cursor = "not-allowed";
                            }

                            optionDiv.appendChild(checkbox);
                            optionDiv.appendChild(label);
                            multiSelectContainer.appendChild(optionDiv);
                        });

                        parentContainer.appendChild(multiSelectContainer);
                        cell_data._cell.row.data.Attribute = parentContainer;
                        let rowElement = cell_data._cell.row.getElement();
                        rowElement.style.zIndex = '9999999';
                        // Toggle visibility of options on click

                        parentContainer.addEventListener('click', (e) => {

                            e.stopPropagation();

                            if (!(e.target.classList.contains('custom-checkbox') || e.target.classList.contains('custom-option') || e.target.classList.contains('custom-option-input-label'))) {

                                if (multiSelectContainer.style.display === 'none') {
                                    setGridRefreshPaused(true);
                                    const parentTop = parentContainer.offsetTop;
                                    const parentHeight = parentContainer.offsetHeight;
                                    multiSelectContainer.style.top = `${parentTop + parentHeight}px`;
                                    multiSelectContainer.style.top = `${parentTop + parentHeight}px`;
                                    if (parseInt(multiSelectContainer.style.top.replace(/px/g, "")) > (window.innerHeight - 500)) {
                                        multiSelectContainer.style.top = (parseInt(multiSelectContainer.style.top.replace(/px/g, "")) - (window.innerHeight * 0.2)).toString() + "px";
                                    }
                                    multiSelectContainer.style.left = `${parentContainer.offsetLeft}px`;
                                    multiSelectContainer.style.display = 'block';
                                    const rowElement = multiSelectContainer.closest('.tabulator-row');
                                    if (rowElement) {
                                        rowElement.style.zIndex = '99999';
                                    }
                                } else {
                                    multiSelectContainer.style.display = 'none';
                                    setGridRefreshPaused(false);
                                }
                            }
                        });

                        const handleClickOutside = (event) => {
                            if (!parentContainer.contains(event.target)) {
                                multiSelectContainer.style.display = 'none';
                                setGridRefreshPaused(false);
                                document.removeEventListener('click', handleClickOutside);
                                try {
                                    if (table.previousCellData && table.previousCellData.row === cell_data._cell.row) {
                                        cell_data._cell.row.data[cell_data._cell.column.field] = table.previousValue;
                                        table.updateData([cell_data._cell.row.data]);
                                    }
                                } catch (e) {}
                            }
                        };
                        setTimeout(() => {
                            document.addEventListener('click', handleClickOutside);
                        }, 0);
                        cellClickTimeout.current = setTimeout(() => {
                            const checkboxes = document.querySelectorAll('.custom-checkbox');
                            checkboxes.forEach(checkbox => {
                                if (!checkbox.dataset.listenerAdded) {
                                    checkbox.addEventListener('change', async (e) => {
                                        let value = checkbox.value;
                                        let selectedName = checkbox.getAttribute('optionTitle');
                                        let selectedShortName = checkbox.getAttribute('optionShortTitle');
                                        let selectedAttrType = checkbox.getAttribute('optionAttrType');
                                        if (checkbox.checked) {
                                            if (!selectedValues.some(item => item.id == value)) {
                                                selectedValues.push({ id: value, name: selectedName, shortName: selectedShortName, attrType: selectedAttrType });
                                            }
                                        } else {
                                            const index = selectedValues.findIndex(item => item.id == value);
                                            if (index !== -1) {
                                                selectedValues.splice(index, 1);
                                            }
                                        }
                                        let payload = {
                                            "iRefID": cell_data._cell.row.data.ConfirmationNo.toString(),
                                            "iATSPID": cell_data._cell.row.data.iSRATSPID.toString(),
                                            "vAttributeIDsList": selectedValues.map(item => item.id).join(",")
                                        };
                                        await APICom.fetchData("", "TripActions/UpdateTripAttributes", "post", { "Content-Type": "application/json" }, payload, null);
                                        let htmlString = "";

                                        for (const selectedValue of selectedValues) {
                                            htmlString += `<p systemattribute="0" title="${selectedValue.name}" attr${selectedValue.id}>${selectedValue.shortName}</p>`;
                                        }

                                        try {
                                            let tempDiv = document.createElement('div')
                                            tempDiv.innerHTML = table.previousValue;

                                            let attributeToRemove = tempDiv.querySelectorAll('p[systemattribute="0"]');
                                            attributeToRemove.forEach(element => element.remove());
                                            let updatedPreviousValueHTML = tempDiv.innerHTML;

                                            table.previousValue = updatedPreviousValueHTML + htmlString
                                        } catch (e) {
                                        }

                                    });
                                    checkbox.dataset.listenerAdded = true;
                                }
                            });

                        }, 0);
                    }

                }
            }
        } catch (err) { console.log(err); }
    }

    const UpdateSelectedTripCounter = (tripsData) => {
        try {
            if(tripsData != undefined && tripsData != null){
                if(tripsData?.length == 0){
                    if (document.getElementById('tabulator_selectedRecords').innerHTML != "[No Trips Selected]") {
                        document.getElementById('tabulator_selectedRecords').innerHTML = "[No Trips Selected]";
                    }
                }
                else if(tripsData?.length == 1)
                {
                    document.getElementById('tabulator_selectedRecords').innerHTML = "[1 Trip Selected]";
                }
                else{
                    document.getElementById('tabulator_selectedRecords').innerHTML = "[" + tripsData.length + " Trips Selected]";
                }
            }
        } catch (error) {
            
        }
    }

    const defaultTableExportAsExcel = (table) => {
        try {
            if (table != undefined) {
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                const visibleColumns = table.getColumns()
                .filter(col => col.isVisible())
                .map(col => col.getField())
                .filter(field => field && !columnsToIgnore.includes(field));
        
                const filteredData = data.map(row => {
                    const filteredRow = {};
                    visibleColumns.forEach(field => {
                        filteredRow[field] = row[field];
                    });
                    return filteredRow;
                });
        
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "Default_Export.xlsx");
            }
        } catch (error) {
            console.log("An Exception has occured while downloading excel file: " + error);
        }
    }


    const groupEntriesAndDownloadAsExcel = (filteredData) => {
        let groupedAndSortedData = [];
        try {
            const groupedData = filteredData?.reduce((acc, item) => {
                const route = item.Route || "";
                if (!acc[route]) {
                    acc[route] = [];
                }
                acc[route].push(item);
                return acc;
            }, {});

            let routes = Object.keys(groupedData).sort().filter(route => route !== "");
            if (groupedData[""]) {
                routes.push("");
            }

            routes.forEach(route => {
                groupedData[route].sort((a, b) =>
                    new Date(a?.PickupDateTime) - new Date(b?.PickupDateTime)
                );
                groupedAndSortedData.push(...groupedData[route]);

                // Optional: Append an empty row after each group
                // groupedAndSortedData.push({});
            });
            if (groupedAndSortedData != undefined) {
                const sheet = XLSX.utils.json_to_sheet(groupedAndSortedData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "Special_Export.xlsx");
            }
        } catch (error) {
            console.error("An Exception has occured while downloading excel file:", error);
            return filteredData;
        }
    }

    function getClusterGridControlOptions() {
        // console.log("Calling getDispatchGridControlOptions")
        return {

            height: 'auto',
            heightoffset: 200,
            calculateHeight: false,
            pagination: true,
            paginationMode: "local",
            paginationSize: 100,
            paginationSizeSelector: [100, 200, 300, 400, 500],
            selectable: true,
            reactiveData: true, //enable data reactivity
            layout: "fitDataStretch",
            placeholder: "No Data Available",
            clipboard: false,
            selectableRangeMode: "click",
            GridName: "clusterTableGrid",
            paginationCounter: "rows",
            intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined ? 60000 : GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value * 2000,
            movableColumns: true,
            movableRows: true,
            vDefaultGridName: "SelectedGridRouteSRQARQPRQ_NewC",
            index: "Index",
            autoColumns: true,
            intervalEnable: false,
            bWebApplySettingToAll: true,
            bSysUser: 1,
            saveCCSettingsOption: true,
            GridReturnOnlyIDColumnInRowData: false,
            persistence: false,
            CCAddition: true,
            contextMenuSetting: ContextMenuStopView,
            MasterMenu: ContextMenuStopView,
            sortCondition: false,
            ID_Column: "Index",
            // AlwaysHiddenColumns:["AffPhoneNo","AssignedDriverId","CallbackInfo","CallbackMethod","CallOutStatus","CallRecieve","CancelComment","CheckInState","DateCallback","DateCreation","DispatchedBy","DispatchMethod","DODev","DriverCellPhone","DriverHomePhone","DriverNearDropLoc","DriverPhone","DropCity","DropLatitude","DropLongitude","DropState","DropZip","EstCostSort","ExtraInformation","iAssignedVehicleId","iClassOfServiceID","iCreatedByAppID","iFundingSourceID","iMVOriginalATSPID","iMVRouteATSPID","iRefID","iScheduleID","iSpecialDriverId","iSpecialVehicleId","iVehicleTypeId","LastModifiedBy","MilesPickOrDrop","PaymentExtention1","PaymentExtention3","PickupCity","PickupLatitude","PickupLongitude","PickupSort","PickupState","PickupZip","PromoAmount","PromotionCode","ProviderMileage","PUDev","ShowDAffiliateTripsToATSP","StandingRoute","TotalCancelled","TotalNoShows","TripAttributes","vCompanyPBXAPIURL","vManifestNumber","vMarsID","vPBXCompany","VREQ"],
            containerClass: "",
            Containerstyle: { top: "-6px" },
            footerElement:
            '<label class="switch" title="Enable Auto Refresh" style="margin-right: 10px;">' +
            '<input type="checkbox" id="clusterTableGrid_checkbox">' +
            '<span class="slider round"></span>' +
          '</label>'
            
          //  '<input type="checkbox" id="clusterTableGrid_checkbox" class="tabulator_checkbox" title="Auto Refresh" style="margin-right: 10px;">'
                + '<button class="tabulator_btns" title="Export to Excel" id="'
                + "clusterTableGrid" + '_ExportToExcel"></button><button class="tabulator_btns middleTabulator-btns" title="Adjust Time & Validate Route" id="'
                + "clusterTableGrid" + '_AdjustTimes"></button><button class="tabulator_btns middleTabulator-btns" '
                + ' title="Commit Changes" id="' + "clusterTableGrid" + '_Commit"></button>'
                + '<button class="tabulator_btns middleTabulator-btns" '
                + ' title="Validate Route" id="' + "clusterTableGrid" + '_validate"></button>'
                + '<button class="tabulator_btns lastTabulator-btn" '
                + ' title="Display Violations Legend" id="' + "clusterTableGrid" + '_infoViolations"></button>',

            tableDoubleClickFunc: function (table, row) {
            },
            AlwaysHiddenColumns: ["iID_RouteGeneralSettings", "iServiceID", "iScheduleID", "StylCondDev", "ManifestNumber", "ReqTimeHidden",
                "bIsScheduled", "dLateTimeWindow", "dFinalEndTimeWindow", "dFinalEndTimeWindow", "dFinalApptTimeWindow",
                "CustomerSignature", "iCreatedByAppID", "iSRATSPID", "vColor", "dtReqIRTPU", "dtDriverLoc", "iRouteID",
                "BusLine", "dEarlyTimeWindow", "vManifestDisposition", "iVehStopOrder", "ServiceRequestType", "SortOrder", "Eta", "iTotalWheelChairs",
                "iTotalPassengerCount", "bWillCall", "bPerformed", "iVehicleID", "iAffiliateID", "CDPUStopNo", "CDDOStopNo", "dtDriverDropLoc", "dUpdateSchWinMins"
            ],
            GeneralArrayForHTML: ["Violation"],
            footerElementHandles: function (table, TableData) {
                ClusterTableObject.current = table;
                // ClusterTableObject.current.selectRow( ClusterTableObject.current.getData()[0].Index);
                var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = saveIcon;
                document.getElementById("clusterTableGrid_ExportToExcel").appendChild(img);
                var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = AdjustTimes;
                document.getElementById("clusterTableGrid_AdjustTimes").appendChild(img);
                img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = CommitTimes;
                document.getElementById("clusterTableGrid_Commit").appendChild(img);

                img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = ValidateIcon;
                document.getElementById("clusterTableGrid_validate").appendChild(img);

                img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px";
                img.src = infoIcon;
                document.getElementById("clusterTableGrid_infoViolations").appendChild(img);

                if(IsRoutedTrip.current != true){ // It might be defaul : false
                    if(_iNoOfTripsInRoutes.current != undefined && _iNoOfTripsInRoutes.current == 0){
                        IsRoutedTrip.current = false;
                        setIsRoutedTrip(false);
                    }
                    else{
                        IsRoutedTrip.current = true;
                        setIsRoutedTrip(true);
                    }
                }

                EnableDisableClusterGridFooter(IsRoutedTrip?.current);

                document.getElementById("clusterTableGrid_ExportToExcel").addEventListener("click", function () {
                    
                    if (table != undefined) {
                        const data = table.getData('active');
                        const columnsToIgnore = ['id'];
                        const visibleColumns = table.getColumns()
                        .filter(col => col.isVisible())
                        .map(col => col.getField())
                        .filter(field => field && !columnsToIgnore.includes(field));
                
                        const filteredData = data.map(row => {
                            const filteredRow = {};
                            visibleColumns.forEach(field => {
                                filteredRow[field] = row[field];
                            });
                            return filteredRow;
                        });
                
                        const sheet = XLSX.utils.json_to_sheet(filteredData);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                        XLSX.writeFile(wb, "cluster_table_data.xlsx");
                    }
                });

                document.getElementById('clusterTableGrid_Commit').addEventListener("click", async function () {
                    CommitActions();
                });

                document.getElementById('clusterTableGrid_validate').addEventListener("click", async function () {
                    ValidateRoute();
                });

                // Update checkbox state based on condition
                const autoRefreshCheckbox = document.getElementById('clusterTableGrid_checkbox');
                if (autoRefreshCheckbox) {
                    if (someThingChangedInGrid.current === true) {
                        autoRefreshCheckbox.checked = false;
                    }
                    else {
                        autoRefreshCheckbox.checked = true;

                    }
                }

                document.getElementById('clusterTableGrid_checkbox').addEventListener("click", async function () {
                    AutoRefresh();
                });
                document.getElementById('clusterTableGrid_AdjustTimes').addEventListener("click", async function () {
                    AdjustRouteTimes();
                });
                document.getElementById('clusterTableGrid_infoViolations').addEventListener("click", function () {
                    let manageRouteFooterBtns = ["Close"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function (item, index) {
                        return (
                            <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={() => setShowDynamicModal(false)}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function (index) {
                        return (
                            <Row key={index} className="border rounded p-1">
                                <Col>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Capacity(CV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Time Window(TWV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Ride Time(RTV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Miles(MMV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Driver Break(DBV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Unique Stops(USV):"}</p>
                                </Col>
                                <Col>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].capacity }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].timeWindow }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].RideTime }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].maxMilesHours }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].driverBreak }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].uniqueStops }}></div>
                                </Col>
                                <Col>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Non Drop(NDV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Pickup Loop Back(PLV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Will Call Trips(WCV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Route Start Time(EST):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Trips(MTV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Invalid DO GPS(DGDSV):"}</p>
                                </Col>
                                <Col>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].nonDrop }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].puLoopBack }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].WillCallTrip }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].TripStartTime }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].MaxTrips }}></div>
                                    <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].invalidDOGPS }}></div>
                                </Col>
                                <Row>
                                    <Col xs={5}>
                                        <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Max Route Hours(RHV):"}</p>
                                        <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Invalid PU GPS(PGPSV):"}</p>
                                        <p className="m-0 user-select-none text-nowrap" style={{ fontSize: "small" }}>{"Ride Sharing(RSV):"}</p>
                                    </Col>
                                    <Col xs={7} style={{ marginLeft: "-6.0%" }}>
                                        <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].maxRouteHrs }}></div>
                                        <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].invalidPUGPS }}></div>
                                        <div className="mt-1" style={{ height: "16px", width: "16px", background: violationColors[0].RideSharing }}></div>
                                    </Col>
                                </Row>
                            </Row>

                        );
                    };
                    setModalHeaderText("Violations Legend");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowDynamicModal(true);
                });
            },
            rowSelectionChangeHandle: function (data) {
                try {
                    //alert("c");
                    // Row Selection change called when selecting from cluster grid
                    ClusterGridSelectedRows.current = data;
                    if (data.length === 1) {
                        data[0].IsRowSelected = true;
                        data[0].IsClusterGridSelection = true;
                        setSelectedStopsData([]);
                        setSelectedStopsData(data);
                        
                        const selectedRow = data[(data.length - 1)]; // Get the first (and only) selected row
                        setClusterTripSelection({
                            Number: selectedRow.TripNo,
                            Type: selectedRow.Type
                        });
                    } 
                    else if (data.length > 1) {
                        const sortedData = data.sort((a, b) => a['Stop#'] - b['Stop#']);

                        // Append isClusterGridSelection = true to each object
                        const updatedData = sortedData.map(item => ({
                            ...item,
                            isClusterGridSelection: true
                        }));
                        setSelectedStopsData([]);
                        setSelectedStopsData(updatedData);

                    } else {
                        setClusterTripSelection(null);
                        console.log('No rows selected');
                    }
                } catch (err) {
                    console.log('Error handling row selection change:', err);
                }
            },
            GridAfterDataFetching: function (table) {

            },
            GridDataLoadComplete: function (table) {
                if (table != null) {
                    if (ClusterGridSelectedRows.current != null && ClusterGridSelectedRows.current.length > 0) {
                        let indexValuesArray = ClusterGridSelectedRows.current.map(row => row.Index);
                        table.selectRow(indexValuesArray);
                    }
                    table.rowManager.element.scrollTop = ClusterGridSrollVertical.current;
                    ClusterGridDataResetComplete.current = true;
                };
            },
            GridScrollVertical: function (top, table = "") {
                ClusterGridSrollVertical.current = top;
            },
            GridDataCompareAndUpdate: function (OldData, NewData) {
                return ClusterGridDataResetComplete.current; //This is maintained in the parent function so that we only update the data rather then destroy and create.
            },
            // clusterColModel: ["Actions", "StopOrder", "pickLat", "pickLng", "dropLat", "dropLng", "ConfirmationNo", "StopType", "Route", "PUPerson", "ReqTime", "ETA", "StopStatus", "Custom", "TSPID", "vAddress", "VehicleNum", "vManifestNumber", "nTotalWheelChairs"],
            ActionList: true,
            ActionRowColoring: true,
            ArrangeClusterTripsErrorCases: [{
                "TripAtTop": "Trip is already at the top.", "TripAtBottom": "Trip is already at the bottom.",
                "PUAfterDO": "Pickup can't come after its Dropoff!", "DOBeforePU": "Dropoff can't come before its Pickup!",
                "PrevRowNotExist": "Action not allowed because no previous row exist", "PrevDepotTrip": "Action not allowed because previous trip is depot trip",
                "PrevWillCallTrip": "Action not allowed because previous trip is a will call trip", "PerformedStops": "Action not allowed because trip has already been performed",
                "PrevPerformedStop": "Action not allowed because previous trip has already been performed",
                "PrevBreakTrip": "Action not allowed because previous trip is a break trip", "NextDepotTrip": "Action not allowed because next trip is depot trip",
                "NextvWillCallTrip": "Action not allowed because next trip is a will call trip", "NextBreakTrip": "Action not allowed because next trip is a break trip",
                "NextPerformedStop": "Action not allowed because next trip has already been performed",
                "CompletedTrip": "Action not allowed because dragged trip has already been performed"
            }],

        }
    }

    const EnableDisableClusterGridFooter = (_IsRoutedTrip = false) => {
        let disabledOpacity = '0.2';
        const buttonIds = [
            'clusterTableGrid_Commit',
            'clusterTableGrid_validate',
            'clusterTableGrid_AdjustTimes',
            'clusterTableGrid_infoViolations',
        ];
        try {
            if(_IsRoutedTrip === false){
                buttonIds.forEach(id => {
                    const el = document.getElementById(id);
                    if(el) {
                        el.disabled = true;
                        el.style.opacity = disabledOpacity;
                    }
                });
                // document.getElementById('clusterTableGrid_Commit').disabled = true;
                // document.getElementById('clusterTableGrid_Commit').style.opacity = disabledOpacity;

                // document.getElementById('clusterTableGrid_validate').disabled = true;
                // document.getElementById('clusterTableGrid_validate').style.opacity = disabledOpacity;

                // document.getElementById('clusterTableGrid_AdjustTimes').disabled = true;
                // document.getElementById('clusterTableGrid_AdjustTimes').style.opacity = disabledOpacity;

                // document.getElementById('clusterTableGrid_infoViolations').disabled = true;
                // document.getElementById('clusterTableGrid_infoViolations').style.opacity = disabledOpacity;

            }
            else{
                buttonIds.forEach(id => {
                    const el = document.getElementById(id);
                    if(el){
                        el.disabled = false;
                        el.style.opacity = '';
                    }
                });
                // document.getElementById('clusterTableGrid_Commit').disabled = false;
                // document.getElementById('clusterTableGrid_Commit').style.opacity = '';

                // document.getElementById('clusterTableGrid_validate').disabled = false;
                // document.getElementById('clusterTableGrid_validate').style.opacity = '';

                // document.getElementById('clusterTableGrid_AdjustTimes').disabled = false;
                // document.getElementById('clusterTableGrid_AdjustTimes').style.opacity = '';

                // document.getElementById('clusterTableGrid_infoViolations').disabled = false;
                // document.getElementById('clusterTableGrid_infoViolations').style.opacity = '';
            }
        } catch (error) {
            buttonIds.forEach(id => {
                const el = document.getElementById(id);
                if(el){
                    el.disabled = false;
                    el.style.opacity = '';
                }
            });
            // document.getElementById('clusterTableGrid_Commit').disabled = false;
            // document.getElementById('clusterTableGrid_Commit').style.opacity = '';
            // document.getElementById('clusterTableGrid_validate').disabled = false;
            // document.getElementById('clusterTableGrid_validate').style.opacity = '';
            // document.getElementById('clusterTableGrid_AdjustTimes').disabled = false;
            // document.getElementById('clusterTableGrid_AdjustTimes').style.opacity = '';
            // document.getElementById('clusterTableGrid_infoViolations').disabled = false;
            // document.getElementById('clusterTableGrid_infoViolations').style.opacity = '';
        }
    }

    useEffect(() => {
        try {
            if (Array.isArray(ARBResponseForStopViewComputeEstimates) && ARBResponseForStopViewComputeEstimates.length > 0 && ClusterTableObject.current) {
                let _driverBreakStart = null;
                let _driverBreakEnd = null;
                let _tempGridData = ClusterTableObject.current.getData();

                for (let d = 0; d < _tempGridData.length; d++) {
                    if (_tempGridData[d]["Type"] === "DriverBreakStart") {
                        _driverBreakStart = _tempGridData[d];
                    } else if (_tempGridData[d]["Type"] === "DriverBreakEnd") {
                        _driverBreakEnd = _tempGridData[d];
                    }
                }

                if (_driverBreakEnd) {
                    ClusterTableObject.current.deleteRow(_driverBreakEnd.Index);
                }
                if (_driverBreakStart) {
                    ClusterTableObject.current.deleteRow(_driverBreakStart.Index);
                }
                let _allRowsGrid2 = ClusterTableObject.current.getData();

                for (let k = 0; k < _allRowsGrid2.length; k++) {
                    for (let i = 0; i < ARBResponseForStopViewComputeEstimates.length; i++) {
                        if (_allRowsGrid2[k].Index === ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"]) {
                            if (ARBResponseForStopViewComputeEstimates[i].WaitTimeAtLocation <= 5) {
                                if (k > 0 && _allRowsGrid2[k - 1].Type === "IdleTime") {
                                    ClusterTableObject.current.deleteRow(_allRowsGrid2[k - 1].Index);
                                }
                            }
                            if (ARBResponseForStopViewComputeEstimates[i].WaitTimeAtLocation > 5) {
                                let _idleTimeData = {
                                    Action: i,
                                    TripNo: i + "_",
                                    SchTime: (moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format('HH:mm')),
                                    SchDateTime: (moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format("YYYY-MM-DDTHH:mm:ss")),
                                    Type: "IdleTime",
                                    vStylCondDev: "IdleTime",
                                    IdleTime: ARBResponseForStopViewComputeEstimates[i].WaitTimeAtLocation,
                                    Index: i + "_IdleTime"
                                };
                                // _idleTimeData["Action"] = i + "";
                                // _idleTimeData["TripNo"] = i + "_";
                                // _idleTimeData["SchTime"] = moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format('HH:mm');
                                // _idleTimeData["SchDateTime"] = moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).add(-1, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
                                // _idleTimeData["Type"] = "IdleTime";
                                // _idleTimeData["vStylCondDev"] = "IdleTime";
                                // _idleTimeData["IdleTime"] = ARBResponseForStopViewComputeEstimates[i]["WaitTimeAtLocation"];
                                // _idleTimeData["Index"] = i + "_IdleTime";
                                if (k > 0 && _allRowsGrid2[k - 1].Type !== "IdleTime") {
                                    //add new row above existing row with index of ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + responseData[i]["NodeType"]
                                    ClusterTableObject.current.addRow(_idleTimeData, true, ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"]);
                                }
                                else {
                                    
                                    ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["SchTime"]: _idleTimeData.SchTime,  
                                        ["SchDateTime"]: _idleTimeData.SchDateTime, ["IdleTime"]: _idleTimeData.IdleTime}
                                    );
                                    // ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["SchDateTime"]: _idleTimeData.SchDateTime });
                                    // ClusterTableObject.current.updateRow(_allRowsGrid2[k - 1]["Index"], { ["IdleTime"]: _idleTimeData.IdleTime });
                                }
                            }
                            const indexToUpdate = ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"];
                            ClusterTableObject.current.updateRow(indexToUpdate, { 
                                ["SchTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format('HH:mm'),  
                                ["SchDateTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss"),
                                ["EstTimeFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelTime,
                                ["EstDistFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelDistance
                            });
                            // ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], { ["SchDateTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss") });
                            // ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], { ["EstTimeFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelTime });
                            // ClusterTableObject.current.updateRow(ARBResponseForStopViewComputeEstimates[i]["MVRecordID"] + "_" + ARBResponseForStopViewComputeEstimates[i]["NodeType"], { ["EstDistFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelDistance });
                        }
                    }
                    if (_allRowsGrid2[k].Type === "EndDept") {
                        for (let i = 0; i < ARBResponseForStopViewComputeEstimates.length; i++) {
                            if (ARBResponseForStopViewComputeEstimates[i].NodeType === "EndDept") {
                                const rowIndex = _allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"];
                                ClusterTableObject.current.updateRow(rowIndex, { 
                                    ["SchTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format('HH:mm'),
                                    ["SchDateTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss"),
                                    ["EstTimeFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelTime,
                                    ["EstDistFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelDistance
                                });
                                // ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], { ["SchDateTime"]: moment(ARBResponseForStopViewComputeEstimates[i].SystemScheduleTime).format("YYYY-MM-DDTHH:mm:ss") });
                                // ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], { ["EstTimeFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelTime });
                                // ClusterTableObject.current.updateRow(_allRowsGrid2[k]["TripNo"] + "_" + _allRowsGrid2[k]["Type"], { ["EstDistFromPrev"]: ARBResponseForStopViewComputeEstimates[i].EstTravelDistance });
                            }
                        }
                    }
                    let _tempGridStopType = ClusterTableObject.current.getData()[k]?.Type;
                    let _gridPrvSchTime = "00:00"
                    let _gridPrvSchTimeInMinutes = 0;

                    try {
                        _gridPrvSchTime = ClusterTableObject.current.getData()[k]?.SchTime;
                        if (_gridPrvSchTime !== undefined) {
                            _gridPrvSchTimeInMinutes = (parseInt(_gridPrvSchTime.split(':')[0]) * 60) + (parseInt(_gridPrvSchTime.split(':')[1]));
                        }
                    } catch (b) { }

                    let _gridSchTime = ClusterTableObject.current.getData()[k]?.SchTime;
                    let _gridSchTimeInMinutes = 0;

                    if (_gridSchTime !== undefined) {
                        _gridSchTimeInMinutes = (parseInt(_gridSchTime.split(':')[0]) * 60) + (parseInt(_gridSchTime.split(':')[1]));
                    }

                    if (_driverBreakStart && _tempGridStopType !== "StartDept" && _tempGridStopType !== "DriverBreakStart" && _tempGridStopType !== "DriverBreakEnd") {
                        let _breakStartSchTime = _driverBreakStart.SchTime;
                        let _breakStartSchTimeInMinutes = (parseInt(_breakStartSchTime.split(':')[0]) * 60) + (parseInt(_breakStartSchTime.split(':')[1]));

                        if (_gridSchTimeInMinutes >= _breakStartSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakStartSchTimeInMinutes) {
                            ClusterTableObject.current.addRow(_driverBreakStart, true, _allRowsGrid2[k].Index);
                            _driverBreakStart = null;
                        }
                    }
                    if (_driverBreakEnd && _tempGridStopType !== "StartDept" && _tempGridStopType !== "DriverBreakStart" && _tempGridStopType !== "DriverBreakEnd") {
                        let _breakEndSchTime = _driverBreakEnd.SchTime;
                        let _breakEndSchTimeInMinutes = (parseInt(_breakEndSchTime.split(':')[0]) * 60) + (parseInt(_breakEndSchTime.split(':')[1]));

                        if (_gridSchTimeInMinutes >= _breakEndSchTimeInMinutes && _gridPrvSchTimeInMinutes > _breakEndSchTimeInMinutes) {
                            ClusterTableObject.current.addRow(_driverBreakEnd, true, _allRowsGrid2[k].Index);
                            _driverBreakEnd = null;
                        }
                    }
                }
                setclusterTableStateBeforeCompute(ClusterTableObject.current.getData());
                validateRouteTimeout.current = setTimeout(() => {
                    ValidateRoute();
                }, 2000);
            }
        } catch (err) { console.log(err); }
    }, [ARBResponseForStopViewComputeEstimates]);

    useEffect(() => {
        try {
            if (Array.isArray(ARBResponseForStopViewValidate) && ARBResponseForStopViewValidate.length > 0 && ClusterTableObject.current) {
                
                const violationMap = {
                    [-1]: { label: 'CV', color: violationColors[0].capacity },
                    [-2]: { label: 'TWV', color: violationColors[0].timeWindow },
                    [-3]: { label: 'RTV', color: violationColors[0].RideTime },
                    [-4]: { label: 'MMV', color: violationColors[0].maxMilesHours },
                    [-5]: { label: 'NDV', color: violationColors[0].nonDrop },
                    [-6]: { label: 'DBV', color: violationColors[0].driverBreak },
                    [-7]: { label: 'PLV', color: violationColors[0].puLoopBack },
                    [-8]: { label: 'TIV', color: '#000000' },
                    [-9]: { label: 'USV', color: violationColors[0].uniqueStops },
                    [-10]: { label: 'EST', color: violationColors[0].TripStartTime },
                    [-11]: { label: 'RHV', color: violationColors[0].maxRouteHrs },
                    [-12]: { label: 'MTV', color: violationColors[0].MaxTrips },
                    [-13]: { label: 'PGPSV', color: violationColors[0].invalidPUGPS },
                    [-14]: { label: 'DGPSV', color: violationColors[0].invalidDOGPS },
                    [-15]: { label: 'WCV', color: violationColors[0].WillCallTrip },
                    [-16]: { label: 'RSV', color: violationColors[0].RideSharing },
                };
                const isRelevantType = type => !["StartDept", "IdleTime", "EndDept"].includes(type);

                let originalTableData = ClusterTableObject.current.getData();
                let tableDataArr = (Array.isArray(originalTableData) ? originalTableData : [originalTableData]);

                tableDataArr.forEach(row => {
                    let _violationHtml = "";

                    ARBResponseForStopViewValidate.forEach(v => {
                        const matchIndex = `${v.TripNo}_${v.StopType}`;
                        if(row.Index === matchIndex && v.StopType !== 'DriverBreakStart'){
                            const violation = violationMap[v.ViolationID];
                            if(violation) {
                                _violationHtml += `<span style="background-color: ${violation.color}; margin: 2px;color:white;">${violation.label}</span>`;
                            }
                        }
                    });
                    if(isRelevantType(row.Type)){
                        ClusterTableObject.current.updateRow(row.Index, { Violation: _violationHtml });
                    }
                });
                // for (let i = 0; i < originalTableData.length; i++) {
                //     let _violationHtml = "";
                //     for (let j = 0; j < ARBResponseForStopViewValidate.length; j++) {
                //         if (originalTableData[i].Index === String(ARBResponseForStopViewValidate[j].TripNo + "_" + ARBResponseForStopViewValidate[j].StopType) &&
                //             ARBResponseForStopViewValidate[j].StopType !== 'DriverBreakStart') {
                //             if (ARBResponseForStopViewValidate[j].ViolationID === -1) {
                //                 _violationHtml += '<span style="background-color: ' + violationColors[0].capacity + ';margin: 2px;color:white;">CV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -2) {
                //                 _violationHtml += '<span style="background-color: ' + violationColors[0].timeWindow + ';margin: 2px;color:white;">TWV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -3) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].RideTime + ';margin: 2px;color:white;">RTV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -4) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].maxMilesHours + ';margin: 2px;color:white;">MMV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -5) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].nonDrop + ';margin: 2px;color:white;">NDV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -6) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].driverBreak + ';margin: 2px;color:white;">DBV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -7) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].puLoopBack + ';margin: 2px;color:white;">PLV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -8) {
                //                 _violationHtml += '<span style="background-color:#000000;margin: 2px;color:white;">TIV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -9) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].uniqueStops + ';margin: 2px;color:white;">USV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -10) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].TripStartTime + ';margin: 2px;color:white;">EST</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -11) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].maxRouteHrs + ';margin: 2px;color:white;">RHV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -12) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].MaxTrips + ';margin: 2px;color:white;">MTV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -13) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].invalidPUGPS + ';margin: 2px;color:white;">PGPSV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -14) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].invalidDOGPS + ';margin: 2px;color:white;">DGPSV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -15) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].WillCallTrip + ';margin: 2px;color:white;">WCV</span>';
                //             } else if (ARBResponseForStopViewValidate[j].ViolationID === -16) {
                //                 _violationHtml += '<span style="background-color:' + violationColors[0].RideSharing + ';margin: 2px;color:white;">RSV</span>';
                //             }
                //         }
                //     }
                //     if (originalTableData[i]['Type'] !== "StartDept" && originalTableData[i]['Type'] !== "IdleTime" && originalTableData[i]['Type'] !== "EndDept") {
                //         ClusterTableObject.current.updateRow(originalTableData[i]['Index'], { Violation: _violationHtml });
                //     }
                // }
            }
        } catch (err) { console.log(err); }
    }, [ARBResponseForStopViewValidate]);

    useEffect(() => {
        try {
            const PopulateAddBreakTripData = async (e) => {
                try {
                    if (StopViewBreakTrip && ClusterTableObject.current) {
                        let index = StopViewBreakTrip.NextServiceTrip;
                        let PUDict = handleGetClusterTableRowData(StopViewBreakTrip.PUarray);
                        let DODict = handleGetClusterTableRowData(StopViewBreakTrip.DOarray);

                        ClusterTableObject.current.addRow(PUDict, true, index);
                        
                        index = StopViewBreakTrip.PUarray['Index'];

                        ClusterTableObject.current.addRow(DODict, true, index);

                        xCancelSourceForGrid.current = APICom.GenerateSource();
                        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/AddManualBreakTrip", "post", {}, StopViewBreakTrip.input, xCancelSourceForGrid.current);
                        if (response.data[0].Result === "OK") {
                            const iRefID = response.data[0].iRefID;
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.PUarray['Index'], { 
                                ["TripNo"]: '0' + iRefID , ["Index"]: '0' + iRefID + '_DO'
                            });
                            ClusterTableObject.current.updateRow(StopViewBreakTrip.DOarray['Index'], { 
                                ["TripNo"]: '0' + iRefID , ["Index"]: '0' + iRefID + '_PU'
                            });
                            // ClusterTableObject.current.updateRow(StopViewBreakTrip.PUarray['Index'], { ["TripNo"]: '0' + iRefID });
                            // ClusterTableObject.current.updateRow(StopViewBreakTrip.DOarray['Index'], { ["TripNo"]: '0' + iRefID });
                            // ClusterTableObject.current.updateRow(StopViewBreakTrip.PUarray['Index'], { ["Index"]: '0' + iRefID + '_DO' });
                            // ClusterTableObject.current.updateRow(StopViewBreakTrip.DOarray['Index'], { ["Index"]: '0' + iRefID + '_PU' });
                            setAddBreakModal({
                                isVisible: false
                            });

                            AdjustRouteTimes();

                            stopViewBreakTrip_Internal_Timeout.current = setTimeout(() => {
                                ValidateRoute();
                                CommitActions();
                            }, 2000);
                        }
                    }
                }
                catch (err) { console.log(err); }
            };
            PopulateAddBreakTripData();
        }
        catch (err) { console.log(err); }
    }, [StopViewBreakTrip]);

    function handleGetClusterTableRowData (DataArr) {
        try{
            return {
                Actions: DataArr?.Action,
                ['Passenger Load']: DataArr['Passenger Load'],
                bIsScheduled: DataArr['bIsScheduled'],
                EstTimeFromPrev: DataArr['EstTimeFromPrev'],
                bPerformed: DataArr['bPerformed'],
                bWillCall: DataArr['bWillCall'],
                CDDOStopNo: DataArr['CDDOStopNo'],
                CDName: DataArr['CDName'],
                CDPUStopNo: DataArr['CDPUStopNo'],
                ClusterType: DataArr['ClusterType'],
                dEarlyTimeWindow: DataArr['dEarlyTimeWindow'],
                dEstimateDistance: DataArr['dEstimateDistance'],
                dEstimatedTime: DataArr['dEstimatedTime'],
                dLateTimeWindow: DataArr['dLateTimeWindow'],
                dLatitude: DataArr['dLatitude'],
                dLongitude: DataArr['dLongitude'],
                dtActualDrop: DataArr['dtActualDrop'],
                dtActualPickup: DataArr['dtActualPickup'],
                dtDriverLoc: DataArr['dtDriverLoc'],
                Eta: DataArr['Eta'],
                dtReqIRTPU: DataArr['dtReqIRTPU'],
                EstDistFromPrev: DataArr['EstDistFromPrev'],
                ForcastedPUTime: DataArr['ForcastedPUTime'],
                ['Funding Source']: DataArr['Funding Source'],
                iAffiliateID: DataArr['iAffiliateID'],
                IdleTime: DataArr['IdleTime'],
                iID_RouteGeneralSettings: DataArr['iID_RouteGeneralSettings'],
                Index: DataArr['Index'],
                iRouteID: DataArr['iRouteID'],
                iScheduleID: DataArr['iScheduleID'],
                iTotalPassengerCount: DataArr['iTotalPassengerCount'],
                iTotalWheelChairs: DataArr['iTotalWheelChairs'],
                iVehStopOrder: DataArr['iVehStopOrder'],
                ManifestNumber: DataArr['ManifestNumber'],
                PUPerson: DataArr['PUPerson'],
                ReqTime: DataArr['ReqTime'],
                ReqTimeHidden: DataArr['ReqTimeHidden'],
                Route: DataArr['Route'],
                SchDateTime: DataArr['SchDateTime'],
                SchTime: DataArr['SchTime'],
                ServiceRequestType: DataArr['ServiceRequestType'],
                ['Stop#']: DataArr['Stop#'],
                TripNo: DataArr['TripNo'],
                StopStatus: DataArr['StopStatus'],
                Type: DataArr['Type'],
                vAddress: DataArr['vAddress'],
                vColor: DataArr['vColor'],
                VehicleInfo: DataArr['VehicleInfo'],
                Violation: DataArr['Violation'],
                vManifestDisposition: DataArr['vManifestDisposition'],
                VType: DataArr['VType'],
                Zone: DataArr['Zone'],
            };
        }
        catch(err){console.log(err); return {};}
    }

    const triggerGetVehicles = useRef(false);

    useEffect(() => {
        const interval = setInterval(() => {
          try {
            if(triggerGetVehicles.current){
                GetVehicles();
            }
          } catch (error) {
            
          }
        }, 10000); // every 10 seconds
      
        return () => clearInterval(interval); // cleanup on unmount
      }, []);


    const GridLoadComplete = async () => {
        try {
            setTimeTakenByLastGridCall((new Date()) - APICom.LastGridCall);
            if (mapViewCheck.current) {
                if (DropDownRouteValue.current && DropDownRouteValue.current !== "") {
                    let DispatchGridData = mainTableObj.current.getData();
                    const singleMatchingRecord = DispatchGridData.find(item => item.Route === DropDownRouteValue.current);

                    if (singleMatchingRecord) {
                        if (singleMatchingRecord.Route !== "" && someThingChangedInGrid.current === false) {
                            await handleClusterManifestData(singleMatchingRecord, checkboxSelectionFlag.current)
                            someThingChangedInGrid.current = false;
                        }
                    }
                }
                if (selectedTripInfoToRefreshGrid.current !== null) {
                    if (selectedTripInfoToRefreshGrid.current.Route !== "" && someThingChangedInGrid.current === false) {
                        await handleClusterManifestData(selectedTripInfoToRefreshGrid.current, checkboxSelectionFlag.current)
                        triggerGetVehicles.current = true;
                    }
                    else if (selectedTripInfoToRefreshGrid.current.Route === "" || selectedTripInfoToRefreshGrid.current.Route === null) {
                        let autoDoubleClick = true;

                        triggerGetVehicles.current = true;
                        await GridRowDoubleClick(selectedTripInfoToRefreshGrid.current, autoDoubleClick);
                    }
                    else{
                        //alert("CALLED FOR VEHICLESZ");
                        let data = selectedTripInfoToRefreshGrid.current;
                        let iAssignedVehicleID = data.iAssignedVehicleId;
                        let _iServiceStatusID = data.iServiceStatusID;
                        let gridType = "";
                        let data1 = (gridType === '' ? mainTableObj.current.getData() : (gridType === 'complete' ? completedTableObj.current.getData() : []));
                        const filteredResults = (gridType === '' ? data1.filter(item => item.vManifestNumber === data.vManifestNumber) : data1.filter(item => item.ManifestNo === data.ManifestNo));
                        filteredResults.sort((a, b) => {
                            const timeA = new Date(a.PickupDateTime);
                            const timeB = new Date(b.PickupDateTime);
                            return timeA - timeB;
                        });
                        triggerGetVehicles.current = true;
                        GetAssignedVehiclesForTrip(selectedTripInfoToRefreshGrid.current,iAssignedVehicleID, _iServiceStatusID,filteredResults);
                    }
                }
            }
        }
        catch (err) { console.log(err); }
    };

    /***
     * This will be triggered each 10 seconds
     */
    const GetVehicles = async () => {
        try {
            if (mapViewCheck.current) {

                let data = selectedTripInfoToRefreshGrid.current;
                //if (data.Route === "" || data.Route === null) {
                    let autoDoubleClick = true;

                    //if(data?.Route != undefined){
                        let currentdate = DateTimeUtils.getCurrentDate();
                        if (RefSelectedDate.current === currentdate)
                        {
                            let iAssignedVehicleID = data.iAssignedVehicleId;
                            let _singleTripiServiceStatusID = data.iServiceStatusID;
                            if (iAssignedVehicleID && iAssignedVehicleID !== "" && iAssignedVehicleID != null && 
                                iAssignedVehicleID != -1 && iAssignedVehicleID != "-1" && 
                                iAssignedVehicleID != "0" && iAssignedVehicleID != "None-R"
                                    &&
                                    (
                                    _singleTripiServiceStatusID === "1" || 
                                    _singleTripiServiceStatusID === "2" ||
                                    _singleTripiServiceStatusID === "3")) 
                            {
                                await GetAssignedVehicleToTrip(data);
                            }
                            else if(tripType.current != "Routed-2") {
                                let RefID = data.iRefID;
                                await GetNearByVehicles(data, RefID);
                            }
                        }
                        else {
                            setVehData([]);
                            //setAssignedVehicleToTrip([]);
                        }
                    //}
                //}
            }
        } catch (error) {
            
        }
    }

    const AddBreakModalFunc = (starttime, dataArray) => {
        setAddBreakModal({
            isVisible: true,
            starttime: starttime.SchTime, // Pass the starttime to the modal
            tableData: dataArray,
            selectedRow: starttime
        });
    };

    const handleRowResize = (newHeight) => {
         
        setHeight(newHeight);
        setIsResizing(true);
    };

    const handleSaveChanges = () => {
        try {
            const time2 = routeStartTime;
            const date2 = new Date(`1970-01-01T${time2}:00`);
            if (modalActionType === 'adjustRouteStartTime') {

                let StopViewMainData = ClusterTableObject.current.getData();
                const time1 = StopViewMainData[0].SchTime;

                const date1 = new Date(`1970-01-01T${time1}:00`);
                // const date2 = new Date(`1970-01-01T${time2}:00`);
                let diffInMinutes = (date2.getTime() - date1.getTime()) / (1000 * 60);

                let originalDate = new Date(`1970-01-01T${StopViewMainData[0].SchTime}:00`);
                originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000);
                const newHours = originalDate.getHours().toString().padStart(2, '0');
                const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
                const newTime = `${newHours}:${newMinutes}`;

                ClusterTableObject.current.updateRow(StopViewMainData[0]['Index'], { SchTime: newTime });
            }
            else if (modalActionType === 'updateScheduleTime') {

                const allRowComponents = ClusterTableObject.current.getRows();


                // Find the selected row component using your custom Index value
                const selectedRowComponent = allRowComponents.find(
                    rowComponent => rowComponent.getData().Index === StopViewSelectedRowIndex
                );

                // Get the position of the selected row in the grid
                const selectedRowPosition = selectedRowComponent.getPosition();

                // Convert to 0-based index for JavaScript arrays
                const arrayIndex = selectedRowPosition - 1;

                // Get previous and next rows using the position

                // Function to find the previous valid row component (not "idletime")
                const findPreviousRow = (index) => {
                    for (let i = index - 1; i >= 0; i--) {
                        const rowData = allRowComponents[i]?.getData();
                        if (rowData?.Type !== "IdleTime") {
                            return allRowComponents[i];
                        }
                    }
                    return null; // No valid previous row found
                };

                // Function to find the next valid row component (not "idletime")
                const findNextRow = (index) => {
                    for (let i = index + 1; i < allRowComponents.length; i++) {
                        const rowData = allRowComponents[i]?.getData();
                        if (rowData?.Type !== "IdleTime") {
                            return allRowComponents[i];
                        }
                    }
                    return null; // No valid next row found
                };


                // Find the previous and next valid rows
                const previousRowComponent = findPreviousRow(arrayIndex);
                const nextRowComponent = findNextRow(arrayIndex);
                const selectedRowData = selectedRowComponent.getData();
                // Access data from the rows
                let currentRowSchTime = selectedRowData.SchTime || null;
                let previousRowSchTime = previousRowComponent?.getData().SchTime || null;
                let nextRowSchTime = nextRowComponent?.getData().SchTime || null;

                
                const time1 = currentRowSchTime;
                const date1 = new Date(`1970-01-01T${time1}:00`);
                // const date2 = new Date(`1970-01-01T${time2}:00`);
                let diffInMinutes = (date2.getTime() - date1.getTime()) / (1000 * 60);

                let originalDate = new Date(`1970-01-01T${time1}:00`);
                originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000);
                const newHours = originalDate.getHours().toString().padStart(2, '0');
                const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
                const newTime = `${newHours}:${newMinutes}`;


                // // Get the selected row and the update window
                // const selectedRow = ClusterTableObject.current.getData().find(row => row.Index === StopViewSelectedRowIndex);
                // const dUpdateSchWinMins = Math.round(selectedRow.dUpdateSchWinMins); // Round off the value

                let StopType = selectedRowData.Type;
                // // Get the ReqTime of the selected row
                // let reqTime = "00:00";

                // if(StopType.toLowerCase() === "pu"){
                //     reqTime = selectedRow.ReqTime;  // in time format like 13:12

                // }

                // else if(StopType.toLowerCase() === "do"){
                //     if (selectedRow && selectedRow.ReqTime && selectedRow.ReqTime.trim() !== ""){
                //         reqTime = selectedRow.ReqTime;
                //     }
                //     else{
                //     const selectedPURowPU = ClusterTableObject.current.getData().find(row => row.TripNo ===  SelectedRowRefID.current && row.Type.toLowerCase()=== 'pu');
                //     const reqTimePU= selectedPURowPU.ReqTime; // in time format like 13:12
                //     const dEstimatedTime = selectedPURowPU.dEstimatedTime; //in minutes like 45
                //     const ServiceTime = selectedPURowPU.ServiceTime; // in minutes like 15


                //     // Convert reqTimePU (which is in time format "HH:mm") to a Date object
                //     const [hours, minutes] = reqTimePU.split(":").map(Number);
                //     const date = new Date();
                //     date.setHours(hours, minutes);

                //     // Add dEstimatedTime and serviceTime (both in minutes)
                //     date.setMinutes(date.getMinutes() + dEstimatedTime + ServiceTime);

                //     // Format the new time in "HH:mm" format
                //     const formattedTime = date.toTimeString().slice(0, 5); // Extracts "HH:mm" part

                //     reqTime = formattedTime; // This will be in "HH:mm" format

                //     }


                // }


                // // Calculate the acceptable range using ReqTime and dUpdateSchWinMins
                // const lowerBound = new Date(`1970-01-01T${reqTime}:00`);
                // lowerBound.setMinutes(lowerBound.getMinutes() - dUpdateSchWinMins); // Subtract update window for lower bound

                // const upperBound = new Date(`1970-01-01T${reqTime}:00`);
                // upperBound.setMinutes(upperBound.getMinutes() + dUpdateSchWinMins); // Add update window for upper bound

                // // Format bounds for comparison
                // const lowerBoundTime = `${lowerBound.getHours().toString().padStart(2, '0')}:${lowerBound.getMinutes().toString().padStart(2, '0')}`;
                // const upperBoundTime = `${upperBound.getHours().toString().padStart(2, '0')}:${upperBound.getMinutes().toString().padStart(2, '0')}`;

                // Format time into AM/PM format
                const formatAMPM = (date) => {
                    let hours = date.getHours();
                    let minutes = date.getMinutes();
                    const ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    const strTime = `${hours}:${minutes} ${ampm}`;
                    return strTime;
                };

                const maxSchTime = new Date(`1970-01-01T${nextRowSchTime}:00`);
                const minSchTime = new Date(`1970-01-01T${previousRowSchTime}:00`);

                // Check if newTime is within the acceptable range
                if (newTime < previousRowSchTime || newTime > nextRowSchTime) {
                    setValidationError(true);
                    setErrorMessageUST(`Time should be between ${formatAMPM(minSchTime)} and ${formatAMPM(maxSchTime)}`);
                    return;
                }

                setValidationError(false);
                setErrorMessageUST('');

                const fromtime = new Date(`1970-01-01T${time1}:00`);
                const toTime = new Date(`1970-01-01T${newTime}:00`);

                HistoryReason.current = `${StopType} Schedule Time is updated manually from ${formatAMPM(fromtime)} to  ${formatAMPM(toTime)}`

                ClusterTableObject.current.updateData([{ Index: StopViewSelectedRowIndex, SchTime: newTime }]);
            }

            AdjustRouteTimes();
            setEditRouteTimeModal(false);
            // for (let i = 0; i < StopViewMainData.length; i++) {
            //     let originalDate = new Date(`1970-01-01T${StopViewMainData[i].SchTime}:00`);
            //     originalDate = new Date(originalDate.getTime() + diffInMinutes * 60000); 
            //     const newHours = originalDate.getHours().toString().padStart(2, '0');
            //     const newMinutes = originalDate.getMinutes().toString().padStart(2, '0');
            //     const newTime = `${newHours}:${newMinutes}`;

            //     if (StopViewMainData[i]['Type'] == "IdleTime") {
            //         let idleTime = StopViewMainData[i]['IdleTime'];
            //         let newIdleTime = idleTime - diffInMinutes; 

            //         if (newIdleTime > 0) {
            //             ClusterTableObject.current.updateRow(StopViewMainData[i]['Index'], {
            //                 IdleTime: newIdleTime,
            //                 SchTime: newTime
            //             });
            //             break;
            //         } else {
            //             ClusterTableObject.current.deleteRow(StopViewMainData[i]['Index']);
            //             diffInMinutes += newIdleTime;
            //         }
            //     } else {
            //         ClusterTableObject.current.updateRow(StopViewMainData[i]['Index'], {SchTime: newTime});
            //     }
            // }

            // ValidateRoute();
            // setTimeout(() => {
            //     setEditRouteTimeModal(false);
            // }, 1000);
        } catch (err) { console.log(err); }
    };

    const handleCancelUST = () => {
        setValidationError(false);
        setErrorMessageUST('');
        setEditRouteTimeModal(false);
    };

    const handleRouteAlertClose = () => {
        setAlert(false);
    };

    const handleRoutingAlertClose = () => {
        setRouteAlert(false);
    };

    const handleUberClose = () => {
        setShowExternalTripDispatch(false);
    };

    const handleSRProgressBar = () => {
        sethandlePageProgressBar("dispatch");
    };

    const stopViewGridLoadCallBack = useCallback(() => {
        try {
            StopViewGridLoad(_vManifestNumber.current, _iAffilaiteID.current)
        } catch (error) {

        }
    }, [_vManifestNumber.current, _iAffilaiteID.current])

    const handleDeletedTag = (deletedConfirmationNo) => {
         
        console.log("Tag deleted in grandchild:", deletedConfirmationNo);
        DispatchGridControlRef.current?.deselectRowById(deletedConfirmationNo);
        
    };


    const [voiceActionForDisaptchQ, setVoiceActionForDispatchQ] = useState("");
    const [voiceAction, setVoiceAction] = useState("")
    const handleVoiceAction = (action, data) => {
        setVoiceAction("");
       if (action === "PlotZonesOnMap"){
            setTimeout(() => {
                setVoiceAction(action);
            }, 3000);
        }
        else if(action === "UnPlotZonesFromMap"){
            setTimeout(() => {
                setVoiceAction(action);
            }, 3000);
        }
        else if(action === "ShowTripsByStatus"){
            
            if(data != undefined && data != null && data != ""){
                try {
                    DispatchGridControlRef.current?.setFilter("TripRequestStatus", "=", data);
                } catch (error) {}
            }
        }
        else if(action === "ClearFilters"){
            if(data != undefined && data != null && data != ""){
                try {
                    DispatchGridControlRef.current?.clearFilters();
                } catch (error) {}
            }
        }
      };
    const ARBResponseListenerMemo = useMemo(() =>
        <ARBResponseListener
            GridRefresh={PrepareGridRequest}
            showClusteringDialog={showClusteringDialog}
            handlePageProgressBar={handlePageProgressBar}
            setShowClusterDialog={setShowClusterDialog}
            setManifestBuildDialog={setManifestBuildDialog}
            setAlert={setAlert}
            setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
            setGridRefreshPaused={setGridRefreshPaused}
            StopViewGridLoad={stopViewGridLoadCallBack}
        // StopViewGridLoad={() => StopViewGridLoad(_vManifestNumber.current, _iAffilaiteID.current)}
        />,
        [showClusteringDialog, setShowClusterDialog,
            setManifestBuildDialog, setAlert,
            setRouteSuggestionActionCreate, setGridRefreshPaused,
            handlePageProgressBar, stopViewGridLoadCallBack]
    )


    const GridControlMemo = useMemo(() =>
        <GridControl setGroupingFilter={setGroupingHeaderFilter} rowColors={apiRowData} cellColors={apiColData} GridLoadComplete={GridLoadComplete}
            AddBreakModalFunc={AddBreakModalFunc} setColumnChooser={setShowColumnChooser} showColumnChooser={showColumnChooser} persistentRowsSel={tableSelRows}
            setPersistentRowSelection={setTableRowsSel} Data={[]} handleMapMode={setMapView} MapDetailData={MapDetailData}
            ReloadDataFunction={PrepareGridRequest} setSelectedRowData={GridRowSelect} GridRefreshPaused={GridRefreshPaused}

            UseInternalGridDataReloadFunction={true}
            ref={DispatchGridControlRef}
            options={DispatchGridControlOptions} ShowLoader={ShowGridLoader} GridRowDoubleClick={GridRowDoubleClick} selectedRoute={SelectedRoute} width={width + "%"}
        />,
        [apiRowData, apiColData]);

  const [confirmationModalObjTripActivationRefusal, setConfirmationModalObjTripActivationRefusal] = useState({
        show: false, title: 'Trip Activation',
        body: 'Please Select One Trip at a time.', btnCanceText: 'No',
        btnOkText: 'OK'
  });

  const handleConfirmationModalObjTripActivationRefusalCancel = () => {
        setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));
  };
  const handleConfirmationModalObjTripActivationRefusalOk = () => {
        setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));
  };
  const handleConfirmationModalObjTripActivationRefusalClose = () => {
            setConfirmationModalObjTripActivationRefusal((prevState) => ({ ...prevState, show: false}));

  };
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: DynamicsStyles }}>
            </style>
            {
                ARBResponseListenerMemo
            }
            {/* <ARBResponseListener GridRefresh={PrepareGridRequest} showClusteringDialog={showClusteringDialog} handlePageProgressBar={handlePageProgressBar}
                setShowClusterDialog={setShowClusterDialog} setManifestBuildDialog={setManifestBuildDialog} setAlert={setAlert} setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                setGridRefreshPaused={setGridRefreshPaused}
                StopViewGridLoad={() => StopViewGridLoad(_vManifestNumber.current, _iAffilaiteID.current)}
            /> */}
            <DispatchMainToolbar setNullifyActivated={setNullifyActivated} nullifyActivated={nullifyActivated}
                setDetailDataFunc={setClusterGridResponse} setSelectedRoute={handleSelectedRouteChange} setDropDownRoute={handleDropDownRouteChange}
                setSideBarStatus={setSidebarOpen} NetworkTimeTakenByLastGridCall={NetworkTimeTakenByLastGridCall}
                TimeTakenByLastGridCall={TimeTakenByLastGridCall} ToolBoxStateChange={ToolBoxStateChange}
                options={(gridMainType === 'Dispatch' ? DispatchGridControlOptions : (gridMainType === 'Standing' ? StandingOrderGridControlOptions : CompletedGridControlOptions))}
                setGroupingFilter={setGroupingHeaderFilter} handleMapMode={setMapView} initiateCancel={setShowMultiTripCancellationDialog} setDateRange = {setCompleteDateRange}
                setShowTripActionsDialog={handleTripActionsDialogueShowHide} setGridMainType={setGridMainType} initiateCallTaker = {showCallTaker}
                setDriverActionsDialog={setDriverActionsDialog} setShowClusterDialog={setShowClusterDialog} setShowGroupingActionDialog={setShowGroupingActionDialog}
                initiateActivate={setShowActivateDialog} initiateVehicleTracking={setShowVehicleTracking} initiateUpdateCallback={setShowUpdateCallback}
                setTripHistoryDialog={setTripHistoryDialog} setBrokerActionsDialog={setBrokerActionsDialog} initiateAgileDispatch={setShowAgileDispatch}
                setManifestBuildDialog={setManifestBuildDialog} setShowRoutesDialog={setShowRoutesDialog} setStandingRouteDialog={setStandingRouteDialog}
                setAgentNotesDialog={setAgentNotesDialog} GridRowData={selectRowData} setMTDiagnosticDialog={setMTDiagnosticDialog} setCallTakerDisp={setShowCallTaker}
                setRBSProcessDialog={setRBSProcessDialog} setCheckCompletedTrips={setShowCompletedTrips} mainSelectedRow={selectedTripInfo.current}
                handleClusterReload={handleClusterManifestData} setTripDetailsDialog={setTripDetailsDialog} selectedAffiliates={ToolboxValues.AffiliatesList}
                selectedDate={ToolboxValues.Date} selectedRoute={SelectedRoute} setSettings={setClusterGridColumnSetting} setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                handleMapHeight={handleRowResize} selectedTripInfoToRefreshGrid={selectedTripInfoToRefreshGrid} DropDownRouteValue={DropDownRouteValue}
                vehData={vehData} updateVehData={setVehData} isFromDoubleClick={MapViewFromDoubleClick} setIsFromDoubleClick={setMapViewFromDoubleClick}
                setGridRefreshPaused={setGridRefreshPaused}
                setIsMainMapOpened={setIsMainMapOpened}
                OnMapActions={handleVoiceAction}
                setShowTripActionsDialogForManifestNumber={handleShowTripsActionsForManifestNumber}
                showCompletedTrips={showCompletedTrips}
                setSelectedRowFromRouteDropDown = {setSelectedRowFromRouteDropDown}

            />

            
            {/* New Map Checking  
            ===========================================================*/}
            {/* <Row className='m-0' style={{ height: `calc(100vh - 132px)`, display: "flex",justifyContent: "flex-end", display: mapView ? 'flex' : 'none'}}>
                <MapControlDispatch></MapControlDispatch>
            </Row> */}
            {/* New Map Checking  
            ===========================================================*/}

            <Row className='m-0' style={{ height: `calc(100vh - 132px)` }}>
                {gridMainType === 'Dispatch' ? GridControlMemo : (gridMainType === 'Standing' ?
                    <GridControl
                        Data={standingOrderGridData} handleMapMode={setMapView} MapDetailData = {MapDetailData} 
                        ReloadDataFunction={(e)=>{console.log("refreshed")}} setSelectedRowData={GridRowSelect} GridRefreshPaused={GridRefreshPaused}
                        ref={SOGridControlRef} options={StandingOrderGridControlOptions} 
                        ShowLoader={ShowGridLoader} width={width +"%"} GridColumnSetting={StandingOrderGridColSetting} 
                    />    
                : <GridControl
                    setGroupingFilter={setGroupingHeaderFilterCompletedQ}
                    Data={completedQueueData} handleMapMode={setMapView} MapDetailData = {MapDetailData} 
                    ReloadDataFunction={(e)=>{console.log("refreshed")}} setSelectedRowData={GridRowSelect} GridRefreshPaused={GridRefreshPaused}
                    ref={CompletedQueueControlRef} options={CompletedGridControlOptions} 
                    ShowLoader={ShowGridLoader} width={width +"%"} GridColumnSetting={CompletedQueueColSetting} 
                    />
                )}
                {showCancel ? <CancelTrip GridRowData={selectRowData} showCancel={showCancel} setShowCancel={setShowCancel} gridType={gridMainType}/> : ""}
                {showMultiTripCancellationDialog && (<MultiTripCancellation GridRowData={selectRowData} selectedDate={ToolboxValues.Date} showMultiTripCancellationDialog={showMultiTripCancellationDialog} setShowMultiTripCancellationDialog={setShowMultiTripCancellationDialog} gridType={gridMainType} />)}
                {showBrokerCancelDialog && (
                    <BrokerCancelDialog 
                        show={showBrokerCancelDialog} 
                        onHide={() => setShowBrokerCancelDialog(false)} 
                        reasonsHtml={brokerCancelReasonsHtml} 
                        tripInfo={brokerCancelTripInfo}
                        onConfirm={handleBrokerCancelConfirmation} 
                    />
                )}

                <div
                    style={{
                        display: 'flex',
                        margin: '0',
                        background: '#32728b',
                        cursor: 'col-resize',
                        width: '5px',
                        padding: '0'
                    }}
                    draggable
                    onDrag={isFirefox.current ? undefined : horizontalDragHandler}
                    onDragEnd={isFirefox.current ? horizontalDragHandler : undefined}
                    className="col-1 flex justify-center items-center bg-slate-800 cursor-col-resize"
                >
                </div>
                <div className='col-5' style={{
                    padding: '0px', flex: '1',
                    //width: "100%",//sidebarOpen ? `calc(${100 - width - 10}% - 5px)` : `calc(${100 - width}% - 5px)`,
                    height: '99%',
                    display: mapView ? 'block' : 'none',
                }}>
                    <Row className='m-0' style={{ height: '100%' }}>
                    {/* <Row className='m-0' style={{ height: `calc(100vh - 132px)`, display: "flex",justifyContent: "flex-end", display: mapView ? 'flex' : 'flex'}}>  */}
                        <MapControlDispatch
                            selectedAffiliates={ToolboxValues.AffiliatesList} 
                            height={height + "%"}
                            handleMapHeight={handleRowResize}
                            options={(gridMainType === 'Dispatch' ? DispatchGridControlOptions : (gridMainType === 'Standing' ? StandingOrderGridControlOptions : CompletedGridControlOptions))}
                            gridType = {gridMainType}

                            vehData={vehData}
                            onShowVehiclesChange={handleShowVehiclesChange}
                            onDeletedTag={handleDeletedTag}
                            assignedVehicleToTrip={assignedVehicleToTrip}
                            onShowOccupiedVehiclesChange={handleShowOccupiedVehiclesChange}
                            IsCheckCompletedTrips={showCompletedTrips}
                            onShowCompletedTripsChange={handleShowCompletedTripChanges}
                            onShowVehicleDispatch={handleShowVehicleDispatch}
                            selectedDate={RefSelectedDate.current}
                            //routedTripFromDispatchQueue = {routedTripShow.current}
                            //routedTripFromDispatchQueue = {ClusterGridResponse}
                            selectedTripFromDispatchQueue={selectedTripFromDispatchQueue.current}
                            routedTripFromDispatchQueue={
                               { selectedStops: SelectedStopsData,
                                 clusterGrid: ClusterGridResponse
                               }}
                            // routedTripFromDispatchQueue={{
                            //     selectedStops: (SelectedStopsData || []).filter(stop =>
                            //       (ClusterGridResponse || []).some(cluster => cluster.Route === stop.Route)
                            //     ),
                            //     clusterGrid: ClusterGridResponse
                            //   }}
                            IsRoutedTrip={routedTrip}
                            DispatchVehicleData={DispatchVehicleData}
                            DispatchDriverData={DispatchDriverData}
                            GridRowData={selectRowData}
                            IsDispatchGridDoubleClickSelectionChange={doubleClickVersion}
                            TripType={tripType}
                            sidebarStatus={sidebarCheck.current}
                            clusterTableStateBeforeCompute={clusterTableStateBeforeCompute}
                            SelectedRoute={SelectedRoute}
                            voiceAction={voiceAction}
                            isCalledFromRouteDropDown={isCalledFromRouteDropDown.current}
                        >
                        </MapControlDispatch>
                    {/* </Row> */}

                         {/* <MapControl 
                         setNullifyActivated={setNullifyActivated} 
                         sidebarStatus={sidebarCheck.current}
                            clusterTripSelected={clusterTripSelection}
                             unroutedTrip={unroutedTripShow.current}
                              routedTrip={routedTripShow.current}
                            arrangedTripsClusterData={arrangedClusterTrips}
                             selectedTripInfoToRefreshGrid={selectedTripInfoToRefreshGrid}
                            selectedAffiliates={ToolboxValues.AffiliatesList} 
                            options={(gridMainType === 'Dispatch' ? DispatchGridControlOptions : (gridMainType === 'Standing' ? StandingOrderGridControlOptions : CompletedGridControlOptions))}
                            DropDownRouteValue={DropDownRouteValue}
                             gridType = {gridMainType}
                            zones={ZoneVerticesData.Table}
                             handleMapMode={setMapView}
                              selectedDate={ToolboxValues.Date}
                            GridRowData={selectRowData}
                             setDetailDataFunc={setClusterGridResponse} 
                             MapDetailData={ClusterGridResponse} 
                             vehData={vehData}
                            DispatchDriverData={DispatchDriverData}
                             DispatchVehicleData={DispatchVehicleData}
                              GridRefresh={PrepareGridRequest} height={height + "%"}
                            handleMapHeight={handleRowResize}
                             clusterTableStateBeforeCompute={clusterTableStateBeforeCompute}
                              SelectedStopsData={SelectedStopsData}
                            isGridRefreshed={someThingChangedInGrid.current} 
                            isFromDoubleClick={MapViewFromDoubleClick}
                             setIsFromDoubleClick={setMapViewFromDoubleClick}
                            IsCheckCompletedTrips={checkboxSelectionFlag.current}
                             setCheckCompletedTrips={setShowCompletedTrips}
                            TripType={tripType}
                             setShowOccupiedVehicles={setShowOccupiedVehicles}
                        />  */}
                        

                        <Row
                            style={{
                                display: isResizing ? 'flex' : 'none',
                                width: '100%',
                                margin: '0',
                                height: '5px',
                                cursor: 'row-resize',
                                background: '#32728b',
                                padding: '0'
                            }}
                            draggable
                            onDrag={isFirefox.current ? undefined : verticalDragHandler}
                            onDragEnd={isFirefox.current ? verticalDragHandler : undefined}
                            className="flex justify-center items-center h-1/6 bg-slate-800 cursor-col-resize"
                        >
                        </Row>
                        {
                            <GridControl setArrangedClusterTripsFunc={setArrangedClusterTripsFunc}
                                ShowLoader={ShowGridClusterLoader} MapDetailData={ClusterGridResponse} handleMapMode={setMapView} AddBreakModalFunc={AddBreakModalFunc}
                                Data={ClusterGridResponse} options={ClusterGridControlOptions} ReloadDataFunction={handleClusterGridResponse}
                                GridColumnSetting={ClusterGridColumnSetting}
                                height={(100 - height) + "%"} setRowMoveFlag={setRowMoveFlag}
                                isStopView={true}
                            />
                        }
                    </Row>
                </div>
            </Row>


            {showActivateDialog ? <ActivateTrip GridRowData={selectRowData} showActivateDialog={showActivateDialog} setShowActivateDialog={setShowActivateDialog} /> : ""}
            {showTripActionsDialog ? <TripActions triggerUnAssign={triggerUnAssign} setTriggerUnAssign={setTriggerUnAssign} GridRowData={selectRowData} showTripActionsDialog={showTripActionsDialog}
                setShowTripActionsDialog={setShowTripActionsDialog} ReloadDataFunction={PrepareGridRequest} setGridRefreshPaused={setGridRefreshPaused} /> : ""}
            {showDriverActionsDialog ? <DriverActionsDialog AffiliateIDList={ToolboxValues.AffiliatesList} GridRowData={selectRowData} gridType = {gridMainType} showDriverActionsDialog={showDriverActionsDialog} setDriverActionsDialog={setDriverActionsDialog} ReloadDataFunction={PrepareGridRequest} /> : ""}
            {showGroupingDialog ? <GroupingActions groupingSet={mainTableObj.current.getData('active')} GridRowData={selectRowData} showGroupingDialog={showGroupingDialog} setShowGroupingActionDialog={setShowGroupingActionDialog} GridRefresh={PrepareGridRequest} /> : ""}
            {showClusteringDialog ?
                <BuildCluster triggerUnRoute={triggerUnRoute} setTriggerUnRoute={setTriggerUnRoute} GridRowData={selectRowData} addTripRoute={route}
                    setAddtoRoute={setAddTripToRouteCluster} addtoRoute={addTripToRouteCluster} showClusteringDialog={showClusteringDialog}
                    setShowClusterDialog={setShowClusterDialog} GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}
                    setGridRefreshPaused={setGridRefreshPaused}
                />
                : ""}
            {showVehicleTracking ? <VehicleTracking GridRowData={selectRowData} gridType={gridMainType} showVehicleTracking={showVehicleTracking} setShowVehicleTracking={setShowVehicleTracking} /> : ""}
            {showUpdateCallback ? <UpdateCallback GridRowData={selectRowData} showUpdateCallback={showUpdateCallback} setShowUpdateCallback={setShowUpdateCallback} /> : ""}
            {showTripHistoryDialog ? <TripHistoryDialog GridRowData={selectRowData} gridType={gridMainType} showTripHistoryDialog={showTripHistoryDialog} setTripHistoryDialog={setTripHistoryDialog} /> : ""}
            {showBrokerActionsDialog ? <BrokerActionsDialog GridRowData={selectRowData} showBrokerActionsDialog={showBrokerActionsDialog} setBrokerActionsDialog={setBrokerActionsDialog}
                ReloadDataFunction={PrepareGridRequest} numOfTripsInRoute={numOfTripsInRoute} setGridRefreshPaused={setGridRefreshPaused} /> : ""}
            {showAgileDispatch ? <AgileDispatch UnMountFunction={UnMountAgileDispatch} GridRowData={selectRowData} showAgileDispatch={showAgileDispatch} setShowAgileDispatch={setShowAgileDispatch} ReloadDataFunction={PrepareGridRequest} /> : ""}
            {showModal ? <ConfirmationModal show={DispatchScreenModalProps.show} Title={DispatchScreenModalProps.Title} Body={DispatchScreenModalProps.Body} btnCanceText={DispatchScreenModalProps.btnCanceText} btnOkText={DispatchScreenModalProps.btnOkText} ShowCancelButton={DispatchScreenModalProps.ShowCancelButton} onOk={handleCloseModal} /> : ""}
            {showTripDetailsDialog ? <TripDetailsDialog GridRowData={selectRowData} showTripDetailsDialog={showTripDetailsDialog} gridType={gridMainType} setTripDetailsDialog={setTripDetailsDialog} /> : ""}
            {showManifestBuildDialog ?
                <BuildManifest triggerRouteSuggestion={triggerRouteSuggestion} settriggerRouteSuggestion={settriggerRouteSuggestion} triggerUnRoute={triggerUnRoute} setTriggerUnRoute={setTriggerUnRoute} GridRowData={selectRowData}
                    addTripRoute={route} setAddtoRoute={setAddTripToRoute} addtoRoute={addTripToRoute} showManifestBuildDialog={showManifestBuildDialog}
                    setManifestBuildDialog={setManifestBuildDialog} GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date} setRouteSuggestionActionCreate={setRouteSuggestionActionCreate}
                    selectedAffiliates={ToolboxValues.AffiliatesList} setGridRefreshPaused={setGridRefreshPaused}
                />
                : ""}


            {showRouteSuggestionActionCreate ? <RunRouteSuggestion GridRefresh={PrepareGridRequest} GridRowData={selectRowData} showRouteSuggestionActionCreate={showRouteSuggestionActionCreate}
                setRouteSuggestionActionCreate={setRouteSuggestionActionCreate} disbaleButton={setdisableAllButtons} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}
                setGridRefreshPaused={setGridRefreshPaused} /> : ""}


            {showRoutesDialog ?
                <ShowRoutes GridRowData={selectRowData} showRoutesDialog={showRoutesDialog} setShowRoutesDialog={setShowRoutesDialog}
                    GridRefresh={PrepareGridRequest} selectedAffiliates={ToolboxValues.AffiliatesList} selectedDate={ToolboxValues.Date}
                />
                : ""}
            {showRBSProcessDialog ?
                <RBSProcess GridRowData={selectRowData} showRBSProcessDialog={showRBSProcessDialog} setRBSProcessDialog={setRBSProcessDialog}
                    GridRefresh={PrepareGridRequest} selectedDate={ToolboxValues.Date} selectedAffiliates={ToolboxValues.AffiliatesList}
                />
                : ""}
            {showStandingRouteDialog ?
                <StandingRoutes selectedAffiliates={ToolboxValues.AffiliatesList} selectedDate={ToolboxValues.Date}
                    showStandingRouteDialog={showStandingRouteDialog} setStandingRouteDialog={setStandingRouteDialog} setSRProgressBar={handleSRProgressBar}
                />
                : ""}
            {showAddBreakModal.isVisible ? <AddBreakModal showAddBreakModal={showAddBreakModal} setAddBreakModal={setAddBreakModal} /> : ""}

            {showAgentNotesDialog ? <AgentNotesDialog GridRowData={selectRowData} showAgentNotesDialog={showAgentNotesDialog} setAgentNotesDialog={setAgentNotesDialog} /> : ""}
            {showDynamicModal ?
                <Modal centered backdrop="static" keyboard={true} onHide={() => setShowDynamicModal(false)} show={showDynamicModal} animation={true} dialogClassName={modalClassName}>
                    <Modal.Header className='activate_dialog_header_bgcolor user-select-none' closeButton>
                        <Modal.Title className='text-white'>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalBodyHTML}</Modal.Body>
                    <Modal.Footer>
                        {modalBtnHTML}
                    </Modal.Footer>
                </Modal>
                : ""}

            {sendEmailDict.showCustomerEmailRequest ?
                <Modal centered backdrop="static" keyboard={true} onHide={() => { setSendEmailDict({ showCustomerEmailRequest: false, customerTripData: {} }); }} show={sendEmailDict.showCustomerEmailRequest} animation={true}>
                    <Modal.Header className='activate_dialog_header_bgcolor user-select-none' closeButton>
                        <Modal.Title className='text-white'>{"Email Receipt"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            <p className='m-0 user-select-none fw-normal'>{"Confirmation No. "}<b>{sendEmailDict.customerTripData["Confirmation #"]}</b></p>
                            <span className='d-flex'>
                                <p className='m-0 user-select-none fw-normal'>{"Customer Email "}</p>
                                <input type="text" className='ms-2 callAgentInputStyle border-0 text-dark' 
                                    autoComplete='new_pass' value={customerEmail} onChange={(e)=>{setShowEmailAlert(""); setCustomerEmail(e.target.value);}}
                                />
                            </span>
                            {emailAlert !== "" ?
                                <p className='m-0 user-select-none fw-normal small text-danger'>{"Please enter the full email address before sending the email."}</p>
                                : ""}
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <>
                            <Button variant="dark" className="mx-1 border-0" onClick={() => {
                                if (customerEmail !== "" && customerEmail.length > 5 && customerEmail.includes("@")) {
                                    setSendEmailDict({ showCustomerEmailRequest: false, customerTripData: {} });
                                    SendEmailToCustomer(sendEmailDict.customerTripData);
                                }
                                else {
                                    setShowEmailAlert("No Email!");
                                }

                            }}
                            >
                                {"Send"}
                            </Button>
                            <Button variant="secondary" className="mx-1 border-0" onClick={()=>{setShowEmailAlert(""); setSendEmailDict({showCustomerEmailRequest:false, customerTripData:{}}); setCustomerEmail("");}}>
                                {"Cancel"}
                            </Button>
                        </>
                    </Modal.Footer>
                </Modal>
                : ""}

            {showMTDiagnosticDialog ?
                <MTDiagnostic showMTDiagnosticDialog={showMTDiagnosticDialog} setMTDiagnosticDialog={setMTDiagnosticDialog} selectedAffiliates={ToolboxValues.AffiliatesList} />
                : ""}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalClose}
                btnCancelText={confirmationModalObj.btnCancelText}
                btnOkText={confirmationModalObj.btnOkText} ShowCancelButton="false"
            />

            <Modal show={showEditRouteTimeModal ? 1 : 0} centered backdrop="static" animation={true} onHide={handleCancelUST} keyboard={true} size="md" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none'>
                        Edit Schedule Time
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="startTime">Stop Schedule Time</label>
                            <input type="time" className="form-control" id="startTime" value={routeStartTime} onChange={(e) => setRouteStartTime(e.target.value)} />
                        </div>
                        {validationError && (
                            <div className="form-group">
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    {errorMessageUST}
                                </span>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="activate_btn_ok border-0" onClick={handleSaveChanges}>Apply Changes</Button>
                    <Button className="activate_btn_ok border-0" onClick={handleCancelUST}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            {showAlert &&
                <Modal centered keyboard={false} show={showAlert} backdrop="static" animation={true} onHide={handleRouteAlertClose} >
                    <Modal.Header>
                        <Modal.Title>{routeObj.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{routeObj.alertMsg}</b></Modal.Body>
                    {routeObj.displayFooter ?
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleRouteAlertClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                        : ""}
                </Modal>
            }

            {showRouteAlert &&
                <Modal centered show={showRouteAlert} onHide={handleRoutingAlertClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleRoutingAlertClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
            
            {showDispatcRouteSummary ?
             <DispatchRouteSummary 
                routes={sampleRoutes}
                showDispatcRouteSummary={showDispatcRouteSummary}
                setShowDispatcRouteSummary={setShowDispatcRouteSummary}
                /> : "" }
            { showPrintManifestCriteria &&
             <PrintManifestCriteria
                selectedRow = {dispatchGridSelectedRow}
                selectedDate= {RefSelectedDate.current}
                selectedSettings_HideCostOnSDByFundingSource = {hideCostOnSDByFundingSource}
                showPrintManifestCriteria={showPrintManifestCriteria} setShowPrintManifestCriteria={setShowPrintManifestCriteria} 
            />

            }
            {showExternalTripDispatch &&
                    <Modal centered size="lg" show={showExternalTripDispatch} onHide={() => setShowExternalTripDispatch(false)} >
                    <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
                        <Modal.Title>{"External Dispatch "}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ExternalDispatch onClose={() => setShowExternalTripDispatch(false)}  
                            selectedRow = {selectRowData} 
                            thirdPartyAffiliateToSelect = {thirdPartyAffiliateToSelect}>
                        </ExternalDispatch>
                    </Modal.Body>
                    {/* <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowExternalTripDispatch(false)}>
                            Close
                        </Button>
                    </Modal.Footer> */}
                    </Modal>
}
            {/*
                <div   
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        zIndex: 10000,
                        height: "100vh",
                        transform: showExternalTripDispatch ? "translateX(0)" : "translateX(-100%)",
                        transition: "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)",
                        willChange: "transform",
                        width: "45%"
                    }}>
                <LeftPane isOpen={showExternalTripDispatch}>
                     <ExternalDispatch onClose={() => setShowExternalTripDispatch(false)}  selectedRow = {selectRowData} thirdPartyAffiliateToSelect = {thirdPartyAffiliateToSelect}></ExternalDispatch>
                </LeftPane>
             </div>
             */
            }
            <ConfirmationModal show={confirmationModalObjTripActivationRefusal.show} Title={confirmationModalObjTripActivationRefusal.title} Body={confirmationModalObjTripActivationRefusal.body}
                onOk={handleConfirmationModalObjTripActivationRefusalOk} onCancel={handleConfirmationModalObjTripActivationRefusalCancel} onClose={handleConfirmationModalObjTripActivationRefusalClose} btnCanceText={confirmationModalObjTripActivationRefusal.btnCanceText}
                btnOkText={confirmationModalObjTripActivationRefusal.btnOkText} ShowCancelButton="false" /> 
        </>
    );
};

export default DispatchComponent;
